/* eslint-disable */
/*
Purpose: displays images for a user, if specified, or images for all the current user follows. toggle grid vs list mode

Notes:
Like other RecyclingScrollView pages, the main data is loaded directly via fetch.
Keep in mind that there could be other copies of this screen in the navigation stack.
When in list (as opposed to grid) mode, there needs to be an api call to load the full Post details (10 at a time max)
This might best be accomplished with Sagas.
Note the visibility property, this need to be more sophisticated as we want all copies of this screen
on the navigationstack to show just pastel squares aside from the one that is on top.
This is to try and reduce the amount of memory used, and reduce the likelyhood of a crash.

Started work on making this a bit more generic, as it can be used in other places.
Overriding header and other functions will allow this code to work elsewhere.

https://github.com/Flipkart/recyclerlistview/tree/master/docs/guides/performance


Issue Reported To React Native Video:
https://github.com/react-native-community/react-native-video/issues/1120

### Current behavior
Using RecyclerListView with React Native Video, if you change the mute settings while scrolling, it frequently causes an iPhone to freeze for a second, and then resume scrolling.

### Reproduction steps
Have a scrolling list of videos that play the sound when they are the main visible video, other videos should be muted (they should stop playing video as well).  I'm using RecyclerListView.  Nothing fancy here, the onScroll function determines which video should be playing and if it's changed the screen's state is modified.  The state change, naturally, causes the screen's render function to be called and the video attributes are slightly altered reflecting the state.

### Expected behavior
Smooth, uninterrupted scrolling.

### Platform
I'm using iOS 11.2.6

Our internal notes:
React Native Video performance enhancement July 11, 2018, so far only tested on iOS.
XCode search for file RCTVideo.m, replace setMuted function:

- (void)setMuted:(BOOL)muted
{
  _muted = muted;
  // [self applyModifiers]; // this caused the 1 second delay when scrolling

  if (_muted) {
    [_player setVolume:0];
    [_player setMuted:YES];
  } else {
    [_player setVolume:_volume];
    [_player setMuted:NO];
  }
}

*/

import React, { Component } from "react"
import { NavigationActions, StackActions } from 'react-navigation'
//import OneSignal from 'react-native-onesignal'

// https://blog.callstack.io/reactnative-how-to-check-what-passes-through-your-bridge-e435571ffd85
/*
import MessageQueue from 'react-native/Libraries/BatchedBridge/MessageQueue.js'

const spyFunction = (msg) => {
  console.log(msg);
}
MessageQueue.spy(spyFunction)
*/

import { ImageBackground, Image,TouchableOpacity,View,ScrollView,Text,Modal,FlatList,ActivityIndicator
       , Dimensions,RefreshControl,Linking,ViewPropTypes,StatusBar,Animated,Alert,CameraRoll,StyleSheet
       , AppState, Easing, TextInput, Keyboard, Clipboard, Share, Platform
} from "react-native"
import { Button } from 'native-base'
import {WebView} from 'react-native-webview'

// import {CustomCachedImage} from "react-native-img-cache";
//import * as Animatable from 'react-native-animatable'
//import { ListItem, SearchBar } from "react-native-elements"
import { connect } from "react-redux"
import EventEmitter from 'EventEmitter'
import Video from "react-native-video"
import LottieView from 'lottie-react-native'
//import Orientation from 'react-native-orientation'
//import LinearGradient from 'react-native-linear-gradient'
//import MarqueeText from 'react-native-marquee'

import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview"
//import FastImage from 'react-native-fast-image' // https://github.com/DylanVann/react-native- fast-image
// this is fake fast image, does not support preload
// import FastImage from '../Components/FastImage'
//import { AppInstalledChecker, CheckPackageInstallation } from 'react-native-check-app-install';

import PostsActions from "../Redux/PostsRedux"
import CreatePostActions from "../Redux/CreatePostRedux"
import LoveActions from "../Redux/LoveRedux"
import OrderActions from "../Redux/OrderRedux"
import UserActions from "../Redux/UserRedux"

import BaseScreen from './BaseScreen'
import CustomMainNavBar from '../Components/CustomMainNavBar'
import MainNavBarScreen from './MainNavBarScreen'
import ActionSheetComponent from '../Components/ActionSheetComponent'
// import MessageComponent from '../Components/MessageComponent';
import MessageCacheComponent from '../Components/MessageCacheComponent';
// import FooterPostWall from '../Components/FooterPostWall';
import IconPostWallV2Component from '../Components/IconPostWallV2Component';
import CaptionComponent from '../Components/CaptionComponent';
//import LiveStreamTheySell from '../Components/LiveStreamTheySell'
//import ZoomableImage from '../Components/ZoomableImage'
import OverLayPostView from '../Components/OverLayPostView';
import FooterPostWall from '../Components/FooterPostWall';
import PopUpReportComponent from '../Components/PopUpReportComponent';
import CaptionOverlayComponent from '../Components/CaptionOverlayComponent';
import ImageAndText from '../Components/ImageAndText'
import { ImageRecycler } from '../Components/ImageRecycler'
//import { PostWallRow } from '../Components/PostWallRow'
//import { MessageCard } from '../Components/MessageCard'
//import { ShareDialog } from 'react-native-fbsdk'
import Marker from 'react-native-image-marker'
//import TwitterShare from '../Lib/TwitterShare'
//import TumblrShare from '../Lib/TumblrShare'
//import RNInstagramShare from 'react-native-instagram-share';
import ProgressBarAnimated from 'react-native-progress-bar-animated'
// import FadeView from "react-native-fade-view"
//import FadeView from '../Components/FadeView'
import AvatarComponent from '../Components/AvatarComponent'
import TextComponent from '../Components/TextComponent'
import PostViewComponent from '../Components/PostViewComponent'
//import TouchID from '../Lib/TouchId'
import { KargoeConfig } from '../Config/AppConfig'
import BadgeGenerator from '../Components/BadgeGenerator'
import AlertMessage from '../Components/AlertMessage'
import { ModalMessage, MoneyFaceMessage, ThumbsDownMessage } from '../Components/ModalMessage'
//import RotatingImage from '../Components/RotatingImage'
//import RNFS from 'react-native-fs'
//import NetInfo from "@react-native-community/netinfo"
//import ZoomableModalImage from '../Components/ZoomableModalImage'
//import Slider from '../Lib/react-native-slider/src/Slider'
//import VideoEfficientRender from '../Components/VideoEfficientRender'
//import ZoomableVideo from '../Components/ZoomableVideo'
//import LiveBroadcastScreen from '../Containers/LiveBroadcastScreen'
//import StreamShoppingView from '../Components/StreamShoppingView'
//import analytics from '@react-native-firebase/analytics'

import {
  isIPhoneX, deepClone, humanReadableNumber, objectDeepCopy,
  isURL, alertView, checkPrice, convertMessage,
  brief, convertTime, getAvatar, optionEditPost, optionRepost,
  showError, optionReport, getKeyByValue, optionType, optionTypeDynamic, getUri, getUriVideo, getUriNothumb, optionShare, convertPercentToPoint, isShoppableItemId,
  SaveToCache, ReadFromCache, initScreenDepth, calcScreenDepthState, markImageWithWatermark, localPrice, i18nCurrency, makeSureUserHasAgoraToken
} from '../Lib/utils'
import { postListToMosaicList } from '../Lib/mosaic'
//import SafariView from '../Lib/SafariView'
import NotificationManager from '../Lib/NotificationManager'

import { USER_KIND } from '../Constant';

// Styles
import styles from "./Styles/PostWallBaseStyle" // PostWallScreenStyle
import customMainNavBarStyles from "../Components/Styles/CustomMainNavBarStyle" // for status bar
import Colors from "../Themes/Colors"
import Images from "../Themes/Images"
import { Fonts } from '../Themes'
//import DonatePayPalComponent from "../Components/DonatePayPalComponent";
//import RNFetchBlob from 'react-native-fetch-blob'
import { NativeEventEmitter, NativeModules } from 'react-native'; // for catching camera events to lock/unlock scroll
import I18n from "i18n-js"
import AtTaggableInput from '../Components/AtTaggableInput'
import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'
import { KeyboardAvoidingView } from "react-native"
import { isNull } from "lodash-es"

const customMainNavBarStylesContent = StyleSheet.flatten(customMainNavBarStyles.content)
const customMainNavBarStylesStatusBar = StyleSheet.flatten(customMainNavBarStyles.statusBar)

const DEV_DIMENSIONS = Dimensions.get("window")

const MAX_AUTOPLAY_VID_TIME = 62 // seconds, if more than this, show play button and don't auto play

// https://github.com/Flipkart/ReactEssentials      recyclerlistview

let { width, height } = Dimensions.get("window")

let origScreenWidth = width

let screenWidth = width
const screenHeight = height

console.log("screenWidth = " + screenWidth + " screenHeight = " + screenHeight)

// change to let so it can be recomputed in constructor

let itemWidth = (width - 0) / 3
let itemHeight = itemWidth

const lottieSize = 140 // musical notes animation

// experimentally determined, dont play start or end of live stream saved because it could be black no signal
const streamVidCutIn = 2 // seconds from beginning
const streamVidCutOut = 6.5 // seconds from end

const ViewTypes = {
  GRID_LEFT: -1,
  GRID_MIDDLE: -2,
  GRID_RIGHT: -3,
  LIST_LANDSCAPE: 3,
  LIST_SQUARE: 4,
  LIST_PORTRAIT: 5,
}

const USE_WALL_DATA_CACHE = false
const GRID_MODE = 'grid'
const MOSAIC_MODE = 'mosaic'
const LIST_MODE = 'list'
const VID_MODE = 'vid'
const FULL_SCREEN_MODE = 'full'

const DONNATE = 'Donate'
const ISELL = 'ISell'
const THEYSELL = 'TheySell'

const ALL_TAG_HEIGHT = 50

const LIST_TOP_GAP   = customMainNavBarStylesContent.height + customMainNavBarStylesContent.borderBottomWidth + customMainNavBarStylesStatusBar.height // 60
const LIST_EXTRA_GAP = 153 // 162 // 84
const LIST_HEADER_HEIGHT = 55 // 50 // footer images = 44, footer caption and comments 54
const LIST_FOOTER_HEIGHT = LIST_EXTRA_GAP - LIST_HEADER_HEIGHT
const LIST_VIDEO_TOP_SLOP = LIST_HEADER_HEIGHT + 200 // 100 200 50
const LIST_VIDEO_BOTTOM_SLOP = LIST_FOOTER_HEIGHT + 200 // 100 200 50
const LIST_VIDEO_UPDATE_MILLISECONDS = 250

const SKIP_SHOP_IT_OVERLAY = true

const liveStreamCaption = 'be sure to watch my live stream!'

// slows things down only use if needed to debug a prod build w/ console
//const log = (str) => NotificationManager.postNotificationWithString("AppDelegate_printf", str)
const log = (str) => {}

// karoge cache init
// keep it outside the component or else it runs every time the component is instantiated

let kargoecacheGlobal = {}
let firstTimeWriteToKargoeCache = true

// this only happens once per app run
// set to if (false) if we dont want to use prior saved file cache, e.g. for testing

const kargoeWallCacheFile = /*RNFS.CachesDirectoryPath + */ '/wallcache.txt'

if (USE_WALL_DATA_CACHE) {
  let path = kargoeWallCacheFile
  //console.log("ready to read wall cache")
  let t1 = Date.now()
  if (false)
  RNFS.readFile(path, 'utf8').then(res => {
    console.log("just read wall cache from disk")
    kargoecacheGlobal = JSON.parse(res)
    let t2 = Date.now()
    console.log("did read the wall cache early, parse time = " + (t2-t1) + " keys = " + JSON.stringify(Object.keys(kargoecacheGlobal)))
  })
  .catch(e => {
    console.log("error reading wall cache " + JSON.stringify(e, null, 2))
  })
}

// end karoge cache init

class CaptionCommentView extends Component {
  constructor(args) {
    super(args)
    this.camComBlockIndex = 1 
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true
    const propsRecentComments = this.props.post.RecentComments ? this.props.post.RecentComments : []
    const nextPropsRecentComments = nextProps.post.RecentComments ? nextProps.post.RecentComments : []
    if (
      this.props.index != nextProps.index ||
      this.props.post.Modified != nextProps.post.Modified ||
      this.props.post.PostId != nextProps.post.PostId ||
      propsRecentComments.length != nextPropsRecentComments.length ||
      JSON.stringify(propsRecentComments) != JSON.stringify(nextPropsRecentComments)
    )
      return true
    return false
  }

  render = () => {
    //console.log("post wall base render 2 CaptionCommentView")
    const { post, index, navigation } = this.props
    this.moreButtonOn = this.props.moreButtonOn
    this.forceUpdate = this.props.forceUpdate
    this.onAvatarPress = this.props.onAvatarPress
    this.showPostView = this.props.showPostView
		// console.tron.display({ name: `PostWallBase`, preview :`CaptionCommentView, postId: ${post.PostId}`, value: { post } })
    const isFullScreen = false, screenLandscape = false, extraTextStyle = null, showFullContent = false
    const fullScreenWidthDelta = isFullScreen ? -20 : 0 // -6
    const width = isFullScreen && screenLandscape ? Math.max(screenWidth, screenHeight) - 50 + fullScreenWidthDelta : Math.min(screenWidth, screenHeight) + fullScreenWidthDelta
    const useTransparentBg = isFullScreen
    const textFontSize = isFullScreen ? 13 : 15
    const textLineHeight = isFullScreen ? 15 : 18
    const briefLines = isFullScreen ? 2 : 3
    const textColor = isFullScreen ? 'white' : 'black'
    const moreShadowColor = isFullScreen ? 'gray' : 'white'
    const textJustify = screenLandscape ? 'flex-end' : 'flex-start'
    let needsMoreBtn = false
    const meta = post.Meta
    // for live stream prototype we tell if a post is a live stream by a special caption
    const caption = post.Caption
    if (caption && caption.length > 126) { // last computed during prior render
      needsMoreBtn = true
    }
    // console.tron.log(`createCaptionCommentView needsMoreBtn: ${needsMoreBtn}`)
    let comments = typeof post.RecentComments != 'undefined' ? [...post.RecentComments] : [] // clone array and objects
    // console.log(`CaptionCommentView render comments: ` + JSON.stringify(comments))
    //console.log("AAA comments.length = " + comments.length + " caption = " + caption)
    if ((comments.length > 1 && caption) || comments.length > 2) needsMoreBtn = true
    if (!showFullContent)
      needsMoreBtn = false
    var commnetsWall = []
    if (comments.length || caption) {
      // comments.reverse()
      const haveCaption = caption // && post.Type == 0 // skip the hyperlink?
      if (haveCaption) {
        comments.unshift({
          TimeStamp: post.TimeStamp,
          UserId: post.UserId,
          Username: post.Username,
          Body: caption,
          IsCaption: true,
        })
      }

      commnetsWall = [...comments]

      commnetsWall.splice(3)
      const bgColors = ['#eee0ff', '#eeeeff', '#e0eeff']
      for (let i = 0; i < commnetsWall.length; i++) {
        let isCaption = haveCaption && i == 0
        // normal way, first item is caption, 3 lines
        let numLines = isCaption ? briefLines : 1
        let maxHeight = numLines * textLineHeight
        // if no caption and we are on the first line, give that comment 3 lines
        if (!haveCaption && i == 0) {
          numLines = briefLines
          maxHeight = briefLines * textLineHeight
        }
        commnetsWall[i] = Object.assign({
          key: "CL" + i, //  + post.PostId + "-" + comments[i].TimeStamp, // for FlatList
          NumLines: numLines,
          MaxHeight: maxHeight,
          isCaption,
          bgColor: 'transparent',
        }, commnetsWall[i])
      }
    }
    const heightOneTextLine = textLineHeight
    const emojiClipFix = 4 // points to bump down to avoid clipping emoji on top line
    const emojiClipFixOuter = 4

    // pile up more text to make shadow (white fadeout) more opaque since we have opacity all the way up, the system is making the fade too weak
    // if you change the styles of this, also change the styles of MORE... button to matc h
    const pileUpMoreButton = (<Text style={{ position: 'absolute', top: 0, left: 0, borderRadius: 5, shadowOffset: { width: 0, height: 0 }, shadowRadius : 6, shadowOpacity: 1, shadowColor: moreShadowColor, backgroundColor: moreShadowColor, padding: 0, margin: 0, width: 52, height: textLineHeight, lineHeight: textLineHeight, fontSize: 14, fontWeight: 'bold', color: textColor }}>...MORE</Text>)

    let containerStyle = {
      backgroundColor: useTransparentBg ? 'transparent' : '#ffffff',
      overflow: 'hidden',
      paddingLeft: useTransparentBg ? 0 : 14, 
      paddingRight: 14,
      top: -emojiClipFixOuter
    }
    if (!showFullContent) {
      containerStyle.height = briefLines * heightOneTextLine + 2*emojiClipFixOuter
      containerStyle.overflow = 'hidden'
    }

    let contents = (
      <>
      {commnetsWall.map((comment, index) => {
        const isFirstLine = (index === 0)
        const isLastLine  = (index === 2)
        const maxHeight   = showFullContent ? null : (comment.MaxHeight + (isFirstLine ? emojiClipFix : 0))
        const numLines    = showFullContent ? 100 : comment.NumLines
        const startWithUsername = !isFullScreen || !comment.isCaption
        return (
          <View key={`c` + index} style={{
            flexDirection: `row`,
            justifyContent: textJustify,
            backgroundColor: comment.bgColor
            }}
            onLayout={(e) => {
              const {x, y, width, height} = e.nativeEvent.layout
              //console.log("onLayout comment height = " + height + " " + JSON.stringify(comment, null, 2) + " nActualLines = " + height/heightOneTextLine)
              let nActualLines = height/heightOneTextLine
              //const priorNActualLines = comment.nActualLines
              //comment.nActualLines = nActualLines // will this work?
              // check the flags already set so we don't do a refresh unnecessarily (or infinite loop, which is worse)
              // console.log("comment.Body = " + comment.Body)
              if (!showFullContent && nActualLines > 2 && !needsMoreBtn && !this.moreButtonOn[post.PostId]) {
                //console.log('setting needs more button in caption for post ' + post.PostId)
                this.moreButtonOn[post.PostId] = true
                this.camComBlockIndex = this.camComBlockIndex + 1
                this.forceUpdate() // redraw to get the more button
              }
            }}
          >
            {true && 
            <Text style={[{lineHeight: textLineHeight, paddingTop: /*isFirstLine*/ true ? emojiClipFix/2 : 0, paddingBottom: isLastLine ? emojiClipFix : 0 }, extraTextStyle]} numberOfLines={numLines}>
              {startWithUsername && <Text style={[styles.userNameFooter, { fontFamily: Fonts.style.font.bold, fontWeight: (Platform.OS == 'web') ? 'bold' : 'normal', fontSize: textFontSize, maxHeight, backgroundColor: comment.bgColor, color: textColor, paddingTop: /*isFirstLine*/ true ? emojiClipFix/2 : 0, paddingBottom: isLastLine ? emojiClipFix : 0 }, extraTextStyle]}
                onPress={() => this.onAvatarPress(comment.UserId, comment.Username)}>
                {`${comment.Username} `}
              </Text>}
              {convertMessage({
                item: comment.Body, // rgb(119, 119, 119)
                styles: { text: [{ fontFamily: Fonts.style.font.regular, fontSize: textFontSize, color: 'black', lineHeight: textLineHeight }, extraTextStyle], wrap: [{ lineHeight: textLineHeight, fontSize: textFontSize, color: textColor }, extraTextStyle] },
                numLines,
                navigation
              }, () => {
              })}
            </Text>}
           
          </View>
        )
      })}
      {(isFullScreen && (needsMoreBtn || this.moreButtonOn[post.PostId])) && <View  style={{position: 'absolute', top: briefLines * textLineHeight - textLineHeight, right: 0, width: 20, height: textLineHeight + emojiClipFix*2 + 10 }}>
          <Text style={[extraTextStyle, {color: 'white', fontSize: textLineHeight, textAlign: 'right'}]}>{showFullContent ? `-` : `+`}</Text>
      </View>}
      {(!isFullScreen && (needsMoreBtn || this.moreButtonOn[post.PostId])) && <View  style={{position: 'absolute', top: briefLines * textLineHeight - textLineHeight, left: width-72-14, width: 20 + 10, height: textLineHeight + emojiClipFix*2 + 10 }}>
        <View style={{ width: 20, height: textLineHeight + emojiClipFix/2, padding: 0, paddingTop: 0, margin: 10 }} resizeMode="cover" source={Images.moreGradient} />
      </View>}
      {(!isFullScreen && (needsMoreBtn || this.moreButtonOn[post.PostId])) && <View  style={{position: 'absolute', top: briefLines * textLineHeight - textLineHeight + emojiClipFix, left: width-52-14, width: 52 + 20 , height: textLineHeight + emojiClipFix*2 + 20 }}>
        <Text style={{ borderRadius: 5, shadowOffset: { width: 0, height: 0 }, shadowRadius : 6, shadowOpacity: 1, shadowColor: 'white', backgroundColor: 'white', padding: 0, margin: 0, width: 52, height: textLineHeight, lineHeight: textLineHeight, fontSize: 14, fontWeight: 'bold', color: textColor }}>...MORE</Text>
        {pileUpMoreButton}
        {pileUpMoreButton}
        {pileUpMoreButton}
        {pileUpMoreButton}
        {pileUpMoreButton}
      </View>}
      </>
    )

    // https://stackoverflow.com/questions/7944460/detect-safari-browser
    let isSafari = false

    if (Platform.OS == 'web')
      isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!isSafari && Platform.OS == 'web') contents = null // some crashing issue on chrome & firefox have to find it

    if (isFullScreen)
      return (
        <View key = {'capComBlockV' + post.PostId + this.camComBlockIndex} style={containerStyle}>
          {contents}
        </View>
      )
    else {
      
      return (
        <TouchableOpacity
          key={'capComBlock' + post.PostId + this.camComBlockIndex}
          onPress={( ) => this.showPostView(post,'Comments')}
          style={containerStyle}>
          {contents}
        </TouchableOpacity>
      )
      }
  }
} // CaptionCommentView


/***
 * To test out just copy this component and render in you root component
 */


export default class PostWallBase extends Component {
  // make the flag static so only once per app run or we leak huge memory
  static registeredForPushNotifications = false
  static eventEmitter = false
	static firstRefreshAfterLaunch = false
	static firstRender = true // first render after construtor, try something more efficient for faster first view
  static preloadedImageUrls = {}

  constructor(args) {
    super(args)
    // console.tron.log("PostWallBase constructor")
    console.tron.display({
      name: `PostWallBase`,
      preview :`constructor props and args`,
      value: {
        props: this.props,
        args: args,
      }
    })

    this.adjustWidthForWeb = () => {
      // test for web 
      if (typeof window.mainViewWidthFraction != 'undefined' && window.mainViewWidthFraction < 1) {
        width = origScreenWidth * window.mainViewWidthFraction
        screenWidth = width

        itemWidth = (width - 0) / 3 - 4
        itemHeight = itemWidth
        
        console.log('reset item width to ' + itemWidth)
      }
    }
    
    this.adjustWidthForWeb()

    let switchFromUserId = null, switchToUserId = null, switchPostHints = null
    if (this.props && this.props.navigation && this.props.navigation.state && this.props.navigation.state.params) {
      switchFromuserId = this.props.navigation.state.params.switchFromUserId
      switchToUserId = this.props.navigation.state.params.switchToUserId
      switchPostHints = this.props.navigation.state.params.switchPostHints
    }

    // sometimes getting a not defined here going to explora screen, web, do differently above to check
    //const { switchFromUserId = null, switchToUserId = null, switchPostHints = null } = this.props.navigation.state.params

    console.log(`PostWallBase nav params: ` + JSON.stringify(this.props.navigation.state.params))
    this.switchFromUserId = switchFromUserId
    this.switchToUserId   = switchToUserId
    this.switchPostHints = switchPostHints
    this.switchNeedsCall = !!switchToUserId

    // note:  this.focused is for post wall BASE
    // derived classes such as ProfileWallV2Screen may have a this.state.focused
    this.focused = false // focus/blur listeners will set/clear this

    // used by shouldComponentUpdate
    this.lastShouldComponentUpdateTime = 0
    this.lastShouldComponentUpdateScrollY = 0

    // move to state:  this.jumpToIndex = 0 // ordinary operation not jumping

    //console.log("**** post wall base constructor")

    this.kargoeIsConnected = true // assume yes to start

    /*
    NetInfo.fetch().then(state => {
      //console.log("wall Connection type", state.type);
      //console.log("wall Is connected?", state.isConnected);
      this.kargoeIsConnected = state.isConnected
    })
    */

    // Subscribe to network info service (online or offline?  this should tell us)
    // dont forgot to unsubscribe or else...mem leak

    /*
    this.unsubscribeNetInfo = NetInfo.addEventListener(state => {
      //console.log("wall connection state changed!")
      //console.log("wall Connection type", state.type);
      //console.log("wall Is connected?", state.isConnected);
      this.kargoeIsConnected = state.isConnected
    });
    */

    // use the same cache for all walls and re-use it if wall is destroyed and re-created as does happen
    // note, this is separate from apisauce cache in API.js due to different XHR data access in this file
    this.kargoecache = kargoecacheGlobal

    // for use with xhr as in post wall base
    // in this case, params are part of url, not in separate object
    // note:  stores to mem but doesnt reload from file on launch yet
    this.storeResponseTextToCache = (url, responseText) => {
      let path = kargoeWallCacheFile
      if (USE_WALL_DATA_CACHE && responseText) {
          let key = url
          //console.log("storing wall cache key of " + key)
          // ref:  could do MD5 of key for more obscurity

          // if we have gotten to a store operation it means we got a good network connection
          // in this case, the first time of app exe, clear the prior cache so it doesnt build up over time

          if (firstTimeWriteToKargoeCache) {
            console.log('*** clearing wall cache')
            kargoecacheGlobal = {} // clear the pointer shared between wall instantiations
            this.kargoecache = kargoecacheGlobal // use this pointer in this instance of the wall
            firstTimeWriteToKargoeCache = false
          }

          // new cache update Feb 2021 store to in mem data cache but don't write
          // to file each time, wait for app to go to background (for bridge traffic jam speedup)

          this.kargoecache[key] = responseText

          //console.log("ready to write cache with keys " + JSON.stringify(Object.keys(this.kargoecache)))
          // this happens once per api call
          // move to a function which is called when app goes to background to avoid
          // bogging down the RN bridge during active user time
          // see below
          // this doesnt handle if app crashes of course
          // but if app is killed when in the background, should be ok

          /*
          let t1 = Date.now()
          let toWrite = JSON.stringify(this.kargoecache)
          console.log("wall cache size is now " + toWrite.length);
          RNFS.writeFile(path, toWrite, 'utf8').then(resp => {
             console.log("write wall cache ok time = " + (Date.now() - t1))
          })
          .catch(error => {
            console.log("error writing wall cache file " + JSON.stringify(error, null, 2))
          })
          */

          // do it again each API to have fresh cache at least for testing (Mar 9 2021)
          // this.writeWallCacheToFile()

          //console.log("past write wall cache")
      }
      //else console.log("skip wall cache write, responseText is empty")
    }

    this.writeWallCacheToFile = () => {
      
      let path = kargoeWallCacheFile
      let t1 = Date.now()
      let toWrite = JSON.stringify(this.kargoecache)
      console.log("wall cache size is now " + toWrite.length);
      if (false)
      RNFS.writeFile(path, toWrite, 'utf8').then(resp => {
          console.log("write wall cache ok time = " + (Date.now() - t1))
      })
      .catch(error => {
        console.log("error writing wall cache file " + JSON.stringify(error, null, 2))
      })

    }

    // for use w/ xhr as in post wall base
    this.getResponseTextFromCache = (url) => {
      //console.log('in get response text from cache, this.kargoecache = ' + this.kargoecache)
      //console.log('wall keys = ' + JSON.stringify(Object.keys(this.kargoecache), null, 2))
      //console.log('url = ' + url)
      let x = this.kargoecache[url]
      //console.log("got wall cache response text len = " + x.length)
      return x
    }
    if (!PostWallBase.registeredForPushNotifications) {
      console.log('registering for one signal push notifs')
      //OneSignal.registerForPushNotifications() // this does the popup alert for user permissions
      PostWallBase.registeredForPushNotifications = true
    }
    this.fundMeHidden = false
    this.fundMeWidth = null // onLayout={(event) => { this.fundMeWidth = event.nativeEvent.layout.width }}
    this.fundMeSummaryRight = new Animated.Value(0)
    this.alertCount = 0 // number of times the "after QR code" alert is displayed
    this.scrollYAnimatedValue = new Animated.Value(0);
    this.otherProfileAnimatedValue = new Animated.Value(0);
    this.animatedMultiplier = new Animated.Value(5)
		this.buttonsFadeInOut = new Animated.Value(1)
		this.fsDetailFadeInOut = new Animated.Value(1)
		this.fsDetailFadeInOutTimer = null
		this.fsDetailState = 'showing'
    this.fsMusicPostIndex = -1
    this.musicNotesAnimationView = null
    this.lastFinishedRefresh = 0 // prevent rapid refreshes from showing the 100th post as the start instead of the 1st
    this.backgroundStart = 0
		this.checkedVisibility = false
		this.loveLayoutFromEvent = null
    //Create the data provider and provide method which takes in two rows of data and return if those two are different or not.
    //THIS IS VERY IMPORTANT, FORGET PERFORMANCE IF THIS IS MESSED UP
    let dataProvider = new DataProvider((r1, r2) => {
      const changed =
        (r1.PostId != r2.PostId) ||
        (typeof r1.NumViews != typeof r2.NumViews) || // has extended info
        (typeof r1.NumLikes != 'undefined' && r1.NumLikes != r2.NumLikes)
      return changed
    })
    let dataProviderFullScreen = new DataProvider((r1, r2) => {
      const changed =
        (r1.PostId != r2.PostId) ||
        (typeof r1.NumViews != typeof r2.NumViews) || // has extended info
        (typeof r1.NumLikes != 'undefined' && r1.NumLikes != r2.NumLikes)
      return changed
    })
    let dataProviderMosaic = new DataProvider((r1, r2) => {
      const changed = (r1.hash != r2.hash)
      return changed
    })
    //       (index) => { return this.state.dataProvider._data[index]['PostId'] }
/*
    let vidDataProvider = new DataProvider((r1, r2) => {
      const changed =
        (r1.PostId != r2.PostId) ||
        (typeof r1.NumViews != typeof r2.NumViews) || // has extended info
        (typeof r1.NumLikes != 'undefined' && r1.NumLikes != r2.NumLikes)
      return changed
    })
*/
    let optionRepost = [
      I18n.t('editpost.repost'), I18n.t('editpost.messageKargoe'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'), I18n.t('editpost.report')
    ]

    if (false)
    this.dismissSubscription = SafariView.addEventListener(
      "onDismiss",
      () => {
        StatusBar.setHidden(false)
        StatusBar.setBarStyle("default", true);
      }
    );
    //Create the layout provider
    //First method: Given an index return the type of item e.g ListItemType1, ListItemType2 in case you have variety of items in your list/grid
    //Second: Given a type and object set the exact height and width for that type on given object, if you're using non deterministic rendering provide close estimates
    //If you need data based check you can access your data provider here
    //You'll need data in most cases, we don't provide it by default to enable things like data virtualization in the future
    //NOTE: For complex lists LayoutProvider will also be complex it would then make sense to move it to a different file
    this._layoutProviderGrid = new LayoutProvider(
      index => {
        const data = this.state.dataProvider._data
        if (index < data.length && typeof data[index]['Header'] != 'undefined')
          return 'HEADER'
        // ************* TODO - offset index
        if (index % 3 === 0) {
          return ViewTypes.GRID_LEFT
        } else if (index % 3 === 1) {
          return ViewTypes.GRID_MIDDLE
        } else {
          return ViewTypes.GRID_RIGHT
        }
      },
      (type, dim) => {
        if (type == 'HEADER') {
          dim.width = screenWidth
          dim.height = this.headerRowHeight
        }
        else {

          dim.width = itemWidth
          dim.height = itemWidth
          //console.info("layout provider grid width = " + dim.width)

        }
      }
    )
    this._layoutProviderMosaic = new LayoutProvider(
      index => {
        const data = this.state.dataProviderMosaic._data // array of mosaics, not posts
        return index < data.length ? data[index].type : -1
      },
      (type, dim, index) => {
        const data = this.state.dataProviderMosaic._data

        // may not get set up soon enough: window.mainViewWidthFraction
        // if we hard code it, will not work properly for narrow screens hmm

        let factor = window.mainViewWidthFraction ? window.mainViewWidthFraction : 1

        if (type == 'HEADER') {
          dim.width = screenWidth 
          dim.height = this.headerRowHeight * factor
        }
        else {
          dim.width  = screenWidth 
          dim.height = index < data.length ? data[index].mosaicHeight * factor : 10
        }

      }
    )

    this._layoutProviderFullScreenPortrait = new LayoutProvider(
      index => {
        // const data = this.state.dataProviderFullScreen._data // array of video posts, not all posts
        return 'FS_PORTRAIT'
      },
      (type, dim, index) => {
        let screenDim = Dimensions.get('window'); // screen Dimensions.get("window")
                                                                
        if (Platform.OS == 'web') {
          screenDim.width = screenWidth
          screenDim.height = screenHeight
        }

				dim.kargoeKind = 'portrait'
        dim.width  = Math.min(screenDim.width, screenDim.height)
        dim.height = Math.max(screenDim.width, screenDim.height)
        // console.tron.log(`layoutProviderFullScreen index ${index}, dim: ${JSON.stringify(dim)}`)
      }
    )
    this._layoutProviderFullScreenLandscape = new LayoutProvider(
      index => {
        // const data = this.state.dataProviderFullScreen._data // array of video posts, not all posts
        return 'FS_LANDSCAPE'
      },
      (type, dim, index) => {
        let screenDim = Dimensions.get('window');

        if (Platform.OS == 'web') {
          screenDim.width = screenWidth
          screenDim.height = screenHeight
        }

				dim.kargoeKind = 'landscape'
        dim.width  = Math.max(screenDim.width, screenDim.height)
        dim.height = Math.min(screenDim.width, screenDim.height)
        // console.tron.log(`layoutProviderFullScreen index ${index}, dim: ${JSON.stringify(dim)}`)
      }
    )

    if (!this.props.options.useNewLayoutProvider) {
      console.log("use new layout provider!!!")
      this._layoutProviderList = new LayoutProvider(
        index => {
          console.log("list layout provider index = " + index)
          return parseFloat(this.state.dataProvider._data[index]['AspectRatio'])
        },
        (type, dim) => {
          dim.width = screenWidth
          dim.height = Math.round(screenWidth / type) + LIST_EXTRA_GAP // aspect ratio
          if (dim.height == 0) dim.height = 1
          console.log("basic layout list dim.width dim.height = " + dim.width + " " + dim.height)
        }
      )
      console.log("made new layoutProviderList = " + this._layoutProviderList)
    }
    else
      this._layoutProviderList = new LayoutProvider(
        index => {
          const data = this.state.dataProvider._data
          // return 'POST' // this.state.dataProvider._data[index]['MediaType'] == 'JPEG' ? 'IMAGE' : 'VIDEO'
          return index < data.length && typeof data[index]['Header'] != 'undefined' ? 'HEADER' : 'POST'
        },
        (type, dim, index) => {
          if (type == 'HEADER') {
            dim.width = screenWidth
            dim.height = this.headerRowHeight
            if (dim.height == 0) dim.height = 1
            //console.log("list layout dim for header = " + JSON.stringify(dim))
          }
          else {
            const data = this.state.dataProvider._data
            const aspectRatio = index < data.length ? parseFloat(data[index]['AspectRatio']) : 1
            const topGap = this.HomeWall && index == 0 ? LIST_TOP_GAP : 0
            let entryHeight = this.state.dataProvider._data.length === 1
                                ? screenHeight*1.5
                                : (Math.round(screenWidth / aspectRatio) + LIST_EXTRA_GAP) + topGap

            dim.width = screenWidth
            dim.height = entryHeight
            if (dim.height == 0) dim.height = 1
            if (isNaN(dim.height)) dim.height = 1

            //console.log("index = " + index + " list layout dim = " + JSON.stringify(dim))
            //console.tron.log(`layoutProviderList type: ${type}, index: ${index}, ratio: ${aspectRatio} dim: ` + JSON.stringify(dim))
          }
        }
      )
/*
    this._layoutProviderVid = new LayoutProvider(
      index => parseFloat(this.state.vidDataProvider._data[index]['AspectRatio'])
    , (type, dim) => {
        dim.width = width
        dim.height = Math.round( width / type ) + LIST_EXTRA_GAP
    })
*/
    const userId = this.getScreenUserId()

    const username = this.props.navigation.state.params && this.props.navigation.state.params.username ? this.props.navigation.state.params.username : ''
    const { setParams } = this.props.navigation
    if (username)
      setParams({ title: username })

    this._rowRendererGrid = this._rowRendererGrid.bind(this)
    this._rowRendererMosaic = this._rowRendererMosaic.bind(this)
    this._rowRendererList = this._rowRendererList.bind(this)
		this._rowRendererFullScreen = this._rowRendererFullScreen.bind(this)
    this._renderPostThumb = this._renderPostThumb.bind(this)
//    this._rowRendererVid = this._rowRendererVid.bind(this)
    this._loadMoreData = this._loadMoreData.bind(this)
    this._loadMoreDataProcess = this._loadMoreDataProcess.bind(this)
    // this._loadMoreVidData = this._loadMoreVidData.bind(this)
    this._onRefresh = this._onRefresh.bind(this)
    this._indexesChanged = this._indexesChanged.bind(this)
    this._indexesChangedFullScreen = this._indexesChangedFullScreen.bind(this)
    this._onPressBack = this._onPressBack.bind(this)
    this._onScroll = this._onScroll.bind(this)
    this._onScrollFullScreen = this._onScrollFullScreen.bind(this)
    this._playVisibleVideo = this._playVisibleVideo.bind(this)
    this._onScrollThumbs = this._onScrollThumbs.bind(this)
    this.onSoundToggle = this.onSoundToggle.bind(this)
    this.setVideoReference = this.setVideoReference.bind(this)
    this.onSettingsClick = this.onSettingsClick.bind(this)
    this.onBadgeShareClick = this.onBadgeShareClick.bind(this)

    this.headerRowRender = this.headerRowRender.bind(this)
    this.profileLayout = this.profileLayout.bind(this)
    this.getUserProfileView = this.getUserProfileView.bind(this)
    this.getFollowView = this.getFollowView.bind(this)
    this.getBlockUserView = this.getBlockUserView.bind(this)
    this.singleScrollToFirstImage = this.singleScrollToFirstImage.bind(this)
    this.scrollModeToIndex = this.scrollModeToIndex.bind(this)
    this.yesPerformBlock = this.yesPerformBlock.bind(this)
    this.actionSheetPress = this.actionSheetPress.bind(this)
    this.onTagPress = this.onTagPress.bind(this)
    this.gotoOrderConfirmation = this.gotoOrderConfirmation.bind(this)
    this.gotoShoppableVariant = this.gotoShoppableVariant.bind(this)
    this.clearAlertMessage = this.clearAlertMessage.bind(this)
    this.clearErrorMessage = this.clearErrorMessage.bind(this)

    this.setSong  = this.setSong.bind(this)
    this.clearSong  = this.clearSong.bind(this)
    this.muteSound  = this.muteSound.bind(this)
    this.unmuteSound = this.unmuteSound.bind(this)
		this.mergePost = this.mergePost.bind(this)
		
		this.fullScreenUpdateVideoProgress = this.fullScreenUpdateVideoProgress.bind(this)
		// for add comment
		this.api = DebugConfig.useFixtures ? FixtureAPI : API.create()
    this.api.setAuthorization(this.props.auth.token)

    this.requestedPreflightItemId = null
    this.noPostsTimeout = null
		this.loveTimeout = null
		this.fullScreenScrollLockTimeout = null
    // this.scrollY = -1000
    this.scroll = {
      inScrollCheck: false,
      lastChecked: 0,
			lastOffsetY: -1,
			lastOffsetX: -1,
      currOffsetY: -1,
      video: {
        rowIndex: -1,
      },
      lastScrollCheckY: -1
    }
    this.currentSong = null

    this.alert = null
    this.headerRowHeight = 0
    this.gridScrollView = null
    this.mosaicScrollView = null
    this.listScrollView = null
    // this.vidScrollView = null
    this.scrollToNextTime = 0
    this.lastReadPostOptions = null
    // this.refVideo = [] // not currently used
    this.refs = []
    this.currentVisibleIndexes = []
    // this.visibleRowsHaveVideos = false
    this.userNames = {} // cache to display usernames before post extended details comes through
    // failed test to see if we could get love icon changing faster
    this.instantPostLove = {
      Modified: Date.now(),
      PostId: null,
      Love: false,
    }
    this.lastPreflight = this.props.order.modified // TEST so we know when to flip from tag over to Order Confirmation Screen
    this.fullScreenVideoRef = []
		this.fullScreenStartIndex = 0
		this.fullScreenPostIdTags = null
		this.currentFullScreenPostIndex = null
    this.fullScreenLandscapeProgress = null
    this.fullScreenPortraitProgress = null
		this.orientation = 'unknown'

    // for LIST_MODE, so we can scroll down a little bit and just see the image beneath the transparent navigation
    this.HomeWall = 'PostWallV2Screen' == this.constructor.name
    const fakeFirstRow = {
      PostId: 0,
      AspectRatio: 4/3,
    }
    const fakeDataList = [fakeFirstRow]
    let fakeDataListProfile = [{"PostId":-1,"NumViews":0,"Header":true,"ListHeight":240}]

    // if profile wall, first post seeded from main wall post list for faster first draw, less white screen time
    const firstItem = this.props.navigation.state.params && this.props.navigation.state.params.firstItem || null

    console.log("profile firstItem = " + JSON.stringify(firstItem, null, 2))

    if (firstItem) fakeDataListProfile.push(firstItem)

    if (!this.HomeWall) { // in case we have a fake list, refresh after a moment
      setTimeout(() => {
        this._onRefresh()
      }, 100)
    }

    //console.log("fake data list has now item count = " + fakeDataListProfile.length)

    //Since component should always render once data has changed, make data provider part of the state
    this.state = {
      isPostWall: args.navigation.state.routeName || "",
      isMyProfile: args.isMyProfile ? args.isMyProfile : false,
      hasNewPost: false,
      isUserFollow: true, // null,
      isProfile: args.isProfile ? args.isProfile : false,
      viewMode:  GRID_MODE, /*args.initialMode ? args.initialMode : */ /*GRID_MODE,*/ // LIST_MODE GRID_MODE
      thenOpenPostView: args.thenOpenPostView, // if true we should open the post view after scrolling to a post; only works if we have an initialPostId
      commentTimeStamp: args.commentTimeStamp, // optional time stamp of comment to scroll to (zero if no nop)
      dataProvider: this.HomeWall ? dataProvider.cloneWithRows(fakeDataList) : dataProvider.cloneWithRows(fakeDataListProfile),
      dataProviderMosaic: dataProviderMosaic,
      dataProviderFullScreen: dataProviderFullScreen,
      // vidDataProvider: vidDataProvider,
      itemWidth: itemWidth,
      itemHeight: itemWidth,
      authUserId: this.props.auth.user.UserId,
      userId: userId,
      username: username,
      profileUser: {
        UserId: userId,
        Username: username != '' ? username : this.props.auth.user.Username,
        complete: false,
      },
      tagPop: new Animated.Value(0),
      haveProfileUser: false,
      start: null,
      // vidStart : null,
      data: [],
      // vidData: [],
      page: 1,
      seed: 1,
      error: null,
      refreshing: false,
      refreshCount: 0,
      calledAPI: 0,
      havePosts: null,
      renderPlaceholderOnly: true,
      indexScroll: -1, // args.initialRow ? args.initialRow : -1,
      vidIndexScroll: -1,
      preflightPostId: -1,
      preflightItemId: -1,
      postdetailsModified: this.props.postdetails.modified,
      postdetailsIntegrated: null,
      loveModified: 0, // this.props.love.modified,
      showKargoeTagsPostId: null,
      hideKargoeDotsPostId: null,
      currVideoPlayIndex: 0, // was -1 if we set to -1 at start, have to bump the scroll a bit with touch to get first vid to play (on cold start)
      currLongVideoPlayIndex: -1,
      currFullScreenVideoPlayIndex: 0,
      // muted: false, // true,
      actionOptions: optionRepost,
      showNewPostBtn: true, // 333ms to show/hide, show when stopped, not scrolling
      showPostCaptionIndex: null,
      currentPostCaption: null,
      forceUpdate: 0,
      networkOffline : false,
      postId: this.props.navigation.state.params && this.props.navigation.state.params.postId || null,
      camIsScroll : true, // true = scroll to cam has been enabled
      mounted : false,
      postViewDefaultTab : 'Comments',
      scrollEnabled : true,
      animatedLove: false,
      animatedOriginX: 0,
      animatedOriginY: 0,
      auxLoading: false, // e.g. firing up instagram
      alertMessage: '',
      errorMessage: '',
      modalLargeAvatarOn: false,
      jumpToIndex: -1, // set to row index of the row we want to jump to on list view, before doing a scrollTo:  0 = ordinary operaiton not jumping
                     // prevents rendering extraneous rows during the jump (long white screen time)
      lastJumpToIndex: -1, // not used any more, do the thumb->full image transition in low level iOS for smoothness
      recyclerListKey: 0, // increment this to force re-render the "large wall" list view
      overlayPostViewKey: 0, // increment this to force re-render the bottom overlay on home wall
      camComBlockIndex: 0,
      landscape: false,
      videoKeyBump: 0,
      videoVolume: 1, // normally 1 for wall display, set to 0 instead of muting totally when we go landscape so user can ctrl it
      appState: null, // dont know yet
      fullScreenURI: null,
      fullScreenImageAR: 1, // aspect ratio of full screen image so we dont have to wait for it later (from getting image dimensions)
      prelimZoomScale: 1,
      dynamicSong: null, // e.g. if changed from within video player due to full screen swiping to next

      fullScreenPaused: false,
      fullScreenAutoAdvance: true,
      fullScreenDetailMode: null,
			fullScreenVideoProgress: 0,
			fullScreenProgressDragging: false,
			newComment: '',
			fsInnerScrolling: false,
			fsCapComScrollHeights: [],
			fsViewingSinglePost : false,
			showSwitchUserView: false,
			showAddProfileView: false,
      switchingUserInProgress: false,
      showSwitchingUsersScreen: false,
      update: null,
      isPostBroadcasting : {}, // key = postId, value = true or false
      streamFullScreenPost: null,
      streamFullScreenMode: '',
      videoPlaybackAllowed: PostWallBase.firstRefreshAfterLaunch, // stop looping cached post problem on startup
      shoppingFromLiveStream : null, // string if set
      hideLiveStreamCloseButton: false, // need to hide this if we are in a modal within live screen view
      currentlyPlayingVideoProgress : 0,
      twoCircleCommentPopup : false,
      twoCircleCommentPopupPost: null,
      recordOn : false,
      playOn : false,
      voiceLevel: 1.0,
      selectMedia: false // web select
		}
    this.streamKeyboardHeight = 0
    this.streamRandomHeartsTimeout = null
    this.streamLastPostIdLoved = null
    this.lastVisiblePostId = null
    this.videoDurationByPostId = {}
		this.newCommentPostId = null
		this.fsLoadingCommentsPostId = null

    // subscribe to events from camera like lock main side swipe or not
    const { CameraEventManager } = NativeModules;
    // move to static, create only once to avoid mem leak, but add listener for this instance (see below)
    //const eventEmitter = new NativeEventEmitter(CameraEventManager);
    // access the static variable in the base class because we instantiate subclasses of this base class
    if (!PostWallBase.eventEmitter) PostWallBase.eventEmitter = new NativeEventEmitter(CameraEventManager)
    // this is working, whew (at least it is getting called from RNCameraManager.m)
    const onEventFromCam = (event) => {
          if (!this.state.mounted) return // cannot setState on unmounted component, silent fail (shows exception in chrome debugger)
          const flag = event.scrollEnabled === "1" ? true : false
          this.setState({ camIsScroll: flag })
    }
    // access the one
    this.camEventSubscription = PostWallBase.eventEmitter.addListener('lockMainAppScroll', onEventFromCam.bind(this));

    initScreenDepth(this, args)
    this.inLoadMoreData = false
    // this.inLoadMoreVidData = false
    this.lastModeScrollIndex = null
    this.pressedTagDetails = null
    this.initialRow = args.initialRow ? args.initialRow : -1 // call in ComponentDidUpdate or row draw will happen before data loaded
    this.initialPostId = args.initialPostId ? args.initialPostId : null // call in ComponentDidUpdate or row draw will happen before data loaded
    this.delayedInitialRow = args.delayedInitialRow ? args.delayedInitialRow : -1 // in case we have fake MiniPost records without real aspect ratios
    // https://colinramsay.co.uk/2015/07/04/react-native-eventemitters.html
    // this.emitter = new EventEmitter()
    // this.emitter.on('SCROLLTO_EVENT', this.scrollToEvent);
    this.scrolling = false
		this.scrollWatcher = null
		this.fullScreenIsFollowing = {}
		//this.pollingRefresh = null
		this.songDetails = null
		this.preloadSongDetails = null
		
		// handle returning from portrait locked screens back to the new Full Screen mode that handles both landscape/portrait
    this.willFocusListener = this.props.navigation.addListener('willFocus', () => {
			if (this.state.viewMode == FULL_SCREEN_MODE) {
				//Orientation.unlockAllOrientations()
				this.setState({fullScreenPaused: false}) // video playback continues
				const postIndex = this.currentFullScreenPostIndex
				const postData  = this.state.dataProviderFullScreen.getAllData()
				let songDetails = {}
				if (postIndex < postData.length) {
					const newPlayPost = postData[postIndex]
					if (newPlayPost)
						songDetails = newPlayPost.Song
				}
				// set song details and unmute
				const music = Object.assign({}, this.props.musicSettings, {songDetails, muted: false})
				this.props.changeIndex({music})
			}
		})
		this.didBlurListener = this.props.navigation.addListener('didBlur', () => {
			//Orientation.lockToPortrait()
			if (this.state.viewMode == FULL_SCREEN_MODE) {
				this.setState({fullScreenPaused: true}) // video playback paused
				this.muteSound() // stop music playback
			}
      this.clearSong()
      this.setState({currVideoPlayIndex: -1})
		})

    // if this works, can remove similar in edit post screen
    // dont have auth yet so can't call this here, what?
    // do in will recv props instead
    // makeSureUserHasAgoraToken(this.props.auth) // from utils.js

    this.checkedAgoraTokensForUsername = false // so we only do it once (put the auth that you checked for)

  }

  static clearDataCache() {
     console.log('new function external call clear data cache post wall base')
     kargoecacheGlobal = {}
     firstTimeWriteToKargoeCache = true
  }

  getScreenUserId() {
    return null
  }

  // can be called w/ (null, fullScreenVid as boolean)
  orientationDidChange(orientation, fullScreenVid) {

        if (!this.kargoeIsConnected) return // dont mess w/ this if we are not connected, giant red screens show up

        if (Date.now() - this.lastOrientationChangeTime < 10) { // 1000 not a problem for standard video...

           // if you're going to tumble like a clown, dont try to track it, full screen video player crashes the whole app
           // with giant red screen if we change state too often

           return
        }

        this.lastOrientationChangeTime = Date.now()

				//console.log(`orientationDidChange orientation: ${orientation}`)
				this.orientation = orientation

				this.fullScreenStartIndex = this.state.currFullScreenVideoPlayIndex // switching keeps us on same row
				setTimeout(() => this.setState({landscape: orientation === 'LANDSCAPE'}), 50)
				// this.setState({landscape: orientation === 'LANDSCAPE'})
        return
/*
        if (orientation === 'LANDSCAPE') {
          this.setState(
            {landscape: true},
            setTimeout(() => this.changeMode(FULL_SCREEN_MODE), 50)
            )
          return
        }
*/        

        // landscape
        if (orientation === 'LANDSCAPE' || fullScreenVid) {
          // unmute but turn down the volume so user can control volume on landscape
          // if we leave it muted, react fights w/ the user's controlling it
          this.setState({landscape: true, muted: false /*, videoVolume: 0.1*/}) // if we leave muted, cannot control volume on popup player

          if (this.currentlyPlayingVideo) {
            // first focused is post wall base, 2nd focused is profile wall v2 screen
            console.log("this.focused = " + this.focused + " this.state.focused = " + this.state.focused)
            if ((this.focused || this.state.focused) && this.props.swiperIndex > 0 && !this.currentlyPlayingVideoIsTilt) {
              console.log("should show full screen video")

              if (!this.currentlyPlayingVideoFullscreen && this.currentlyPlayingVideo.mounted && !this.videoInTransition) {
                this.currentlyPlayingVideo.presentFullscreenPlayer()
                console.log("full screen vid saving scroll position " + this.scrollOffsetY)
                this.presentedFullScreenAtOffsetY = this.scrollOffsetY
              }
              else {
                console.log("but NOT showing full screen video because:")
                console.log("this.currentlyPlayingVideoFullscreen = " + this.currentlyPlayingVideoFullscreen)
                console.log("this.currentlyPlayingVideo.mounted = " + this.currentlyPlayingVideo.mounted)
                console.log("this.videoInTransition = " + this.videoInTransition)
              }
              this.currentlyPlayingVideoFullscreen = true
            }
          }

       }
       else { // portrait

          this.setState({landscape: false, muted: true, videoVolume: 1})
          if (this.currentlyPlayingVideo && !this.videoInTransition) {

            if (this.currentlyPlayingVideoFullscreen) {

              console.log("setting landscape false, should dismiss full screen player loc 1 currentlyPlayingVideo = " + this.currentlyPlayingVideo)

              this.currentlyPlayingVideo.dismissFullscreenPlayer()
              //if (this.listScrollView) {
                setTimeout(() => {
                  if (true || !this.videoInTransition) {

                    // check again for list scroll view since this is delayed
                    if (this.listScrollView) {
                      // DEBUG console.log("should scroll to prior position")
                      // console.log("skipping scroll to prior position")

                      // DEBUG
                      this.listScrollView.scrollToOffset(0, this.presentedFullScreenAtOffsetY, false)

                      this.currentlyPlayingVideo.setNativeProps({paused: false});

                    }
                    else console.log("cannot scroll to offset, no list scroll view")

                  } else console.log("we think video is in transition, don't scroll to prior")
                  }, 100)
              //}
              //else console.log("caution, no this.listScrollView, can't scroll back")
              this.currentlyPlayingVideoFullscreen = false
            }
            setTimeout(() => {
              // make sure this is still set or crash
              // if (this.currentlyPlayingVideo)
                // feb 4 2020 AM:
                // try to remove to reduce flicker:  this.setState({videoKeyBump : this.state.videoKeyBump + 1}) // force re-render vids so they play if needed
                // but if we remove, will video still be playing?
              }, 50) // make sure video keeps playing by forcing a redraw
          }
       }
  }

  shouldComponentUpdate(nextProps, nextState) {

    //console.log("nextProps = " + JSON.stringify(nextProps))
    //console.log("nextState = " + JSON.stringify(nextState))

    return true // dont do this yet, some items were missing sometimes such as usernames on posts

    // how far scroll view has moved since we last got here
    const scrollDelta = this.lastShouldComponentUpdateScrollY - this.scrollOffsetY

    this.lastShouldComponentUpdateScrollY = this.scrollOffsetY
    
    let delta = Date.now() - this.lastShouldComponentUpdateTime

    this.lastShouldComponentUpdateTime = Date.now()

    // console.log("should component update at " + this.lastShouldComponentUpdateTime)

    if (delta < 100 && scrollDelta != 0) {
       //console.log("skipping render during scrolling, too soon time delta = " + delta + " scrollDelta = " + scrollDelta);
       return false
    }
    else return true // if not scrolling, on scrollDelta = 0 will trigger re-render
  }

  componentDidMount( ) {
    //Orientation.addOrientationListener(this.orientationDidChange.bind(this))
    //Orientation.lockToPortrait()
    // Orientation.unlockAllOrientations()
    // this isnt going to work because sub class post wall v2 screen defines this handler, it must not allow more than one
    this.focusListener = this.props.navigation.addListener('didFocus', () => {
      console.log("didFocus pwb");
      this.focused = true
      const currentVisibleIndexes = this.currentVisibleIndexes.length > 0 ? this.currentVisibleIndexes : []

      console.log("on focus, current visible indexes = " +  JSON.stringify(currentVisibleIndexes))

      // if this is a <-- back from post view (e.g. adding a comment), even though the wall
      // scroll position is correct, its currently visible indexes go bad for some reason,
      // so force ourselves to the proper post and then the indices get updated
      if (this.postViewPriorOffsetY /*typeof this.postViewPost !== 'undefined'*/) {
        /*
        console.log("should scroll to post " + JSON.stringify(this.postViewPost, null, 2))
        this.scrollToPost(this.postViewPost)
        delete this.postViewPost
        */
       console.log("should scroll to scroll position " + this.postViewPriorOffsetY)
       this.listScrollView.scrollToOffset(0, this.postViewPriorOffsetY, true)
       delete this.postViewPriorOffsetY
      }

    })
    // if we are going to blur, tell us we are not focused first
    this.blurListener = this.props.navigation.addListener('willBlur', () => {console.log("didBlur pwb"); this.clearSong(); this.focused = false})

    // this is out in orig version pre web dont put it in for web
    //if (this.loveAnimation)
    //  this.loveAnimation.play()
    this.state.mounted = true
    if (this.props.getUnreadMessage)
      this.props.getUnreadMessage( )

    if (this.props.navigation.state.params && this.props.navigation.state.params.isNewPost) {
      this.setState({
        viewMode: LIST_MODE
      })
    }

    //this.pollingRefresh = setInterval( this._onRefresh, 60000 )
    if (this.state.isMyProfile)
      this.scrollWatcher = setInterval(() => {
        const now = Date.now()
        // const scrolling = (now - this.scroll.lastChecked) < 100
        const scrolling = this.scroll.currOffsetY != this.scroll.lastScrollCheckY
        this.scroll.lastScrollCheckY = this.scroll.currOffsetY
        if (scrolling && !this.scrolling) {
          this.scrolling = true
          this.setState({ showNewPostBtn: false })
        }
        else if (!scrolling && this.scrolling) {
          this.scrolling = false
          this.setState({ showNewPostBtn: true })
        }
      }, 250)

    AppState.addEventListener('change', this.handleAppStateChange)

    // force initial data load ---> this make the view can not scroll to post when go to profile or dicovery detail or from happening

    // this.setState({ data : [ ], vidData: [ ] }, ( ) => {
    //   this._loadMoreData ( )
    //   var vidTarget = '', wallTarget = ''
    //   if( this.HomeWall ) {
    //     vidTarget = 'homeVidData'
    //     wallTarget = 'homeWallData'
    //   } else if( this.state.userId ) { // profile
    //     vidTarget = `profileVidData-${this.state.userId}`
    //     wallTarget = `profileWallData-${this.state.userId}`
    //   } else {
    //     vidTarget = 'uknownVidData'
    //     wallTarget = 'unknownWallData'
    //   }
    //   ReadFromCache ( vidTarget )
    //   .then(data => {
    //     if( this.state.vidData.length === 0 ) {
    //       let obj = JSON.parse(data)
    //       this.setState({ vidStart: obj.vidStart, vidData: obj.vidData
    //                     , vidDataProvider: this.state.vidDataProvider.cloneWithRows(obj.vidData)
    //                     , error: null, refreshing: false, calledAPI: true, hasNewPost: false
    //                     })
    //     }
    //   }).catch(console.log)
    //   ReadFromCache ( wallTarget )
    //   .then(data => {
    //     if( this.state.data.length === 0 ) {
    //       let obj = JSON.parse(data)
    //       this.setState({ data : obj.data, start : obj.start
    //                     , dataProvider : this.state.dataProvider.cloneWithRows(obj.data)
    //                     , error : null, refreshing : false, calledAPI : true, hasNewPost : false
    //                   })
    //     }
    //   }).catch(console.log)
		// })
    this.keyboardIsShowing = false
		//this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow)
		//this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide)
  }

  componentWillMount() {
    // https://github.com/kmend/react-native-eventemitter
    // EventEmitter.on('SCROLLTO_EVENT', this.scrollToEvent); // not a function
  }

  componentWillUnmount() {
    this.state.mounted = false
		//this.dismissSubscription.remove()
		this.fullScreenClearDetailFadeTimer()
    if (this.loveTimeout) { clearTimeout(this.loveTimeout) }
		if (this.noPostsTimeout) { clearTimeout(this.noPostsTimeout) }
		if (this.fullScreenScrollLockTimeout) { clearTimeout(this.fullScreenScrollLockTimeout) }
    if (this.scrollWatcher) { clearInterval(this.scrollWatcher) }
    clearInterval(this.unreadTimeout)
    //clearInterval(this.pollingRefresh)
    //this.camEventSubscription.remove() do this like below instead for mem leak fix trial
    //PostWallBase.eventEmitter.removeAllListeners('lockMainAppScroll')
    //PostWallBase.eventEmitter = null
    // EventEmitter.removeListener('SCROLLTO_EVENT', this.scrollToEvent);

    // https://github.com/react-native-community/react-native-netinfo
    // unusual way of unsubscribing from netinfo, see above link
    //    this.unsubscribeNetInfo()

    if (this.focusListener) this.focusListener.remove()
    if (this.blurListener) this.blurListener.remove()

    this.focusListener = null
    this.blurListener = null

    if (this.xhrRequests)
      this.xhrRequests.forEach((item, index) => {
        console.log("abort xhr request if it exists " + item)
        if (item) item.abort()
      })
    // this might not work because of the bind, need to check
    //Orientation.removeOrientationListener(this.orientationDidChange.bind(this))
    //Orientation.lockToPortrait()
    AppState.removeEventListener('change', this.handleAppStateChange);

		this.clearSong()
		this.willFocusListener.remove()
    this.didBlurListener.remove()
		//this.keyboardDidShowListener.remove()
		//this.keyboardDidHideListener.remove()

    if (this.streamRandomHeartsTimeout)
      clearTimeout(this.streamRandomHeartsTimeout)
    this.streamRandomHeartsTimeout = null

    this.stopFakeAudioWave()
    
	}

  isMuted = () => {
    // return this.props.musicSettings.muted // this.state.muted
    return this.props.muted
  }

  muteSound = () => {
    // console.tron.log(`postWallBase music muteSound`)
    const music = Object.assign({}, this.props.musicSettings, {muted: true})
    this.props.changeIndex({music})
  }

  unmuteSound = () => {
    // console.tron.log(`postWallBase music unmuteSound`)
    const music = Object.assign({}, this.props.musicSettings, {muted: false})
    this.props.changeIndex({music})
  }

  clearSong = () => {
    this.setSong({}, `clearSong`)
  }

  setSong = (songDetails, callerName) => {
    if (!this.state.videoPlaybackAllowed)
      return
    if (this.props.options.pauseSongPlayback) {
      console.tron.log(`postWallBase music setSong aborted due to settings`)
      return
    }
    if (songDetails === undefined || songDetails === '')
      songDetails = {}
		const currentSongId = this.state.dynamicSong ? this.state.dynamicSong.id : null
		const newSongId = songDetails ? songDetails.id : null
    if (currentSongId == newSongId)
      return
    console.log(`postWallBase music setSong (from ${callerName}) ` + JSON.stringify(songDetails))
    const music = Object.assign({}, this.props.musicSettings, {songDetails})
    this.props.changeIndex({music})
    this.setState({dynamicSong : songDetails})
  }

  preloadSong = (songDetails, callerName) => {
		console.log(`postWallBase music preloadSong (from ${callerName}) ` + JSON.stringify(songDetails))
		const oldPreloadSongId = this.preloadSongDetails ? this.preloadSongDetails.id : null
		const preloadSongId = songDetails ? songDetails.id : null
		if (preloadSongId && preloadSongId != oldPreloadSongId) {
			console.log(`postWallBase music preloadSong2 (from ${callerName}) ` + JSON.stringify(songDetails))
			this.preloadSongDetails = songDetails
			const preloadMusic = {songDetails}
			this.props.changeIndex({preloadMusic})
		}
  }

  onSoundToggle() {
    console.tron.log(`onSoundToggle`)
    const newMuteState = !this.isMuted()
    if (newMuteState)
      this.muteSound()
    else
      this.unmuteSound()
/*
    this.setState({ muted: newMuteState }, () => {
      if (!newMuteState) {
        this.unmuteSound()
      }
      else
        this.muteSound()
    })
*/
  }

  handleAppStateChange = (nextAppState) => {
    console.log(`handleAppStateChange, this.state.appState ${this.state.appState} nextAppState ${nextAppState}`)
    if (nextAppState === 'active') {
      console.log('handleAppStateChange App has come to the foreground!')
      const now = Date.now()
      const fiveMinutes = 300000 // 5 * 60 * 1000
      const backgroundDuration = now - this.backgroundStart
      const briefBackgrounding = backgroundDuration < fiveMinutes // eg: GoeFundMe donation via Paypal on Safari
      if (!briefBackgrounding) {
        console.log(`PostWallBase handleAppStateChange calling _onRefresh, backgroundDuration ${backgroundDuration}`)
        this._onRefresh()
      }
      const postId = this.props.order.postId
      if (postId) {
        console.log(`handleAppStateChange App has come to the foreground - refreshing tagDetails for PostId ${postId}`)
        setTimeout(() => { this.props.tagDetails(postId) }, 1000)
      }
    }
    else if (nextAppState === 'background') {
       this.backgroundStart = Date.now()
       console.log("handleAppStateChange post wall base detected that app is going to the background")
       this.writeWallCacheToFile()
    }
    this.setState({appState: nextAppState})
  }

  postIndexToMosaicIndex(index) {
    if (this.state.dataProviderMosaic._data) {
      const mosaics = this.state.dataProviderMosaic._data
      let postIndex = 0
      for (let mosaicIndex = 0; mosaicIndex < mosaics.length; mosaicIndex++) {
        const count = mosaics[mosaicIndex].count
        if (postIndex + count > index) {
          // console.tron.log(`postIndexToMosaicIndex found index ${index} at mosaicIndex ${mosaicIndex}`)
          return Math.max(0, mosaicIndex - 1) // skip header
        }
        postIndex += count
      }
    }
    return 0
  }

  scrollModeToIndex(viewMode, index, delay = 1000, thenOpenPostView = false, commentTimeStamp = 0) {
    console.log("top of scroll mode to index " + index + " thenOpenPostView = " + thenOpenPostView + " commentTimeStamp = " + commentTimeStamp)
       // assume index is Post index, mosaic is more complex...
    console.tron.log(`scrollModeToIndex viewMode ${viewMode}, index ${index}`)
    // fix crashes related to views not being defined before scrolling them
    // this crash occurred in grid view but do for each
    // https://fabric.io/kargoe/ios/apps/com.kargoe.kargoeapp/issues/5bbf55e9f8b88c296374d12e?time=last-twenty-four-hours
    switch (viewMode) {
      case LIST_MODE:
        if (this.listScrollView)
          if (index == 0 && this.HomeWall) {
            console.log("loc 1 scroll mode to index")
            if (this.listScrollView)
              if (this.props.transparentPanels)
                this.listScrollView.scrollToOffset(0, LIST_TOP_GAP + LIST_HEADER_HEIGHT + 1, true)
              else
                this.listScrollView.scrollToOffset(0, 0, true)
          }
          else {
            if (this.listScrollView) {
              const postData = this.state.dataProvider._data // this.state.viewMode !== VID_MODE ? this.state.dataProvider._data : this.state.vidDataProvider._data
              if (false && !this.HomeWall) {
                if (index < postData.length)
                  this.listScrollView.scrollToIndex(index, true)
              }
              else {
                const topGap = this.HomeWall ? LIST_TOP_GAP : 0
                let postTopCoord = -topGap
                for (rowIndex = 0; rowIndex < index && rowIndex < postData.length; rowIndex++) {
                  const isHeader = rowIndex == 0 && typeof postData[rowIndex].Header != 'undefined'
                  const rowHeight = isHeader ? this.headerRowHeight : postData[rowIndex]['ListHeight'] + (rowIndex == 0 ? topGap : 0)
                  postTopCoord += rowHeight
                }

                const isHomeWall = (this.constructor.name === 'PostWallV2Screen')
                let shouldAnim = !isHomeWall
                shouldAnim = false // never anim (Darren's call Dec 20 2019)

                if (isHomeWall) {
                  this.state.jumpToIndex = index // dont trigger another render just set state (scrollToOffset triggers renders properly)
                  this.state.lastJumpToIndex = index
                }

                console.tron.log(`scrollModeToIndex scrollToOffset index: ${index}, postTopCoord: ${postTopCoord}`)
                // fails sometimes, as pixel 2,000,000 does not yet exist...
                // this.listScrollView.scrollToIndex(index, false) // get close
                // index = 0 // hack test (worked, goes fast to top)

                setTimeout(() => {
                  console.log("loc 2 scroll mode to index " + index)
                  if (this.listScrollView && this.listScrollView.scrollToOffset) this.listScrollView.scrollToOffset(0, index == 0 ? 0 : postTopCoord, shouldAnim)
                }, 100) // get closer

                setTimeout(() => {
                  console.log("loc 3 scroll mode to index " + index + " this.listScrollView = " + this.listScrollView);
                  if (this.listScrollView && this.listScrollView.scrollToOffset) this.listScrollView.scrollToOffset(0, index == 0 ? 0 : postTopCoord, shouldAnim)}, 1000) // in case it is slow

                // after the fast jump, clear this so the rest of the rows can render

                setTimeout(() => {
                  console.log("loc 4 scroll mode to index " + index)
                  this.setState({jumpToIndex: -1}) // trigger a re-render later to get the rows around the target row rendered
                }, 200)

                /* dont do this anymore, thumb to full image is handled in low level iOS

                setTimeout(() => {
                  this.setState({lastJumpToIndex: -1})
                }, 2000)

                */

                // make sure extended post data is loaded for this post
                const updatedPostDetails = {
                  posts: [postData[index]]
                }
               this.updateExtendedPostData(updatedPostDetails)

               // may need to think about this timer thing, would rather do it when the extended post data arrives
               // (and after the above "go to proper post" business)
               if (thenOpenPostView) {
                 setTimeout(() => {
                    console.log("ready to show post view, postData[index] = " + JSON.stringify(postData[index], null, 2))
                    this.showPostView(postData[index], 'Comments', commentTimeStamp)
                    }, 
                    1000)
                    // fire it after the above timers, maybe we need post details too?
               }
              }
            }
          }
        break;
      case GRID_MODE:
        const postData = this.state.dataProvider._data
        if (this.gridScrollView && index < postData.length) this.gridScrollView.scrollToIndex(index, true);
        break;
      case MOSAIC_MODE:
        const mosaicRows = this.state.dataProviderMosaic._data
        if (this.mosaicScrollView && index < mosaicRows.length) this.mosaicScrollView.scrollToIndex(this.postIndexToMosaicIndex(index), true);
        break;
    } // switch
  }

  scrollTo = (index) => {
    // console.tron.log(`scrollTo, viewMode: ${this.state.viewMode}`)
    this.scrollModeToIndex(this.state.viewMode, index)
  }

  scrollToEvent(event) {
  }

  _onPressBack = () => {
    console.tron.display({
    name: `_onPressBack`,
     preview :``,
    value: {
    state: `this.state`
    }
    })
    this.props.navigation.goBack()
  }

  onFollowerPress = () => {
    this.props.navigation.navigate('follow', { title: 'Followers', userId: this.props.user.UserId, isFollower: true })
  }
  onFollowingPress = () => {
    this.props.navigation.navigate('follow', { title: 'Following', userId: this.props.user.UserId, isFollower: false })
  }

  onSettingsClick = () => {
    console.tron.log("on settings")
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'settings', params: {} })]
    }))
  }
  onBadgeShareClick = () => {
    console.tron.log("on vixen")
    console.log("on badge share click")
    this.setState({
      dataPost: 'badge',
      actionOptions: ['facebook', 'twitter', 'instagram'] // tumblr was 2nd from last
    }, () => {
      this.actionSheet.showActionSheet()
    })
  }
  onBadgeImage = b64BadgeImage => {
    console.log("on badge image b64 length = " + b64BadgeImage.length)
    this.setState({ badge : b64BadgeImage })
  }

  onHumburgerPress = () => {
    this.props.screenProps.openDrawer()
  }

  messageAction = () => {
    if (Platform.OS != 'web') {
    const { navigation: { state: { params: { userId } } } } = this.props
    const { currentUser, user: { Username } } = this.props
    this.props.navigation.navigate('chat', {
      PhoneUser: currentUser,
      OtherUserId: userId,
      OtherUserName: Username,
      isScroll: true
    })
    } else {
      alert("To message Kargoers, get the Kargoe mobile app for iPhone or Android...available on the App Store and Google Play now!")
    }
  }

  setAlertMessage(alertMessage) {
    this.setState({alertMessage})
  }

  clearAlertMessage() {
    this.setAlertMessage('')
  }

  setErrorMessage(errorMessage) {
    this.setState({errorMessage})
  }

  clearErrorMessage() {
    this.setErrorMessage('')
  }

  onFollowUser = (userId = null) => {
		if (userId == null)
			userId = this.props.user.UserId
    this.setState({
      isUserFollow: true
    })

		delete this.fullScreenIsFollowing[userId]
    this.props.followUser(this.state.authUserId, userId)

    setTimeout(() => {
      this.props.readUser(userId) // UserId => dispatch(UserActions.readOtherRequest(UserId)),
    }, 1000)
  }

  onUnfollowUser = (userId = null) => {
		if (userId == null)
			userId = this.props.user.UserId
    this.setState({
      isUserFollow: false
    })
		delete this.fullScreenIsFollowing[userId]
    this.props.unFollowUser(this.state.authUserId, userId)

    setTimeout(() => {
      this.props.readUser(userId) // UserId => dispatch(UserActions.readOtherRequest(UserId)),
    }, 1000)
  }

  _rowRendererGrid(type, data, index) {
    //console.log("row renderer grid")
    // return this.rowRenderer(type, data, index, GRID_MODE)
    const gridBorder = 1
    if (type == 'HEADER')
      return this.headerRowRender()

    if (this.state.viewMode == GRID_MODE)
      return this._renderPostThumb(type, data, index, itemWidth, itemHeight, gridBorder)
    else
      return (<View></View>)
  }

  _rowRendererMosaic(type, mosaicDetails, index) {
    //console.log("row renderer mosaic")
    // console.tron.log(`_rowRendererMosaic index ${index}`) // dataProviderMosaic
    if (type == 'HEADER')
      return this.headerRowRender()
    let thumbViews = []
    const mosaicBorder = 2 // orig
    if (mosaicDetails && mosaicDetails.count)
      for (let i = 0; i < mosaicDetails.count; i++) {
          const layoutOrig = mosaicDetails.layout[i]
          //console.log("mosaic layout = " + JSON.stringify(layout, null, 2))
          let layout = JSON.parse(JSON.stringify(layoutOrig))

          let factor = window.mainViewWidthFraction ? window.mainViewWidthFraction : 1

          layout.width *= factor
          layout.height *= factor

          layout.top *= factor
          layout.left *= factor

          const index = layout.index
          const postIndex = this.ProfileWall ? index + 1 : index
          const post = this.state.dataProvider._data[postIndex]
          const postThumbView = this._renderPostThumb(type, post, index, layout.width, layout.height, mosaicBorder)
          const thumbWrapper = (
            <View style={{ position: 'absolute', top: layout.top, left: layout.left }}>
              {postThumbView}
            </View>
          )
          thumbViews.push(thumbWrapper)
      }
    if (this.state.viewMode == MOSAIC_MODE)
      return thumbViews
    else 
      return (<View></View>)
  }

  _rowRendererList(type, data, index) {
    //console.log("row render list index = " + index)
    if (type == 'HEADER')
      return this.headerRowRender()
    if (this.state.viewMode == LIST_MODE)
      return this.rowRenderer(type, data, index, LIST_MODE)
    else 
      return (<View></View>)
  }

  _rowRendererFullScreen(type, data, index, extendedState = null) {
    //console.log("row render list index = " + index)
    // console.tron.log("_rowRendererFullScreen index = " + index + ", type: " + type)
    if (type == 'HEADER')
      return this.headerRowRender()
    return this.rowRendererFullScreen(type, data, index, extendedState)
  }

/*
  _rowRendererVid(type, data, index) {
    if (type == 'HEADER')
      return this.headerRowRender()
    return this.rowRenderer(type, data, index, VID_MODE)
  }
*/

  _renderPostThumb(type, post, index, width, height, gridBorder) {
    // consistent 'random' value
    const temp = Math.sin(1000 * Math.floor(post ? post.TimeStamp : 0)) * 100000
    const rand = temp - Math.floor(temp)
    const tileIndex = Math.floor(Colors.cellbg.length * rand)
    const tileColor = Colors.cellbg[tileIndex]
    // Use less memory if the screen isn't on top, ie: visible
    if (!post || !this.state.nearTopScreen)
      return (
        <View
          style={{ backgroundColor: tileColor, width: width, height: height }}
        />
      )
    else {
      const url = `${KargoeConfig.baseUrlMedia}/${post.PostId}-thumb.jpg?${post.Version}`
      const postSelling = typeof post.Selling != 'undefined' ? post.Selling : false
      const postMediaType = typeof post.MediaType != 'undefined' && !this.props.options.disableVideos ? post.MediaType : 'JPEG'
      const postType = typeof post.Type != 'undefined' ? post.Type : ''
      const overlayIcons = /*this.props.options.showOverlayIcons*/ true ?
        (
          <IconPostWallV2Component showVideoWall={this.showVideoWallNew.bind(this, post.PostId)} postId={post.PostId} viewMode={this.state.viewMode} viewModeList={false} selling={postSelling} mediaType={postMediaType} type={postType} muted={this.isMuted()} playing={this.state.currVideoPlayIndex == index} onSoundToggle={this.onSoundToggle} />
        ) :
        null
      //const gridBorder = 1
      const isGrid     = type == ViewTypes.GRID_LEFT || type == ViewTypes.GRID_MIDDLE || type == ViewTypes.GRID_RIGHT
      const isGridEdge = type == ViewTypes.GRID_LEFT || type == ViewTypes.GRID_RIGHT
      const tileWidth  = isGridEdge ? width : width - 2*gridBorder // width - 2*gridBorder
      const tileHeight = isGrid ? height - gridBorder : height - 2*gridBorder
      let marginTop    = isGrid ? 0 : gridBorder
      let marginBottom = gridBorder
      let marginLeft   = isGridEdge ? 0 : gridBorder
      let marginRight  = isGridEdge ? 0 : gridBorder
      // style={{ backgroundColor: tileColor, width: tileWidth, height: tileHeight, margin: gridBorder }}>
      return (
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => this.onImagePress(post, index)}
          style={{ backgroundColor: tileColor, width: tileWidth, height: tileHeight, marginTop: marginTop, marginBottom: marginBottom, marginLeft: marginLeft, marginRight: marginRight }}>
          <ImageRecycler
            useCache={this.props.options.useCache}
            style={{ width: tileWidth, height: tileHeight }}
            resizeMode="cover"
            source={{ uri: url, cache: 'force-cache' }}
            loadingOpacity={this.props.options.loadingOpacity}
          />
          {overlayIcons}
        </TouchableOpacity>
      )
    }
  } // _renderPostThumb

  // https://ste.vn/2015/06/10/configuring-app-transport-security-ios-9-osx-10-11/
  httpToHttps(url) {
    if (url == null || typeof url == 'undefined')
      return ''
    else
      return url //.replace('http://', 'https://')
  }

  // functions that render parts of the Wall
  onLocation = (post) => {
    console.tron.display({
      name: `onLocation`,
      preview: ``,
      value: {
        state: post
      }
    })
    console.log("on location tap post = " + JSON.stringify(post, null, 2))
    this.props.navigation.navigate('mapwall', { LocationName: post.LocationName, LocationCoord : post.LocationCoord, LocationId : post.LocationId })
  }
  createHeaderView(post) {
    let userName = ''
    if (typeof post.Username != 'undefined')
      userName = post.Username
    else if (typeof this.userNames[post.UserId] != 'undefined')
      userName = this.userNames[post.UserId]
    const locationName = typeof post.LocationName != 'undefined' ? post.LocationName : ''
    return (
      <View style={{ height: LIST_HEADER_HEIGHT }}>
        <MessageCacheComponent
          onSubTitle={() => this.onLocation(post)}
          isWall={true}
          style={{ paddingBottom: 10 }}
          contentStyle={[{ minHeight: LIST_HEADER_HEIGHT, justifyContent: 'center', backgroundColor: this.props.options.debugBackgrounds ? '#FFCC66' : '#ffffff' }]}
          onPress={() => this.onAvatarPress(post.UserId, userName,post.PostId)}
          userId={post.UserId}
          // key={post.PostId}
          title={userName}
          titleStyle={[styles.userName, {
            // fontSize: 13, default is 16
            fontSize: 17,
            width: screenWidth - 100,
            color: 'black',
            backgroundColor: this.props.options.debugBackgrounds ? '#ddffdd' : 'transparent'
          }]}
          subTitle={locationName}
          subtitleContainerStyle={[{ marginLeft: 0 }]}
          subtitleStyle={{ color: 'rgb(74, 83, 109)', fontWeight: '400', fontSize: 12, width: screenWidth - 110, backgroundColor: this.props.options.debugBackgrounds ? '#ffdddd' : 'transparent' }}
          rightTitle={convertTime(post.TimeStamp)}
          rightTitleStyle={[{ width: 40, fontFamily: Fonts.style.font.regular, fontSize: 17, backgroundColor: this.props.options.debugBackgrounds ? '#ddddff' : 'transparent' }]}
        />
      </View>
    )
  } // createHeaderView

  createCaptionCommentView_UNUSED(post, index) {
    const isFullScreen = false, screenLandscape = false, extraTextStyle = null, showFullContent = false
		const fullScreenWidthDelta = isFullScreen ? -20 : 0 // -6
		const width = isFullScreen && screenLandscape ? Math.max(screenWidth, screenHeight) - 50 + fullScreenWidthDelta : Math.min(screenWidth, screenHeight) + fullScreenWidthDelta
		const useTransparentBg = isFullScreen
		const textFontSize = isFullScreen ? 13 : 15
		const textLineHeight = isFullScreen ? 15 : 18
		const briefLines = isFullScreen ? 2 : 3
		const textColor = isFullScreen ? 'white' : 'black'
		const moreShadowColor = isFullScreen ? 'gray' : 'white'
		const textJustify = screenLandscape ? 'flex-end' : 'flex-start'
		let needsMoreBtn = false
    const meta = post.Meta
    const caption = post.Caption
    if (caption && caption.length > 126) { // last computed during prior render
      needsMoreBtn = true
		}
    // console.tron.log(`createCaptionCommentView needsMoreBtn: ${needsMoreBtn}`)
    let comments = typeof post.RecentComments != 'undefined' ? [...post.RecentComments] : [] // clone array and objects
    //console.log("AAA comments.length = " + comments.length + " caption = " + caption)
		if ((comments.length > 1 && caption) || comments.length > 2) needsMoreBtn = true
		if (!showFullContent)
			needsMoreBtn = false
    var commnetsWall = []
    if (comments.length || caption) {
      comments.reverse()
      const haveCaption = caption // && post.Type == 0 // skip the hyperlink?
      if (haveCaption) {
        comments.unshift({
          TimeStamp: post.TimeStamp,
          UserId: post.UserId,
          Username: post.Username,
          Body: caption,
          IsCaption: true,
        })
      }

      commnetsWall = [...comments]

      commnetsWall.splice(3)
      const bgColors = ['#eee0ff', '#eeeeff', '#e0eeff']
      for (let i = 0; i < commnetsWall.length; i++) {
        let isCaption = haveCaption && i == 0
        // normal way, first item is caption, 3 lines
        let numLines = isCaption ? briefLines : 1
        let maxHeight = numLines * textLineHeight
        // if no caption and we are on the first line, give that comment 3 lines
        if (!haveCaption && i == 0) {
          numLines = briefLines
          maxHeight = briefLines * textLineHeight
        }
        commnetsWall[i] = Object.assign({
          key: "CL" + i, //  + post.PostId + "-" + comments[i].TimeStamp, // for FlatList
          NumLines: numLines,
					MaxHeight: maxHeight,
					isCaption,
          bgColor: this.props.options.debugBackgrounds ? bgColors[i % 3] : 'transparent',
        }, commnetsWall[i])
      }
    }
    const { navigation } = this.props
    const heightOneTextLine = textLineHeight
		if (!this.moreButtonOn)
			this.moreButtonOn = {}
    const emojiClipFix = 4 // points to bump down to avoid clipping emoji on top line
    const emojiClipFixOuter = 4

    // pile up more text to make shadow (white fadeout) more opaque since we have opacity all the way up, the system is making the fade too weak
    // if you change the styles of this, also change the styles of MORE... button to matc h
    const pileUpMoreButton = (<Text style={{ position: 'absolute', top: 0, left: 0, borderRadius: 5, shadowOffset: { width: 0, height: 0 }, shadowRadius : 6, shadowOpacity: 1, shadowColor: moreShadowColor, backgroundColor: moreShadowColor, padding: 0, margin: 0, width: 52, height: textLineHeight, lineHeight: textLineHeight, fontSize: 14, fontWeight: 'bold', color: textColor }}>...MORE</Text>)

		let containerStyle = {
			backgroundColor: useTransparentBg ? 'transparent' : '#ffffff',
			overflow: 'hidden',
			paddingLeft: useTransparentBg ? 0 : 14, 
			paddingRight: 14,
			top: -emojiClipFixOuter
		}
		if (!showFullContent) {
			containerStyle.height = briefLines * heightOneTextLine + 2*emojiClipFixOuter
			containerStyle.overflow = 'hidden'
		}
	
		const contents = (
			<>
			{commnetsWall.map((comment, index) => {
				const isFirstLine = (index === 0)
				const isLastLine  = (index === 2)
				const maxHeight   = showFullContent ? null : (comment.MaxHeight + (isFirstLine ? emojiClipFix : 0))
				const numLines    = showFullContent ? 100 : comment.NumLines
				const startWithUsername = !isFullScreen || !comment.isCaption
				return (
					<View key={`c` + index} style={{
						flexDirection: `row`,
						justifyContent: textJustify,
						backgroundColor: comment.bgColor
						}}
						onLayout={(e) => {
							const {x, y, width, height} = e.nativeEvent.layout
							//console.log("onLayout comment height = " + height + " " + JSON.stringify(comment, null, 2) + " nActualLines = " + height/heightOneTextLine)
							let nActualLines = height/heightOneTextLine
							//const priorNActualLines = comment.nActualLines
							//comment.nActualLines = nActualLines // will this work?
							// check the flags already set so we don't do a refresh unnecessarily (or infinite loop, which is worse)
							// console.log("comment.Body = " + comment.Body)
							if (!showFullContent && nActualLines > 2 && !needsMoreBtn && !this.moreButtonOn[post.PostId]) {
								//console.log('setting needs more button in caption for post ' + post.PostId)
								this.moreButtonOn[post.PostId] = true
								this.state.camComBlockIndex = this.state.camComBlockIndex + 1
								this.forceUpdate() // redraw to get the more button
							}
						}}
					>
            {true &&
						<Text style={[{lineHeight: textLineHeight, paddingTop: /*isFirstLine*/ true ? emojiClipFix/2 : 0, paddingBottom: isLastLine ? emojiClipFix : 0 }, extraTextStyle]} numberOfLines={numLines}>
							{startWithUsername && <Text style={[styles.userNameFooter, { fontFamily: Fonts.style.font.bold, fontSize: textFontSize, maxHeight, backgroundColor: comment.bgColor, color: textColor, paddingTop: /*isFirstLine*/ true ? emojiClipFix/2 : 0, paddingBottom: isLastLine ? emojiClipFix : 0 }, extraTextStyle]}
								onPress={() => this.onAvatarPress(comment.UserId, comment.Username)}>
								{`${comment.Username} `}
							</Text>}
							{convertMessage({
								item: comment.Body, // rgb(119, 119, 119)
								styles: { text: [{ fontFamily: Fonts.style.font.regular, fontSize: textFontSize, color: 'black', lineHeight: textLineHeight }, extraTextStyle], wrap: [{ lineHeight: textLineHeight, fontSize: textFontSize, color: textColor }, extraTextStyle] },
								numLines,
								navigation
							}, () => {
							})}
						</Text>}
					</View>
				)
			})}
			{(isFullScreen && (needsMoreBtn || this.moreButtonOn[post.PostId])) && <View  style={{position: 'absolute', top: briefLines * textLineHeight - textLineHeight, right: 0, width: 20, height: textLineHeight + emojiClipFix*2 + 10 }}>
					<Text style={[extraTextStyle, {color: 'white', fontSize: textLineHeight, textAlign: 'right'}]}>{showFullContent ? `-` : `+`}</Text>
			</View>}
			{(!isFullScreen && (needsMoreBtn || this.moreButtonOn[post.PostId])) && <View  style={{position: 'absolute', top: briefLines * textLineHeight - textLineHeight, left: width-72-14, width: 20 + 10, height: textLineHeight + emojiClipFix*2 + 10 }}>
				<View style={{ width: 20, height: textLineHeight + emojiClipFix/2, padding: 0, paddingTop: 0, margin: 10 }} resizeMode="cover" source={Images.moreGradient} />
			</View>}
			{(!isFullScreen && (needsMoreBtn || this.moreButtonOn[post.PostId])) && <View  style={{position: 'absolute', top: briefLines * textLineHeight - textLineHeight + emojiClipFix, left: width-52-14, width: 52 + 20 , height: textLineHeight + emojiClipFix*2 + 20 }}>
				<Text style={{ borderRadius: 5, shadowOffset: { width: 0, height: 0 }, shadowRadius : 6, shadowOpacity: 1, shadowColor: 'white', backgroundColor: 'white', padding: 0, margin: 0, width: 52, height: textLineHeight, lineHeight: textLineHeight, fontSize: 14, fontWeight: 'bold', color: textColor }}>...MORE</Text>
				{pileUpMoreButton}
				{pileUpMoreButton}
				{pileUpMoreButton}
				{pileUpMoreButton}
				{pileUpMoreButton}
			</View>}
			</>
		)
		if (isFullScreen)
			return (
				<View key = {'capComBlockV' + this.state.camComBlockIndex} style={containerStyle}>
					{contents}
				</View>
			)
		else
			return (
				<TouchableOpacity
					key={'capComBlock' + this.state.camComBlockIndex}
					onPress={( ) => this.showPostView(post,'Comments')}
					style={containerStyle}>
					{contents}
      </TouchableOpacity>
    )
	} // createCaptionCommentView
	
	fullScreenCaptionOrComment(post, comment = null, screenLandscape = false, index = 0, width) {
    const { navigation } = this.props
		const isLastLine = false
		const textColor = 'white'
		const numLines = 0 // unlimited
		const textFontSize = 12 // 14
		const textLineHeight = 15 // 18
		const extraTextStyle = {}
    const emojiClipFix = 4 // points to bump down to avoid clipping emoji on top line
    const emojiClipFixOuter = 4
		const textJustify = screenLandscape ? 'flex-end' : 'flex-start'
		const containerStyle = {flexDirection: `row`, justifyContent: textJustify, width, marginBottom: 6}
		const textContainerStyle = {flexDirection: `row`, justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'rgba(64,64,64,0.20)', borderRadius: 6, flex: 1 /* , width: width - 43 */}
		const partStyle = [{lineHeight: textLineHeight, paddingTop: emojiClipFix/2, paddingBottom: emojiClipFix/2 }, extraTextStyle]
		const isComment = comment != null
		const text = isComment ? comment.Body : post.Caption
		const when = isComment ? comment.TimeStamp : post.TimeStamp
		const postId = post.PostId
		const userId = isComment ? comment.UserId : post.UserId
		const userName = isComment ? comment.Username : post.Username
		const messageParams = {
			item: text,
			styles: { text: [{ fontFamily: Fonts.style.font.regular, fontSize: textFontSize, color: 'black', lineHeight: textLineHeight }, extraTextStyle], wrap: [{ lineHeight: textLineHeight, fontSize: textFontSize, color: textColor }, extraTextStyle] },
			numLines,
			navigation
		}
		const avatarView = (
			<View style={[partStyle, {width: 42, paddingRight: 10, paddingTop: 0, backgroundColor: 'rgba(0,0,255,0)'}]}>
				<AvatarComponent style={{borderWidth : 0}} userId={userId} size={28} onPress={() => this.onAvatarPress(userId , userName, postId)}/>
			</View>
		)
		const userView = (
			<Text style={[styles.userNameFooter, { fontFamily: Fonts.style.font.bold, fontWeight: (Platform.OS == 'web') ? 'bold' : 'normal', fontSize: textFontSize, color: textColor, paddingTop: emojiClipFix/2, paddingBottom: 0 }, extraTextStyle]}
				onPress={() => this.onAvatarPress(userId, userName)}>
				{`${userName} `}
			</Text>
		)
		const whenView = (
			<View style={[partStyle, {width: 38, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(255,0,0,0)'}]}>
				<Text style={{color: 'white', fontSize: textFontSize}}>{convertTime(when)}</Text>
			</View>
		)
		const textView = convertMessage(messageParams, () => {})
		return (
			<View key={`c` + index} style={containerStyle}>
				{avatarView}
				<View style={textContainerStyle}>
					<Text style={[partStyle, {width: width - 38 - 42 - 10, paddingLeft: 10, justifyContent: 'center', backgroundColor: 'rgba(0,255,0,0)'}]}>
						{userView}
						{textView}
					</Text>
					{whenView}
				</View>
			</View>
		)
	}

  // add arg so this can be used for aux right side view on wide web display
  updateForPostView = (postToUse) => {
    // this._onRefresh()
    const options = { // lower case postId if it comes in wow
      PostId: this.postViewPost ? this.postViewPost.PostId : (postToUse ? postToUse.postId : 0),
      PostIds: [],
      GetLikes: true
    }
    console.log("updateForPostView get extended data for post = " + options.PostId)
    this.props.readPosts(options)

    this.setState({directCommentEntryOn : false}) // hide comment entry after posting comment (this fn should get called via _onRefresh
      // after posting a comment from wall

  }

  // commentTimeStamp optional
  showPostView = (post, defaultTab, commentTimeStamp, asPopup) => {
    // this.setState({ showPostView : post, postViewDefaultTab : 'Comments' })
    const currentVisibleIndexes = this.currentVisibleIndexes.length > 0 ? this.currentVisibleIndexes : []
    console.log("showPostView, current visible indexes = " +  JSON.stringify(currentVisibleIndexes))
    this.postViewPost = post // save for when we go back because the above current visible indexes get messed up for some react reason
    this.postViewPriorOffsetY = this.scrollOffsetY // similar reason as above but more precise scroll location
    console.log("showPostView:  should show post view as popup = " + asPopup)
    if (!asPopup) {
    this.props.navigation.navigate('postView', {
      post: post,
      defaultTab:  defaultTab,
      _onRefresh: this.updateForPostView,
      commentTimeStamp: commentTimeStamp, // pass along can be 0, in which case it will be ignored
      isPopup: asPopup
    })
    } else {
        
        if (this.state.twoCircleCommentPopupPost != post && 
            this.state.twoCircleCommentPopup) // close old first and make sure direct comment entry field is off
          this.setState({twoCircleCommentPopup: false, twoCircleCommentPopupPost: null, directCommentEntryOn: false})

        setTimeout(() => {
        if (this.state.twoCircleCommentPopup)
          // also shut off direct comment entry in case it was on
          this.setState({twoCircleCommentPopup: false, twoCircleCommentPopupPost: null, directCommentEntryOn: false})
        else
          this.setState({twoCircleCommentPopup: true, twoCircleCommentPopupPost: post})
        },0)
    }
  }

  checkShowShopping = (post) => {
    return (post.ISell && post.ISell.length > 0) && (post.TheySell && post.TheySell.length > 0)
      && (post.Donate && post.Donate.length > 0) && (post.UserTags && post.UserTags > 0)
  }

  safariView = (url) => {
    if (true) { // url.indexOf('https://secure.shoppable.co') == 0 || isURL(url)) {
      this.setState({currVideoPlayIndex: -1})
      this.muteSound()
      if (false)
      SafariView.openUrl(url)
    } else {
      alertView('Invalid URL', url)
    }
  }

  createFooterButtonView(post, index) {
    const numViews = typeof post.NumViews != 'undefined' ? humanReadableNumber(post.NumViews) : ''
    const numLoves = typeof post.NumLikes != 'undefined' ? humanReadableNumber(post.NumLikes) : ''
    const numComments = typeof post.NumComments != 'undefined' ? humanReadableNumber(post.NumComments) : ''
    const kargoeTags = typeof post.TheySell != 'undefined' ? post.TheySell.length + post.ISell.length + post.Donate.length > 0 : false
    const userLovesPost = typeof post.UserLovesPost != 'undefined' ? post.UserLovesPost : false
    // if (!this.props.options.useFooterImages)
    //   return (
    //     <View style={styles.footerContainer}>
    //       <View style={styles.footerWrapper}>
    //         <ImageAndText text={numViews} isText={true}>
    //           <Text style={{ width: 22, height: 22 }}>Vw</Text>
    //         </ImageAndText>
    //         <ImageAndText text={numLoves} isText={true} onPress={() => this.onLovePress(post, index)}>
    //           <Text style={{ width: 22, height: 22 }}>Lv</Text>
    //         </ImageAndText>
    //         <ImageAndText text={numComments} isText={true} onPress={() => this.showCommentDialog(post)}>
    //           <Text style={{ width: 22, height: 22 }}>Cm</Text>
    //         </ImageAndText>
    //         <ImageAndText text={``} onPress={() => this.onKargoePress(post, index)}>
    //           <Text style={{ width: 22, height: 22 }}>Kg</Text>
    //         </ImageAndText>
    //         <ImageAndText text={``}>
    //           <Text style={{ width: 22, height: 22 }}>#</Text>
    //         </ImageAndText>
    //         <ImageAndText text={``} onPress={() => this.showActionSheet(post)}>
    //           <Text style={{ width: 22, height: 22 }}>...</Text>
    //         </ImageAndText>
    //       </View>
    //     </View>
    //   )
    // else
    // for debug of love log("creating footer for post " + JSON.stringify(post, null, 2))
    return (
      <FooterPostWall
        onSharePress={() => this.iosShare(post)}
        popup={(tab, asPopup) => 
            {
              //if (Platform.OS != 'web') // for now, hide on web
                this.showPostView(post, tab, null /*TimeStamp to scroll to*/, asPopup)
            }
        }
        userLovesPost={userLovesPost}
        onLovePress={(e) => this.onLovePress(e, post, index, 'wall')}
        showActionSheet={() => this.showActionSheet(post)}
        isShopping={kargoeTags}
        indexRow={index}
        data={post}
        navigation={this.props.navigation}
        onPressShoping={() => this.onPressList(post, index)}
        isText={true}
        NumViews={numViews}
        NumLikes={numLoves}
        NumComments={numComments}
        PostId={post.PostId}
        key={post.PostId} />
    )
  } // createFooterButtonView

  createShopItView(post) {
    if (!this.pressedTagDetails)
      return null
    // console.tron.log(`createShopItView`)
/*
    console.tron.display({
      name: `createShopItView`,
      preview: ``,
      value: {
        tagDetails: this.props.order.item,
        pressedTagDetails: this.pressedTagDetails,
      }
    })
*/
    // this.props.order.item
    const { tag } = this.pressedTagDetails
    const { name, url, price, itemId } = this.findExtendedTagDetails(post.PostId, this.pressedTagDetails.kind, this.pressedTagDetails.tag, this.pressedTagDetails.id)
    // preflightItemId
    switch (this.pressedTagDetails.kind) {
      case DONNATE:
        return (
          <View style={{ position: 'absolute', left: 0, top: 0, width: screenWidth, height: 93, opacity: 0.80, backgroundColor: '#eeeeee' }}>
            <View style={{ height: 50 }}>
              <View style={{ height: 50, flex: 1, flexDirection: 'row', paddingLeft: 10, paddingRight: 10 }}>
                <View style={{ height: 50, flex: 75, flexDirection: 'column', justifyContent: 'space-around' }}>
                  <Text style={{ fontWeight: 'bold' }}>{tag.CharityName}</Text>
                </View>
                <View style={{ height: 50, flex: 25 }}>
                  <Text style={{ lineHeight: 50, fontWeight: 'bold', alignSelf: 'flex-end' }}>{price}</Text>
                </View>
              </View>
            </View>

            <TouchableOpacity key={`shopit_btn`} activeOpacity={0.8}
              onPress={() => this.onDonatePress({ price: tag.Amount, charityName: tag.CharityName, itemId, postId: post.PostId })}
              style={{ flex: 1, justifyContent: 'center', alignItems: 'center', height: 43, backgroundColor: 'rgba(113,179,212,0.81)' }}>
              <Text style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}>Donate now!</Text>
            </TouchableOpacity>
          </View>
        )
        break
      case ISELL:
        const name = tag.Name
        const description = tag.Color
        const sold = tag.Sold // Sold: (true/false) - 'Out of stock' or 'Shop it'
        const iSellBtnBg = sold ? 'rgba(176, 32, 38,.81)' : 'rgba(55,189,154,0.95)'
        return (
          <View style={{ position: 'absolute', left: 0, top: 0, width: screenWidth, height: 102, opacity: 0.80, backgroundColor: '#eeeeee' }}>
            <View style={{ height: 62 }}>
              <View style={{ height: 62, flex: 1, flexDirection: 'row', paddingLeft: 10, paddingRight: 10 }}>
                <View style={{ height: 62, flex: 74, flexDirection: 'column', justifyContent: 'space-around' }}>
                  <Text style={{}}>Title: <Text style={{ fontWeight: 'bold' }}>{name}</Text></Text>
                  <Text style={{}}>Description: <Text style={{ fontWeight: 'bold' }}>{description}</Text></Text>
                </View>
                <View style={{ height: 62, flex: 26 }}>
                  <Text style={{ lineHeight: 62, fontWeight: 'bold', alignSelf: 'flex-end' }}>{price}</Text>
                </View>
              </View>
            </View>

            <TouchableOpacity key={`shopit_btn`} activeOpacity={0.8}
              onPress={() => this.onShopitPress()}
              style={{ flex: 1, justifyContent: 'center', alignItems: 'center', height: 40, backgroundColor: iSellBtnBg }}>
              <Text style={{ color: 'white', fontSize: 20, fontWeight: 'bold', letterSpacing: 2 }}>{sold ? 'No longer available' : 'Shop it'}</Text>
            </TouchableOpacity>
          </View>
        )
        break
      case THEYSELL:
        const title = tag.Title
        const brand = this.props.order.item && this.props.order.item.ItemId == this.pressedTagDetails.id ? this.props.order.item.Brand : '...'
        const store = this.props.order.item && this.props.order.item.ItemId == this.pressedTagDetails.id ? this.props.order.item.StoreName : '...'
        let btnTitle = this.props.order.meta ? this.props.order.meta.availableMessage : 'Shop it'
        const isShoppable = isShoppableItemId(this.pressedTagDetails.id)
        let btnEnabled = true
        if (isShoppable && (!this.props.options.useShoppableShopIt || (this.props.order.item && !this.props.order.item.Active))) {
          btnEnabled = false
          btnTitle = 'Item not available - SP'
        }
        if (this.props.order.error) {
          btnEnabled = false
          btnTitle = this.props.order.error.detail
        }
        if (this.props.order.meta && !this.props.order.meta.isAvailable)
          btnEnabled = false
        const TheySellBtnBg = !btnEnabled ? 'rgba(176, 32, 38,.81)' : 'rgba(55,189,154,0.95)'
        return (
          <View style={{ position: 'absolute', left: 0, top: 0, width: screenWidth, height: 126, opacity: 0.80, backgroundColor: '#eeeeee' }}>
            <View style={{ height: 83 }}>
              <View style={{ height: 83, flex: 1, flexDirection: 'column', justifyContent: 'space-around', paddingTop: 6, paddingLeft: 10, paddingRight: 10 }}>
                <Text style={{ flex: 1, width: screenWidth }} numberOfLines={2}>Title: <Text style={{ fontWeight: 'bold' }}>{title}</Text></Text>
                <View style={{ flex: 1, height: 18, flexDirection: 'row', justifyContent: 'space-around' }}>
                  <Text style={{ flex: 65 }}>Brand: <Text style={{ fontWeight: 'bold' }}>{brand}</Text></Text>
                  <Text style={{ flex: 35, fontWeight: 'bold', alignSelf: 'flex-end', textAlign: 'right' }} adjustsFontSizeToFit>{price}</Text>
                </View>
                <Text style={{ flex: 1, width: screenWidth, height: 18 }}>Store: <Text style={{ fontWeight: 'bold' }}>{store}</Text></Text>
              </View>
            </View>

            <TouchableOpacity key={`shopit_btn`} activeOpacity={0.8}
              onPress={() => btnEnabled ? this.onShopitPress() : null}
              style={{ height: 43, flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: TheySellBtnBg }}>
              <Text numberOfLines={1} adjustsFontSizeToFit={true} style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}>{btnTitle}</Text>
            </TouchableOpacity>
          </View>
        )
        break
    } // switch
    return (
      <View style={{ position: 'absolute', left: 0, top: 0, width: screenWidth, height: 100, opacity: 0.80, backgroundColor: '#eeeeee' }}>
        <Text>Shop It</Text>
      </View>
    )
  } // createShopItView

  tagPopTimes = [ 0, 0.25, 0.50, 0.75, 1 ]
  tagPopSizes = [ 0, 1.20, 0.90, 1.05, 1 ]

  createTagDots(post, postIndex, dotList) {
    const aspectRatio = post.AspectRatio
    const imageWidth  = screenWidth
    const imageHeight = screenWidth / aspectRatio
    const dotSize     = screenWidth / 15
    const halfDot     = dotSize / 2
    const iconSpacer  = 47
    const pixelsPerChar = 6 // guess
    const pixelsPerCharWide = 7.8
    return dotList.map((entry, index) => {
      let title = '1234567890'
      if (typeof entry.Title != 'undefined')
        title = entry.Title // TheySell
      else if (typeof entry.Name != 'undefined')
        title = entry.Name
      else if (typeof entry.CharityName != 'undefined')
        title = entry.CharityName
      title = title.substr(0, 23)
      const numUppers = (title.match(/[A-Z]/g) || []).length;
      // 23 if lowercase but only 19 chars if upper case
      const widerChars = numUppers > 8
      if (widerChars)
        title = title.substr(0, 19)
      const titleLength = title.length
      const tagWidth = iconSpacer + (title.length * (widerChars ? pixelsPerCharWide : pixelsPerChar))
      const top  = - halfDot + (imageHeight * entry.Top / 100) + ALL_TAG_HEIGHT
      const left = - halfDot + (imageWidth  * entry.Left / 100) + tagWidth / 2
      // console.tron.log(`createTagDots entry.top: ${entry.Top}, entry.left: ${entry.Left}, title: ${title}, tagWidth: ${tagWidth}, numUppers: ${numUppers}`)
      return <View key={post.PostId + '_dt_' + index} style={{position : 'absolute', top : top, left : left}}>
          <TouchableOpacity style={{height:dotSize, width: dotSize}} hitSlop={{left: 15, right: 15, top: 15, bottom: 15}} key={`DOT${index}`} activeOpacity={0.8} onPress={( ) => this.onKargoePress(post, postIndex)}>
            <Image style={{width: dotSize, height: dotSize}} source={Images.shoppingDot}/>
          </TouchableOpacity>
        </View>
    })
  }

  // use bigger tag rendering if live stream
  createTheySellTagViews(post, imageWidth, imageHeight, showShopit, forLiveStream = false, streamBackgroundColor = null) {
    const count = post.TheySell ? post.TheySell.length : 0
    console.log(`stream createTheySellTagViews begins, count: ${count}`)
    return post.TheySell && post.TheySell.map((entry, index) => {
			const { name, url, price } = this.findExtendedTagDetails(post.PostId, 'TheySell', entry, entry.ItemId)
      // console.log(`createTheySellTagViews entryId ${entry.ItemId} url ${url}`)

      // orig way
      let position = {top : `${entry.Top}%`, left : `${entry.Left}%`}
 
      if (forLiveStream) {
         position = {bottom : 3, left : index * 100} // see image width in LeaveStreamTheySellStyle
      }

      let allTagHeight = forLiveStream ? 150 : ALL_TAG_HEIGHT
      let itemStyle = forLiveStream ? {} : {  
        transform : [{scale:this.state.tagPop.interpolate({inputRange:this.tagPopTimes,outputRange:this.tagPopSizes})}],
        position : 'absolute', 
        opacity : showShopit && entry.ItemId != this.pressedTagDetails.id? 0.25: 1,
        ...position
      }
      if (forLiveStream && this.streamViewData && this.streamViewData.id == entry.ItemId)
        itemStyle.backgroundColor = streamBackgroundColor
      let onPress
      if (forLiveStream)
        onPress = () => this.onTagPressStream(post, 'TheySell', entry, entry.ItemId)
      else
        onPress = () => this.onTagPress(post, 'TheySell', entry, entry.ItemId)
      return  <Animated.View key={post.PostId + '_tstv_' + index} style={itemStyle}>
                <TouchableOpacity style={{height:allTagHeight}} key={`TS${index}`} activeOpacity={0.8} onPress={onPress}>
                  {forLiveStream ? <View isClose={false} data={{ Image: url }} text={entry.Title} price={price} isProduct/>
                  : <CaptionComponent isClose={false} data={{ Image: url }} text={entry.Title} price={price} isProduct/>}
                </TouchableOpacity>
              </Animated.View>
    })
  }

  onTagPressStream = (data, kind, tag, id) => {
    console.log(`onTagPressStream id: ${id}`)
    this.setState({update: new Date().getTime()})
    if (this.streamViewData && this.streamViewData.id == id)
      this.streamViewData = null
    else
      this.streamViewData = {data, kind, tag, id}
  }

  onTagPressStreamExecute = () => {
    // tell the live stream host that we are shopping
    if (!this.streamViewData)
      return
    const {data, kind, tag, id} = this.streamViewData
    // console.log("this.streamViewData = " + JSON.stringify(this.streamViewData))
    console.log("is looking at " + tag.Title)
    const msg = "is looking at " + tag.Title + " 🛍"
    this.setState({shoppingFromLiveStream: msg})
    console.log(`onTagPressStreamExecute id: ${id}`)
    setTimeout(() =>
    this.onTagPress(data, kind, tag, id), 500) // leave time for the live stream to send a message out to tell host we are shopping
    // delay may not be needed if we can leave Agora RTM on when we push another screen on top the nav stack
    // see onBlur handler in LiveBroadcastScreen


  }

  streamLookingAt = (tag, id) => {
    console.log("is looking at " + tag.Title)
    const msg = "is looking at " + tag.Title + " 🛍"
    this.setState({shoppingFromLiveStream: msg})
    console.log(`onTagPressStreamExecute id: ${id}`)
  }

  streamExitShopping = () => {
    this.toggleStreamFullScreenMode()
  }

  createISellTagViews(post, imageWidth, imageHeight, showShopit, thumbUrl) {
    return post.ISell && post.ISell.map((entry, index) => {
      const { name, url, price } = this.findExtendedTagDetails(post.PostId, 'ISell', entry, entry.ISellId)
      let imageUrl = typeof entry.Image != 'undefined' && entry.Image.trim() ? entry.Image.trim().split('??')[0] : thumbUrl
      if (imageUrl == '__DEFAULT__')
        imageUrl = thumbUrl
      const tokenPrice = typeof entry.TokenPrice != 'undefined' ? entry.TokenPrice : null
      return  <Animated.View key={post.PostId + '_stv_' + index} style={{  transform : [{scale:this.state.tagPop.interpolate({inputRange:this.tagPopTimes,outputRange:this.tagPopSizes})}]
                                      , position : 'absolute', opacity : showShopit && entry.ISellId != this.pressedTagDetails.id? 0.25: 1, top : `${entry.Top}%`, left : `${entry.Left}%` }}>
                <TouchableOpacity style={{height:ALL_TAG_HEIGHT}} key={`TS${index}`} activeOpacity={0.8} onPress={( ) => this.onTagPress(post, 'ISell', entry, entry.ISellId)}>
                  <CaptionComponent isClose={false} data={{ Image: imageUrl }} text={name} rawPrice={entry.Price} price={price} tokenPrice={tokenPrice} isProduct/>
                </TouchableOpacity>
              </Animated.View>
    })
  } // createISellTagViews

  createDonateViews(post, imageWidth, imageHeight, showShopit) {
    return post.Donate && post.Donate.map((entry, index) => {
      const { name, url, price } = this.findExtendedTagDetails(post.PostId, 'Donate', entry, entry.CharityId)
      return  <Animated.View key={post.PostId + '_dv_' + index} style={{  transform : [{scale:this.state.tagPop.interpolate({inputRange:this.tagPopTimes,outputRange:this.tagPopSizes})}]
                                      , position : 'absolute', opacity : showShopit && entry.DonateId != this.pressedTagDetails.id? 0.25: 1, top : `${entry.Top}%`, left : `${entry.Left}%` }}>
                <TouchableOpacity style={{height:ALL_TAG_HEIGHT}} key={`DN${index}`} activeOpacity={0.8} onPress={( ) => this.onTagPress(post, 'Donate', entry, entry.DonateId)}>
                  <CaptionComponent isClose={false} data={{ ImageUrl: url }} text={entry.CharityName} price={price} isDonate/>
                </TouchableOpacity>
              </Animated.View>
    })
  } // createDonateViews

  createFundMeSummaryViews(post, imageWidth, imageHeight, showShopit, hasSound) {
    const radius = ALL_TAG_HEIGHT / 2
    const fromBottom = hasSound ? 95 : radius
    const detail = this.findExtendedTagDetails(post.PostId, 'FundMeSummary', null, null)
    if (!detail)
      return null
    const amountRaised = detail.amount + ` ` + I18n.t("editpost.raised")
    return  (
      <Animated.View style={{  transform : [{scale:this.state.tagPop.interpolate({inputRange:this.tagPopTimes,outputRange:this.tagPopSizes})}, {translateX: this.fundMeSummaryRight}]
                                , position : 'absolute', opacity : 1, bottom : fromBottom, right : 0}}
                      onLayout={(event) => { this.fundMeWidth = Math.max(this.fundMeWidth, event.nativeEvent.layout.width) }}>
        <TouchableOpacity  activeOpacity={0.8} onPress={( ) => this.onTagPress(post, 'FundMeSummary', detail, detail.DonateId)} style={{paddingLeft: 15, paddingRight: 10, height:ALL_TAG_HEIGHT, backgroundColor: '#a0fa01', borderTopLeftRadius: radius, borderBottomLeftRadius: radius, justifyContent: 'center', alignItems: 'center'}} key={`FM1`}>
          <Text style={{color: 'black', fontFamily: Fonts.style.font.bold, fontSize: 12}}>{amountRaised}</Text>
        </TouchableOpacity>
      </Animated.View>
    )
  } // createFundMeSummaryViews

  createFundMeSummaryStaticView(post, isLandscape, textShadowStyle = null) {
		const marginTop = isLandscape ?  4 : 0 // 0
		const height = ALL_TAG_HEIGHT / 2 // ALL_TAG_HEIGHT
		const radius = height / 2
		const backgroundColor = '#a0fa0166' // '#a0fa01'
		const color = 'white' // 'black'
		const fontFamily = Fonts.style.font.regular // Fonts.style.font.bold
		const detail = this.findExtendedTagDetails(post.PostId, 'FundMeSummary', null, null)
		console.tron.display({ name: `PostWallBase`, preview :`createFundMeSummaryStaticView, postId: ${post.PostId}`, value: { detail } })
    if (!detail)
      return null
    const amountRaised = detail.amount + ` ` + I18n.t("editpost.raised")
    return  (
			<TouchableOpacity  activeOpacity={0.8} onPress={( ) => this.onTagPress(post, 'FundMeSummary', detail, detail.DonateId)} style={{paddingLeft: 15, paddingRight: 10, height, backgroundColor, marginTop, borderTopLeftRadius: radius, borderBottomLeftRadius: radius, justifyContent: 'center', alignItems: 'center'}} key={`FMS1`}>
				<Text style={[{color, fontFamily, fontSize: 12}, textShadowStyle]}>{amountRaised}</Text>
			</TouchableOpacity>
    )
  } // createFundMeSummaryStaticView

	createUserTagViews(post, imageWidth, imageHeight, showShopit) {
    return post.UserTags && post.UserTags.map((entry, index) =>
        <Animated.View key={post.PostId + '_utv_' + index} style={{  transform : [{scale:this.state.tagPop.interpolate({inputRange:this.tagPopTimes,outputRange:this.tagPopSizes})}]
                                , position : 'absolute', opacity : showShopit && entry.DonateId != this.pressedTagDetails.id? 0.25: 1, top : `${entry.Top}%`, left : `${entry.Left}%` }}>
          <TouchableOpacity style={{height:ALL_TAG_HEIGHT}} key={`US${index}`} activeOpacity={0.8} onPress={( ) => this.onAvatarPress(entry.UserId, entry.Username)}>
            <CaptionComponent isClose={false} data={{ UserId : entry.UserId }} text={entry.Username} isAvatar/>
          </TouchableOpacity>
        </Animated.View>
    )
  } // createUserTagViews

  createLinkPostDetailView(viewMode, post) {
    let postType = typeof post.Type != 'undefined' ? post.Type : ''
      , meta = typeof post.Meta != 'undefined' ? post.Meta : null
    var url = ''
    if( meta ) {
      if( meta.domain ) url = meta.domain
      else if( meta.site_name ) url = meta.site_name
      else if( meta.url ) url = meta.url
      else url = meta.pasted_url
    }

    if (viewMode == LIST_MODE && postType > 0 && meta) {
      // https://reactnativecode.com/open-website-url-in-default-browser/
      let favIconUrl = meta.favicon && meta.favicon.length > 4 && meta.favicon.substr(-4) != 'ico' ? meta.favicon : ''
      for (i = 0; i < meta.favicons.length; i++)
        if (meta.favicons[i].substr(-4) != '.svg' && meta.favicons[i].substr(-4) != '.ico') {
          favIconUrl = meta.favicons[i]
          break
        }
      // console.log(`createLinkPostDetailView meta ` + JSON.stringify(meta))
      // console.log(`createLinkPostDetailView favIconUrl ${favIconUrl}`)
      return (
        <View style={{ height: 80, flexDirection: 'column', justifyContent: 'space-around', position: 'absolute', left: 0, right: 0, bottom: 0, opacity: 0.95, backgroundColor: 'rgb(239, 239, 239)', paddingLeft: 10, paddingRight: 10, borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          <Text numberOfLines={2} style={{ width: screenWidth - 20, textDecorationLine: 'underline', color: 'rgb(79, 82, 113)', fontWeight: 'bold' }}
            onPress={() => this.safariView(meta.pasted_url)}>{meta.title}</Text>
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            {favIconUrl.length > 0 && <Image
              key={`${post.PostId}_LP_Icon`}
              style={{ width: 20, height: 20, marginRight: 10 }}
              resizeMode="cover"
              source={{ uri: favIconUrl }} />}
            <Text numberOfLines={1} style={{ width: screenWidth - 80 }} onPress={() => this.safariView(meta.pasted_url)}>{url}</Text>
          </View>
        </View>
      )
    }
    return null
  } // createLinkPostDetailView

  createMusicDetailView(post, imageWidth, imageHeight, hasLinkPost) {
//       <LinearGradient colors={['transparent', 'rgba(255,255,255,.38)', 'rgba(255,255,255,.75)', 'rgba(255,255,255,.75)',  'rgba(255,255,255,.75)']} start={{ x : 0, y : 0 }} end={{ x : 0, y : 1 }}
//      <LinearGradient colors={['transparent', 'rgba(255,255,255,.09)', 'rgba(255,255,255,.38)', 'rgba(255,255,255,.75)', 'rgba(255,255,255,.75)',  'rgba(255,255,255,.75)']} start={{ x : 0, y : 0 }} end={{ x : 0, y : 1 }}
    const linkPostOffset = hasLinkPost ? 80 : 0
    const yOffset = hasLinkPost ? 140 : 60
    const height  = hasLinkPost ? 68 : 60 // behind rounded corners...
    const song    = post.Song
    // const playingThisSong = !this.props.musicSettings.muted && this.props.musicSettings.songDetails && this.props.musicSettings.songDetails.id && this.props.musicSettings.songDetails.id == song.id
    // const playingThisSong = !this.props.musicSettings.muted && typeof this.props.musicSettings.songDetails != 'undefined' && typeof this.props.musicSettings.songDetails.id != 'undefined' && this.props.musicSettings.songDetails.id == song.id
    let playingThisSong = false
    if (!this.props.musicSettings.muted)
      if (this.props.musicSettings.songDetails)
        if (this.props.musicSettings.songDetails.id)
          playingThisSong = this.props.musicSettings.songDetails.id == song.id
    const showMusicLottie = false // playingThisSong && !this.props.options.pauseMusicLottie
    const rotateAlbum = playingThisSong && !this.props.options.pauseMusicRotation && !this.props.slowNetwork
    const displayAlbumArt = true && !this.props.options.skipAlbumArt
    const animateSong = !this.props.options.skipSongAnimation
    const animatedTitle = playingThisSong && !this.props.options.pauseMusicLottie && !this.props.slowNetwork && animateSong
    this.musicStyle = {width: 32, height: 32, borderRadius: 16, marginLeft: 15}
// <Text style={{fontSize: 15, lineHeight: 22, color: 'black', width: screenWidth - 108}} numberOfLines={1}>{song.song + " by " + song.artist}</Text>
// <LinearGradient colors={['transparent', 'rgba(255,255,255,.19)', 'rgba(255,255,255,.38)', 'rgba(255,255,255,.75)', 'rgba(255,255,255,.75)',  'rgba(255,255,255,.75)']} start={{ x : 0, y : 0 }} end={{ x : 0, y : 1 }}
// <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems:'center', width: '100%', marginTop: 20, height: 50, padding: 5}}>
// screenWidth - 108 - 150
//         <LinearGradient colors={['rgba(255,255,255,0)', 'rgba(255,255,255,0.80)', 'rgba(255,255,255,0.95)']} locations={[0,.50,1]} start={{ x : 0, y : 0 }} end={{ x : 0, y : 1 }}
//          style={{position : 'absolute', top : imageHeight - yOffset, left : 0, width: '100%', height: height}}>
// imageStyle={{width: '100%', height: height}} 

    return post.Song &&
      <>
        <View style={{position: 'absolute', top: imageHeight - yOffset, left: 0, width: '100%', height: height}}>
          <ImageBackground resizeMode='stretch' source={Images.wallMusicBackground} style={{width: '100%', height: height}}>
            <View style={{display: 'flex', flexDirection: 'row', alignItems:'center', width: '100%', marginTop: 10, height: 50, padding: 5, paddingLeft: 15}}>

              {!animatedTitle &&
                <Text style={{marginTop: 10, fontSize: 14, lineHeight: 18, color: 'black', width: (screenWidth - 10) / 2}} numberOfLines={1}>{song.song + " by " + song.artist}</Text>}

              {animatedTitle && <Text style={{marginTop: 10, fontSize: 14, lineHeight: 18, color: 'black', width: (screenWidth - 10) / 2}}
                duration={3000} marqueeOnStart loop marqueeDelay={1000} marqueeResetDelay={1000}>
                {song.song + " by " + song.artist}
              </Text>}
              
              <View style={{width: (screenWidth - 10) / 2 - 100}}></View>

              {displayAlbumArt && <Image key={'animated' + post.PostId} rotating={animateSong && rotateAlbum} rotationSpeed={7000}
                style={this.musicStyle} source={{uri: song.imageUrl}} />}

              {!displayAlbumArt && <View style={this.musicStyle}></View>}
            </View>
          </ImageBackground>
        </View>
        {showMusicLottie &&
          <View style={{overflow: 'hidden', width: lottieSize, height: lottieSize, position: 'absolute', top: imageHeight - linkPostOffset - lottieSize, right: 0, borderWidth: 0, borderColor: 'orange'}}>
            {this.musicNotesAnimationView}
          </View>}

        <TouchableOpacity activeOpacity={0.8} style={{position: 'absolute', top: imageHeight - yOffset + 24, right: 10, width: 26, height: 26}} onPress={this.onSoundToggle} >
          <Image style={{width: 26, height: 26, borderRadius: 13}} source={this.isMuted() ? Images.soundOffBlack : Images.soundOnBlack}/>
        </TouchableOpacity>

      </>
  } // createMusicDetailView

  findExtendedTagDetails = (postId, kind, postTag, itemId) => {
    console.tron.log(`findExtendedTagDetails postId: ${postId}, kind: ${kind}, itemId: ${itemId}, postTag: ` + JSON.stringify(postTag))
    let details = {}
    let price = 0
    let currency = 'USD'
    const tagDetails = this.props.order.postId == postId ? this.props.order.tags : null
    const rates = this.props.exchangeRates.rates
    const userCurrency = this.props.auth.user && this.props.auth.user.Currency ? this.props.auth.user.Currency : 'USD'
    switch (kind) {
      case 'ISell':
        price = postTag.Price
        if (typeof postTag.Currency != 'undefined')
          currency = postTag.Currency
        details = { name: postTag.Name, url: '', price: `$${postTag.Price}`, complete: null }
        // return details // nothing else is needed
        break
      case 'TheySell':
        if (typeof postTag.Currency != 'undefined')
          currency = postTag.Currency
        details = { name: postTag.Title, url: '', price: ` `, complete: null }
        break
      case 'Donate':
        price = postTag.Amount
        details = { userName: postTag.Username, name: postTag.CharityName, url: '', price, rawPrice: postTag.Amount, itemId } // CharityId url
        if (postTag.FundMe)
          details.userName = tagDetails && tagDetails.FundMeSummary && tagDetails.FundMeSummary.length ? tagDetails.FundMeSummary[0].Username : ''
        console.tron.log(`findExtendedTagDetails details: ` + JSON.stringify(details))
        break
      case 'FundMeSummary':
        details = null
        if (tagDetails && tagDetails.FundMeSummary && tagDetails.FundMeSummary.length) {
          const entry = tagDetails.FundMeSummary[0]
          console.tron.display({ name: `PostWallBase`, preview :`findExtendedTagDetails`, value: { entry } })
          let amount = 0
          if (rates)
            amount = localPrice(entry.DonationsTotal, entry.Currency, rates, userCurrency).formatted
          else
            amount = i18nCurrency(entry.DonationsTotal, entry.Currency, {extended: true})
          details = { amount }
        }
        return details
        break;
    }

    details.price = i18nCurrency(price, currency, {extended: true})

    if (true) {
      if (tagDetails) {
        // console.tron.log(`findExtendedTagDetails has tags`)
        if (tagDetails.TheySell)
          tagDetails.TheySell.forEach((extended, i) => {
            if (extended.ItemId == itemId) {
              // console.tron.log(`findExtendedTagDetails found TheySell itemId: ${itemId}, extended: ${JSON.stringify(extended)}`)
              const url = typeof extended.Image == 'undefined' ? extended.ImageUrl : extended.Image
              const noRange = extended.PriceMin == extended.PriceMax
              const priceMin = i18nCurrency(extended.PriceMin, currency, {extended: true})
              const priceMax = i18nCurrency(extended.PriceMax, currency, {extended: true})
              const priceStr = noRange ? priceMin : `${priceMin}-${priceMax}`
              details = { name: extended.Title, url: this.httpToHttps(url), price: priceStr, complete: typeof extended.Complete != 'undefined' ? extended.Complete : null }
            }
          })
        if (tagDetails.ISell)
          tagDetails.ISell.forEach((extended, i) => {
            if (extended.Id == itemId) {
              // console.tron.log(`findExtendedTagDetails found iSell itemId: ${itemId}, extended: ${JSON.stringify(extended)}`)
              const url = typeof extended.Image == 'undefined' ? extended.ImageUrl : extended.Image
              const noRange = extended.PriceMin == extended.PriceMax
              const priceMin = i18nCurrency(extended.PriceMin, currency, {extended: true})
              const priceMax = i18nCurrency(extended.PriceMax, currency, {extended: true})
              const priceStr = noRange ? priceMin : `${priceMin}-${priceMax}`
              details = { ...extended, name: extended.Title, Description: extended.Complete.Color, url: this.httpToHttps(url), price: priceStr }
            }
          })
        if (tagDetails.Donate)
          tagDetails.Donate.forEach((extended, i) => {
            if (extended.CharityId == itemId)
              details = {
                name: extended.CharityName, url: this.httpToHttps(extended.ImageUrl),
                price: i18nCurrency(postTag.Amount, currency, {extended: true}),
                rawPrice: postTag.Amount,
                itemId
              }
          })
      }
    }
    // console.tron.log(`findExtendedTagDetails postId: ${postId}, kind: ${kind}, itemId: ${itemId}, details: ${JSON.stringify(details)}`)
    return details
  }

  rowRenderer_UNUSED(type, data, index, viewMode) {
    console.tron.log(`rowRenderer_UNUSED index: ${index}`)
    if (this.state.viewMode != viewMode)
      return null

    let userName = ''
    if (![ViewTypes.GRID_LEFT, ViewTypes.GRID_MIDDLE, ViewTypes.GRID_RIGHT].includes(type)) {
      if (typeof data.Username != 'undefined')
        userName = data.Username
      else if (typeof this.userNames[data.UserId] != 'undefined')
        userName = this.userNames[data.UserId]
    }

    return (
      <PostWa llRow
        visible={this.state.visible}
        type={type}
        data={data}
        userName={userName}
        index={index}
        viewMode={viewMode}
        order={this.props.order}
        options={this.props.options}
        showKargoeTagsPostId={this.state.showKargoeTagsPostId}
        onAvatarPress={() => this.onAvatarPress(data.UserId, userName)}
      />
    )
  }

  indexToRefHash(index) {
    // so that component refs within this do not get too numerous
    return index % 30
  }

  /* from RN doc:

  Note that when the referenced component is unmounted and whenever the ref changes,
  the old ref will be called with null as an argument.
  This prevents memory leaks in the case that the instance is stored,
  as in the second example. Also note that when writing refs with inline function expressions
  as in the examples here, React sees a different function object each time so on every update,
  ref will be called with null immediately before it's called with the component instance.
  */

  // hence, we make this a non-inline function to avoid this being called so much esp w/ null ref
  // when it is not actually null.  we only want it called by null when the video component is unmounted

  // not used

  EXPERIMENTstoreVideoRef(ref) {
    if (this.state.currVideoPlayIndex == index && !this.videoInTransition && !this.currentlyPlayingVideoFullscreen) {
      if (ref) {
         //console.log("for wall index " + index + " setting currently playing video to " + JSON.stringify(ref.props))

         if (ref.props && ref.props.source) {

           // if uri has changed, close prior
           if (this.currentlyPlayingVideoUri && (this.currentlyPlayingVideoUri != ref.props.source.uri)) {
             if (this.currentlyPlayingVideo) {
               //console.log("dismiss full screen player loc 3")
               if (this.currentlyPlayingVideoFullscreen && !this.videoInTransition) {
                 this.currentlyPlayingVideo.dismissFullscreenPlayer()
                 // this.presentedFullScreenAtOffsetY
                 this.currentlyPlayingVideoFullscreen = false
               }

             }
           }

          this.currentlyPlayingVideoUri = ref.props.source.uri

         }

         this.currentlyPlayingVideo = ref
         this.currentlyPlayingVideoIsTilt = (postMediaType === '3D')

      }
      else {
         console.log("SHOULD BE clearing currentlyPlayingVideo")
         // note:  was working if we commented out this, but crashes
         // w/ red screen on dismissFullscreenPlayer
         this.currentlyPlayingVideo = ref
         this.currentlyPlayingVideoIsTilt = false
      }

    }
  }

  onVideoPlayPress(data, index) {
     console.log('on video play press')
     // maybe need to set 'details' see other playVideo func
     if (this.state.currLongVideoPlayIndex != index)
       this.setState({ currLongVideoPlayIndex: index }) // play
     else
       this.setState({ currLongVideoPlayIndex: -1 }) // pause
  }

  getVideoDuration = (postId) => {
    if (typeof this.videoDurationByPostId[postId] == 'undefined')
      return null
    return this.videoDurationByPostId[postId]
  }

  setVideoDuration = (postId, duration) => {
    let changed = false
    if (typeof this.videoDurationByPostId[postId] == 'undefined' || this.videoDurationByPostId[postId] != duration) {
      changed = true
      this.videoDurationByPostId[postId] = duration
    }
    return changed
  }

  // note that videoDuration values come in rolling asych, not available at initial render
  // tenative logic, probably should put whether to auto play or not in mini post record
  shouldHidePlayButton(postId, index) {
    // return true // TO DEBUG SCROLL GLITCH, ALWAYS HIDE PLAY BUTTON
    let hidePlayButton = true
    if (this.props.options.noLongVideoPlayButton)
      return hidePlayButton
    
    const duration = this.getVideoDuration(postId)
    if (duration !== null) {
      // 2nd clause:  if this is the currently playing video, keep the play button hidden
      if (duration > MAX_AUTOPLAY_VID_TIME && this.state.currLongVideoPlayIndex !== index)
        hidePlayButton = false
    }
    else // duration not defined yet (not read-in) so assume it is long video and do not hide play button
      hidePlayButton = false

    return hidePlayButton
  }

  fullScreenSetAutoAdvance = (setting = null) => {
    if (setting == null)
      this.setState({fullScreenAutoAdvance: !this.state.fullScreenAutoAdvance})
    else
      this.setState({fullScreenAutoAdvance: setting})
	}

  fullScreenToggleMode = () => {
		if (this.state.fullScreenDetailMode == 'new_comment') {
			this.setState({fullScreenDetailMode: '', newComment: ''})
			this.fullScreenResetDetailFadeTimer()
			this.setState({fullScreenPaused: false})
			this.unmuteSound() // music
		}
		else {
			switch (this.fsDetailState) {
				case 'fadeOutTimer':
					this.fullScreenClearDetailFadeTimer()
					this.fullScreenFadeDetailNow()
					break
				case 'fadingOut':
				case 'hidden':
					this.fullScreenResetDetailFadeTimer()
					break
				case 'fadingIn':
				case 'showing':
					this.fullScreenFadeDetailNow()
					break
			}
		}
/*
		else if (this.state.fullScreenDetailMode == 'bare')
      this.setState({fullScreenDetailMode: ''})
    else
			this.setState({fullScreenDetailMode: 'bare'})
*/			
  }

  formatTwoDigits(number) {
    return number < 10 ? '0' + number : number
  }

  formatTime(duration) {
    const totalSeconds = Math.floor(duration)
    const minutes = Math.floor(duration / 60)
    const seconds = totalSeconds % 60
    const formatted = this.formatTwoDigits(minutes) + ':' + this.formatTwoDigits(seconds) //  + '.' + Math.round(10 * (duration - Math.floor(duration)))
    // console.log(`formatTime duration`, duration, `formatted`, formatted, 'progress', this.state.fullScreenVideoProgress)
    return formatted
	}
	
	fullScreenUpdateVideoProgress(seconds) {
		seconds = Math.round(seconds * 100) / 100
		console.log(`fullScreenUpdateVideoProgress ${seconds}`)
		if (typeof this.fullScreenVideoRef[this.state.currFullScreenVideoPlayIndex] != 'undefined') {
			this.fullScreenVideoRef[this.state.currFullScreenVideoPlayIndex].seek(seconds)
			// this.state.fullScreenVideoProgress = value
			this.setState({fullScreenVideoProgress: seconds}) // update slider quickly...
		}
	}

	fullScreenVideoOnEnd = (index, isLastPost, screenLandscape) => {
		console.log(`rowRendererFullScreen onEnd index: ${index} isLastPost: ${isLastPost}`)
		Keyboard.dismiss()
		if (this.state.fsInnerScrolling) // make sure we don't stop manual scrolling
			this.setState({ fsInnerScrolling: false })
		if (this.state.fullScreenAutoAdvance) {
			if (typeof this.fullScreenVideoRef[index] != 'undefined') {
				console.log(`rowRendererFullScreen seek`)
				this.fullScreenVideoRef[index].seek(0)
			}
			//     "recyclerlistview": "^1.4.0-beta.5",
			if (!isLastPost) {
				console.log(`rowRendererFullScreen onEnd index: ${index} ScrollTo: ${index+1} Land: ${!!this.fullScreenScrollViewLandscape ? 'T' : 'F'} Port: ${!!this.fullScreenScrollViewPortrait ? 'T' : 'F'}`)
				if (screenLandscape)
					this.fullScreenScrollViewLandscape.scrollToIndex(index + 1, true)
				else
					this.fullScreenScrollViewPortrait.scrollToIndex(index + 1, true)
/*
				if (screenLandscape)
					this.fullScreenScrollView.scrollToOffset((index + 1) * screenWidth, 0, true)
				else
					this.fullScreenScrollView.scrollToOffset(0, (index + 1) * screenHeight, true)
*/								
			}
		}
	}

	keepLoveLayoutFromEvent = (layout) => {
		this.loveLayoutFromEvent = Object.assign({}, layout)
	}

	fullScreenTagsTap = (post, index) => {
		const showTags = this.state.fullScreenDetailMode != 'tags'
		if (showTags && this.props.order.postId != post.PostId || this.props.order.modified < post.Modified)
			this.props.tagDetails(post.PostId)
		this.setState({fullScreenDetailMode: showTags ? 'tags' : '', fullScreenPaused: showTags})
		if (showTags) {
			this.onFullScreenShowTags(post, index)
			this.fullScreenClearDetailFadeTimer()
			this.muteSound()
		}
		else {
			this.onFullScreenHideTags(post)
			this.fullScreenResetDetailFadeTimer()
			this.unmuteSound()
		}
	}

	_keyboardDidShow = () => {
    this.keyboardIsShowing = true
		if (this.state.viewMode == FULL_SCREEN_MODE)
			this.enterAddNewCommentMode()
	}

	_keyboardDidHide = () => {
    this.keyboardIsShowing = false
	}

	enterAddNewCommentMode = () => {
		this.setState({fullScreenPaused: true, fullScreenDetailMode: 'new_comment'})
		this.muteSound()
		this.fullScreenClearDetailFadeTimer()
	}

  // vis-a-vis:  https://stackoverflow.com/questions/3733227/javascript-seconds-to-minutes-and-seconds

  secondsToMinSec(time) { // pass in number in seconds, floating pt ok
        let minutes = Math.floor(time / 60)
        let seconds = Math.round(time - minutes * 60)
        const zeroPad = (num, places) => String(num).padStart(places, '0')
        durationText = zeroPad(minutes, 2) + ':' + zeroPad(seconds, 2)
        return durationText
  }
	addNewComment = (postId) => {
		const comment = this.state.newComment.trim()
		console.tron.log(`addNewComment, postComment postId: ${postId} comment ${comment}`)
		Keyboard.dismiss()
		// return
    if (true || (typeof comment === 'string' && comment.length > 0)) {
			// this.setState({ sending: true })
			if (comment.length)
				this.props.postComment({postId, body: comment})
			this.setState({fullScreenDetailMode: '', newComment: '', fullScreenPaused: false})
			this.unmuteSound()
			this.fullScreenResetDetailFadeTimer()
		}
	}

	fullScreenLovePress = (e, post, index) => {
		this.fullScreenResetDetailFadeTimer()
		this.onLovePress(e, post, index, 'fsvideo')
	}

	onChangeComment = (newComment) => {
		// this.setState({newComment})
		this.setState({newComment, fullScreenPaused: true, fullScreenDetailMode: 'new_comment'})
		this.muteSound()
		this.fullScreenClearDetailFadeTimer()
	}

	loadMoreComments = (PostId) => {
		if (this.fsLoadingCommentsPostId == PostId)
			return
		console.tron.log(`loadMoreComments PostId: ${PostId}`)
		this.fsLoadingCommentsPostId = PostId
		const params = {
			postId: PostId,
			start: '', // this.state.start, - future pagination
			limit: 100, // this.state.limit
		}
		this.props.getPostComments(params)
		this.fullScreenResetDetailFadeTimer()
	}

	lockFullScreenMainScroll = () => {
		this.setState({ fsInnerScrolling: true })
		this.unlockFullScreenMainScroll(1000)
	}

	unlockFullScreenMainScroll = (delay = 500) => {
		// this.setState({ fsInnerScrolling: false })
		if (this.fullScreenScrollLockTimeout)
			clearTimeout(this.fullScreenScrollLockTimeout)
		this.fullScreenScrollLockTimeout = setTimeout(() => {
			this.setState({ fsInnerScrolling: false })
			clearTimeout(this.fullScreenScrollLockTimeout)
			this.fullScreenScrollLockTimeout = null
		}, delay)
	}

  fullScreenToStreamMode = (post) => {
    this.exitFullScreenMode(post.PostId)
    this.onPressShowStreamView(post)
  }

  onPressShowStreamView = (post) => {
    console.log(`onPressShowStreamView post`)
    // negative index means it won't match, do it again and video starts playing once more
    let playIndex = Math.abs(this.state.currVideoPlayIndex)
    this.streamViewData = null
    if (post) {
      if (playIndex == 0)
        playIndex = 'first' // -0 == 0
      
      // this.props.tagDetails(post.PostId) // done within LiveBroadcastScreen Mount
      this.setState({streamFullScreenPost: post, streamFullScreenMode: '', currVideoPlayIndex: -playIndex})
      this.clearSong()
      // this.streamRandomHearts()
    }
    else {
      // closing stream view 

      // if (this.streamRandomHeartsTimeout)
      //  clearTimeout(this.streamRandomHeartsTimeout)
      // this.streamRandomHeartsTimeout = null

      // refresh post in case stream view updated it w/ new StreamURL
      // last state should have this set up 
      const PostId = this.state.streamFullScreenPost ? this.state.streamFullScreenPost.PostId : ''

      const options = {
        PostId: PostId,
        PostIds: [PostId],
        GetLikes: true
      }
      console.log("coming back from live stream, re-get data for PostId = " + PostId)
      this.props.readPosts(options)

      this.justSavedStreamPostId = PostId

      // this was already here
      this.setState({streamFullScreenPost: post, currVideoPlayIndex: playIndex, videoKeyBump : this.state.videoKeyBump + 1})
    }
    this.props.setCameraLockout(post != null)
  }

  changeStreamFullScreenMode = (newMode) => {
    console.log("XXX change stream full screen mode to " + newMode)
    this.setState({streamFullScreenMode: newMode})
  }

  // toggle among 3 states , none is needed for dual view video, chat hides the bottom video
  // '' = default show chat
  // 'tags' = show product tags
  // 'none' = hide chat
  toggleStreamFullScreenMode = () => {
    console.log("XXX toggle stream full screen mode")

    // next mode as a key of current mode
    const nextMode = {     '' : 'tags',
                       'tags' : 'none',
                       'none' : ''
    }

    this.changeStreamFullScreenMode(nextMode[this.state.streamFullScreenMode])
  }

  streamRandomHearts = () => {
    if (!this.streamRandomHeartsTimeout) {
      this.streamRandomHeartsTimeout = setTimeout(() => {
        clearTimeout(this.streamRandomHeartsTimeout);
        this.streamRandomHeartsTimeout = null;
        if (this.loveAnimation && this.loveAnimation.playing)
          ;
        else
          this.onStreamLoveActivate()
        this.streamRandomHearts() // again
      }, 500 + 2500 * Math.random())
    }
  }

  renderStreamTextRow = (entry) => {
    let {UserId, Username, Message, UserColor = 'rgb(0,153,255)', MessageColor = 'white'} = entry
    const textShadowStyle = {shadowOffset: { width: 0, height: 0 }, shadowRadius : 1.5, shadowOpacity: 1, shadowColor: 'black'}
    const avatarSize  = 22
    const avatarBorder = 1
    const containerStyle = {
      flexDirection: 'row',
    }
    const textWrapperStyle = {
      width: screenWidth - 50,
      ...textShadowStyle
    }
    const avatarStyle = {
      margin: 2,
      marginRight: 8,
      borderWidth: avatarBorder,
      borderColor: 'white',
    }
    const usernameStyle = {
      color: UserColor,
      fontSize: 15,
      ...textShadowStyle
    }
    const messageStyle = {
      color: MessageColor,
      fontSize: 15,
      ...textShadowStyle
    }
    return (
      <View style={containerStyle}>
        <AvatarComponent style={avatarStyle} userId={UserId} size={avatarSize}/>
        <Text style={textWrapperStyle}>
          <Text style={usernameStyle}>{`${Username}: `}</Text>
          <Text style={messageStyle}>{Message}</Text>
        </Text>
      </View>
    )
  }

  renderStreamFullScreen = () => {
    console.log(`renderStreamFullScreen`)
    const post = this.state.streamFullScreenPost
    const containerStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: screenWidth,
      height: screenHeight,
      backgroundColor: 'black',
    }
    return null
    return (
      <LiveBroadcastScreen ref={(ref) => console.log("got live broadcast ref = " + ref)} 
        key={"liveVideoKey_fullscreen"} 
        style={containerStyle} 
        post={post}
        postId={post.PostId} 
        paused={true/*!playThisVideo*/} 
        viewableByUser={/*playThisVideo*/true}
        postUsername={post.Username} 
        postUserId={post.UserId}
        onHideCloseButton={(x) => {
            console.log("on hide close button " + x)
            this.setState({hideLiveStreamCloseButton : x})
          }
        }
        onBroadcastStateChanged={(x) => {
          // dont have an easy way to trigger this yet so just do a lookup
          if (x != this.state.isPostBroadcasting[post.PostId]) { // just do != so we dont have to init this obj
            // dont trigger state change if it's the same value
            this.state.isPostBroadcasting[post.PostId] = x
            this.setState({ forceUpdate: this.state.forceUpdate + 1 })
          }
        }}
        onAvatarPress={this.onAvatarPress}
        onPressShowStreamView={this.onPressShowStreamView}
        onStreamLoveActivate={this.onStreamLoveActivate}
        findExtendedTagDetails={this.findExtendedTagDetails}
        onDonatePress={this.onDonatePress}
        navigation={this.props.navigation}
      >
      </LiveBroadcastScreen>
    )
  } // renderStreamFullScreen

  postIsStreamAvailable = (post) => {
    if (!post)
      return false
    const {StreamStatus = 0} = post
    return false
    return (StreamStatus != LiveBroadcastScreen.POST_STREAM_STATUS_NOT_A_STREAM) && (StreamStatus != LiveBroadcastScreen.POST_STREAM_STATUS_DONE)
  }

  rowRendererFullScreen = (type, post, index, extendedState = null, includeOverlay = true) => {
		let slowNetwork = this.props.slowNetwork
    const {adjustsFontSizeToFit = true, allowFontScaling = true} = this.props
    let {PostId, UserId, AspectRatio, MediaType, Version, TimeStamp, Caption = '', NumViews = null, NumLikes = null, NumComments = null, 
			RecentComments = [], LoadedMoreComments = false, UserLovesPost = null, TheySell = null, ISell = null, Donate = null, StreamStatus = 0} = post
    if (post.StreamURL) AspectRatio = 640/1138 // common saved aspect ratio for live stream posts
    const isStreamingAvailable = this.postIsStreamAvailable(post)
		const drawingCurrentPlayingPost = this.state.currFullScreenVideoPlayIndex == index
		const loveAnimationThisPost = this.state.animatedLove && this.lastPostLove && this.lastPostLove.Kind == 'fsvideo' && this.lastPostLove.PostId === PostId
		const loveAnimationView = loveAnimationThisPost ? this.heartsAnimation : null
    const allPosts     = this.state.dataProviderFullScreen._data
    const isLastPost   = index == allPosts.length - 1
    const screenWidth  = extendedState.screenWidth
    const screenHeight = extendedState.screenHeight
    const screenAspect = screenWidth / screenHeight
		const screenLandscape = screenAspect > 1
		const rowKey    = (screenLandscape ? 'FS_H': 'FS_V') + PostId
    const landscape = AspectRatio > 1
    const videoUrl  = post.StreamURL ? post.StreamURL : `${KargoeConfig.baseUrlMedia}/${PostId}.mp4?${Version}`
		const imageUrl  = `${KargoeConfig.baseUrlMedia}/${PostId}.jpg?${Version}`
    const thumbUrl  = `${KargoeConfig.baseUrlMedia}/${PostId}-thumb.jpg?${Version}`
    const rand      = Math.sin(1000 * Math.floor(TimeStamp)) * 100000
    const tileIndex = Math.floor(Colors.cellbg.length * (rand - Math.floor(rand)))
    const tileColor = 'black' // 'white' // layout debugging
    const textBgColor = 'rgba(64,64,64,0.20)'
    const textBoxStyle = {
      backgroundColor: textBgColor,
      borderRadius: 6,
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 5,
      paddingRight: 5,
      marginTop: 7,
		}
		const leftRightOverlayMargin = 20
		const textFontSize = 13
		const textLineHeight = 15
		const albumFontSize = textFontSize + 2
		const albumLineHeight = 18
    this.statViewStyle = {flexDirection: 'row', paddingRight: 10, textAlign: screenLandscape ? 'right' : 'left'}
    this.fsEyeStyle = {width: 42, height: 30}
		this.iconStyle = {width: 26, height: 26}
		const textShadowStyle = {shadowOffset: { width: 0, height: 0 }, shadowRadius : 3, shadowOpacity: 1, shadowColor: 'black'}
    const counterTextStyle = [{color: 'white', fontSize: textFontSize, width: 35}, textShadowStyle]
    let imageWidth = screenWidth
    let imageHeight = Math.round(imageWidth / AspectRatio)
    if (screenLandscape && landscape) {
			if (screenAspect > AspectRatio) {
				imageHeight = screenHeight
				imageWidth = Math.round(imageHeight * AspectRatio)
			}
		}
		else if (screenLandscape != landscape)
      if (screenLandscape) {
        // portrait image on landscape screen
        imageHeight = screenHeight
        imageWidth  = Math.round(imageHeight * AspectRatio)
      }
      else {
        // landscape image on portrait screen
        imageWidth  = screenWidth
        imageHeight = Math.round(imageWidth / AspectRatio)
			}
		const portrait9x16Aspect = 0.563
		if (isIPhoneX() && !screenLandscape && Math.abs(AspectRatio - portrait9x16Aspect) < .1) {
			// full height video for 'tall' iPhones
			imageWidth  = screenWidth
			imageHeight = screenHeight
	}

		let userName = ''
		if (typeof post.Username != 'undefined') {
			userName = post.Username
			if (typeof this.userNames[post.UserId] == 'undefined')
			this.userNames[post.UserId] = userName
		}
		else if (typeof this.userNames[post.UserId] != 'undefined')
			userName = this.userNames[post.UserId]
	
		const switchModePosition = { position: 'absolute', left: screenLandscape ? leftRightOverlayMargin : 30, top: screenLandscape ? 5 : (isIPhoneX ? 55 : 25) }
		const switchModeStyle = { width: 34, height: 34, borderRadius: 6, backgroundColor: 'transparent', alignItems : 'center', justifyContent: 'center' }
    let switchViewMode = (
			<Animated.View pointerEvents="box-none" style={[switchModePosition, {opacity: this.fsDetailFadeInOut}]}>
				<TouchableOpacity activeOpacity={1} onPress={() => this.exitFullScreenMode(PostId)} style={switchModeStyle}>
					<Image source={Images.fsBackArrowWhite} style={{width: 34, height: 34}}/>
				</TouchableOpacity>
			</Animated.View>
    )

    const switchStreamPosition = { position: 'absolute', right: screenLandscape ? leftRightOverlayMargin : 30, top: screenLandscape ? 5 : (isIPhoneX ? 55 : 25) }
		const switchStreamStyle = { width: 60, height: 34, borderRadius: 6, backgroundColor: 'green', borderRadius: 8, alignItems : 'center', justifyContent: 'center' }
    let switchStreamMode = isStreamingAvailable ? (
			<Animated.View pointerEvents="box-none" style={[switchStreamPosition, {opacity: this.fsDetailFadeInOut}]}>
				<TouchableOpacity activeOpacity={1} onPress={() => this.fullScreenToStreamMode(post)} style={switchStreamStyle}>
					<Text style={{color: 'white', textSize: 16}}>{`Stream`}</Text>
				</TouchableOpacity>
			</Animated.View>
    ) : null

		const hasLinkPostDetail = false // linkPostDetail != null
		const isMuted = this.isMuted()
		const animatedTitle = !isMuted
		const song = !slowNetwork && post.Song ? post.Song : null
		const hasSong = song != null
		const muteVideo = !!song
		const songWidth = !song ? 0 : (screenLandscape ? screenWidth * 2 / 5 : screenWidth)
		const progSongGap = screenLandscape ? 33 : 0
		// paddingLeft: 13 + progSongGap
		const songDetailView = !song ? null : (
			<View style={{backgroundColor: 'transparent', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems:'center', flex: 1, /* width: songWidth - 20, */ marginTop: 0, height: 32, padding: 0, paddingLeft: progSongGap}}>
				{!animatedTitle &&
					<Text style={[{fontSize: albumFontSize, lineHeight: albumLineHeight, color: 'white', width: (songWidth - 10) / 2}, textShadowStyle]} numberOfLines={1}>{song.song + " by " + song.artist}</Text>}
				{animatedTitle && <Text style={[{fontSize: albumFontSize, lineHeight: albumLineHeight, color: 'white', width: (songWidth - 10) / 2}, textShadowStyle]}
					duration={3000} marqueeOnStart loop marqueeDelay={1000} marqueeResetDelay={1000}>
					{song.song + " by " + song.artist}
				</Text>}
				<View style={{width: 32, height: 32, backgroundColor: 'transparent'}}>
					<Image key={'animated' + post.PostId} rotating={drawingCurrentPlayingPost && !isMuted} rotationSpeed={7000}
						style={{width: 32, height: 32, borderRadius: 16, borderWidth: 1.25, borderColor: 'white'}} source={{uri: song.imageUrl}} />
					<TouchableOpacity activeOpacity={0.8} style={{position: 'absolute', top:0, left: 2, width: 32, height: 32, alignItems : 'center', justifyContent: 'center'}} onPress={this.onSoundToggle}>
						<Text style={{fontSize: 32, lineHeight: 32, color: 'black', fontWeight: 'bold', shadowOffset: { width: 0, height: 0 }, shadowRadius : 3, shadowOpacity: 1, shadowColor: 'white'}}>{isMuted ? `▸` : ``}</Text>
					</TouchableOpacity>
				</View>
			</View>
		)

		// console.tron.log(`rowRendererFullScreen post url: ${videoUrl}`)
		// console.tron.display({name: 'rowRendererFullScreen', preview: "extendedState", value: extendedState})
    const backgroundImage = null
    //console.log("before <Video poster url = " + imageUrl)
    let pausedFlag = this.state.fullScreenPaused || !drawingCurrentPlayingPost
    let posterUrl = this.props.options.useVideoPosterFile ? thumbUrl : null
    // note:  poster image is handled at native level now, so posterResizeMode may not be used
    // full screen
      const postMedia = !slowNetwork ? (
      <Video
        key={rowKey + '_v'}
        style={{ flex: 1 }}
				resizeMode="cover"
        posterResizeMode="cover"
        poster={posterUrl}
        adjacentUrls={[]}
        NO_BAD_preload={this.props.options.preloadVideoBeforePlaying}
        source={{ uri: videoUrl /*imageUrl*/ }}
        paused={pausedFlag}
        ref={(ref) => {this.fullScreenVideoRef[index] = ref; this.currentlyPlayingVideoRef = ref}}
        repeat={!this.state.fullScreenAutoAdvance}
        muted={muteVideo}
        volume={1}
        controls={false}
        isTilt={false /* MediaType === '3D' */}
        progressUpdateInterval={250 /* 100 no progress, 106%, drawing too slow... 250 default ms */}
        onProgress={(progress) => {

          if (post.StreamURL) {
            if (progress.playableDuration - progress.currentTime < streamVidCutOut) { // chop off last few seconds and restart
              if (this.currentlyPlayingVideoRef) {
                this.currentlyPlayingVideoRef.seek(streamVidCutIn) // rewind
              }
            }
          }

          const currVideoTime = progress.currentTime.toFixed(2)
          // console.log(`Rotation full screen progress called ${currVideoTime}s`)
					// currentTime, seekableDuration
					if (!this.state.fullScreenProgressDragging && drawingCurrentPlayingPost) {
            const currPlayIndex = this.state.currFullScreenVideoPlayIndex
            // check if we rotated, continue where we left off
            if (this.state.fullScreenVideoProgress != currVideoTime)
              this.setState({fullScreenVideoProgress: currVideoTime})
            if (screenLandscape) {
              if (this.fullScreenPortraitProgress && this.fullScreenPortraitProgress.playIndex == currPlayIndex) {
                this.fullScreenUpdateVideoProgress(this.fullScreenPortraitProgress.progress)
                this.fullScreenPortraitProgress = null
              }
              else
                this.fullScreenLandscapeProgress = {
                  playIndex: currPlayIndex,
                  progress: currVideoTime
                }
            }
            else {
              if (this.fullScreenLandscapeProgress && this.fullScreenLandscapeProgress.playIndex == currPlayIndex) {
                this.fullScreenUpdateVideoProgress(this.fullScreenLandscapeProgress.progress)
                this.fullScreenLandscapeProgress = null
              }
              this.fullScreenPortraitProgress = {
                playIndex: currPlayIndex,
                progress: currVideoTime
              }
            }
          }
          //console.log(`rowRendererFullScreen video onProgress`) 
          //console.log(progress)
        }}
        onLoad={(loadData) => {
          //alert('on load video loc 3')
          console.log("on load loc 3")
          if (this.setVideoDuration(PostId, loadData.duration))
            console.log("on load set update to new time")
            this.setState({update: new Date().getTime()})

            if (post.StreamURL) {
              if (this.currentlyPlayingVideoRef) {
                this.currentlyPlayingVideoRef.seek(streamVidCutIn) 
              }
          }
/*
          console.log(`rowRendererFullScreen onLoad called, duration: ` + JSON.stringify(loadData.duration))
          if (loadData.duration <= MAX_AUTOPLAY_VID_TIME) { // make sure play button gets hidden
              this.setState({videoDurat ionByIndex : this.state.videoDura tionByIndex}) // reset at top level to trigger render
          }
*/
        }}
        onEnd={() => this.fullScreenVideoOnEnd(index, isLastPost, screenLandscape)}
      />
		) :
		(
			<Image
				key={rowKey + '_i'}
				style={{ flex: 1 }}
				resizeMode="cover"
				source={{ uri: imageUrl }}
			/>
		)

    console.log("uri = " + imageUrl)

		const isUsersPost = this.state.authUserId == UserId
		if (!isUsersPost && typeof this.fullScreenIsFollowing[UserId] == 'undefined') {
			this.fullScreenIsFollowing[UserId] = null
			this.props.readUser(UserId) // future - improve by just getting following state
		}
		const isUserFollowing = typeof this.fullScreenIsFollowing[UserId] != 'undefined' && this.fullScreenIsFollowing[UserId]
		const followBtnStyle = {marginLeft: 10, marginTop: 6, marginBottom: 6, width: 22, height: 22, borderRadius: 10, backgroundColor: 'white', borderWidth: 1, borderColor: 'rgba(225,225,225,1)', alignItems: `center`, justifyContent: `center`}
		const followView = isUsersPost || isUserFollowing === null ? null : (
			isUserFollowing ? (
				null
				/*
				// FUTURE
				<TouchableOpacity activeOpacity={0.8} style={followBtnStyle} onPress={() => this.onUnfollowUser(UserId)}>
					<Text style={{lineHeight: 22, fontSize: 18, color: 'rgba(0,0,0,0.33)'}}>{`-`}</Text>
				</TouchableOpacity>
				*/
			) : (
				<TouchableOpacity activeOpacity={0.8} style={followBtnStyle} onPress={() => this.onFollowUser(UserId)}>
					<Text style={{lineHeight: 22, fontSize: 18, color: 'rgba(0,0,0,0.33)'}}>{`+`}</Text>
				</TouchableOpacity>
			)
		)
		const userInfoView = (
      <View style={[{}, {flex: 1, flexDirection: `row`}]}>
        <AvatarComponent style={{ borderWidth : 0}} userId={post.UserId} size={34} onPress={() => this.onAvatarPress(post.UserId , userName, post.PostId)}/>
        <TextComponent text={userName} style={[{lineHeight: 34, fontFamily: Fonts.style.font.regular, fontSize: textFontSize, paddingLeft:  14, marginLeft: 0, marginRight: 0, paddingRight: 0, color: 'white'}, textShadowStyle]} onPress={() => this.onAvatarPress(post.UserId , userName, post.PostId)} />
				{followView}
      </View>
    )
    // if (this.state.landscape) {
    const haveExtendedData = NumViews != null ? 'y' : 'n'
    const isPaused = this.state.fullScreenPaused ? 'y' : 'n'
    const isAutoAdvance = this.state.fullScreenAutoAdvance ? 'y' : 'n'
    const rawDuration = this.getVideoDuration(PostId)
    const duration = rawDuration != null ? rawDuration : 1
    const durationStr = rawDuration != null ? parseFloat(rawDuration).toFixed(2) : null
    // muted={this.currentlyPlayingVideoFullscreen ? (this.state.dynamicSong !== null) : (hasSong || !this.props.options.useOnScroll || this.isMuted() || this.state.currVideoPlayIndex != index || this.props.swiperIndex === 0 ) }
    const numViews = NumViews != null ? humanReadableNumber(NumViews) : ''
    const numLoves = NumLikes != null ? humanReadableNumber(NumLikes) : ''
    const numComments = NumComments != null ? humanReadableNumber(NumComments) : ''
    const kargoeTags = TheySell != null ? TheySell.length + ISell.length + Donate.length > 0 : false
    const userLovesPost = UserLovesPost != null ? UserLovesPost : false
		const textWidth = screenLandscape ? screenWidth - leftRightOverlayMargin - screenWidth / 2 - 30 : screenWidth - leftRightOverlayMargin - leftRightOverlayMargin

		// Need to have setState within ScrollView so that RecyclerListView does not use event to do main scroll
		let textInfo = []
		if (true || this.state.fullScreenDetailMode != 'bare') {
			if (Caption != '')
				textInfo.push(this.fullScreenCaptionOrComment(post, null, screenLandscape, 0, textWidth))
			if (RecentComments && RecentComments.length > 0)
				for (let i = 0; i < RecentComments.length; i++)
					textInfo.push(this.fullScreenCaptionOrComment(post, RecentComments[i], screenLandscape, i+1, textWidth))
			if (textInfo.length) {
				let scrollHeightFound = false
				let scrollHeight = screenLandscape ? 80 : 120
				for (let i = 0; i < this.state.fsCapComScrollHeights.length; i++)
					if (this.state.fsCapComScrollHeights[i].PostId == PostId) {
						scrollHeightFound = true
						scrollHeight = Math.min(scrollHeight, this.state.fsCapComScrollHeights[i].height)
					}
				const footerView = !scrollHeightFound || LoadedMoreComments || NumComments < 4 ? null : (
					<View style={{marginTop: 30, height: 20, flex: 1, justifyContent: 'flex-end'}}>
						<ActivityIndicator color='black' style={{position: 'absolute', top: 1, left: 11}}/>
						<ActivityIndicator color='white' style={{position: 'absolute', top: 0, left: 10}}/>
					</View>
				)
				const textContainerStyle = {paddingLeft: 4, marginTop: 4, marginBottom: 4, height: scrollHeight, flex: 1, /* width: textWidth, */ borderWidth: 0, borderColor: 'red'}
				textInfo = [(
					<ScrollView key={`comments${PostId}-${RecentComments.length}`} /* directionalLockEnabled={true} */ contentContainerStyle={{}} style={textContainerStyle}
						onScroll={(ev) => {
							this.fullScreenResetDetailFadeTimer()
							if (NumComments > 3)
								this.loadMoreComments(PostId)}
						}
						>
						<TouchableOpacity activeOpacity={1} style={{flex: 1}}
							onPress={(ev) => { /* needed so that we can drag and swipe the scrolling list of comments/captions */}}
							onLayout={(event) => {
								let height = event.nativeEvent.layout.height
								let scrollHeights = [...this.state.fsCapComScrollHeights]
								let found = false
								for (let i = 0; i < scrollHeights.length; i++)
									if (scrollHeights[i].PostId == PostId) {
										found = true
										if (scrollHeights[i].height != height) {
											scrollHeights[i].height = height
											this.setState({fsCapComScrollHeights: scrollHeights})
										}
										i = scrollHeights.length // exit
									}
								if (!found) {
									scrollHeights.push({PostId, height})
									if (scrollHeights.length > 20)
										scrollHeights.shift() // remove oldest
									this.setState({fsCapComScrollHeights: scrollHeights})
								}
							}}
							>
							{textInfo}
							{footerView}
						</TouchableOpacity>
					</ScrollView>
				)]
			}
		}

		// eye width: 48, height: 30
		const statsView = (
      <View style={this.statViewStyle}>
        <ImageAndText isText text={numViews} extraTextStyle={counterTextStyle}
          imageStyle={this.fsEyeStyle} source={Images.fsEyeIconWhite} />
        <ImageAndText isText text={numLoves} extraTextStyle={counterTextStyle} onPress={(e) => this.fullScreenLovePress(e, post, index)}
					imageStyle={this.iconStyle} source ={userLovesPost ? Images.lovesOnIcon: Images.fsLoveHeartWhite}/>
        <ImageAndText isText text={numComments} extraTextStyle={counterTextStyle}
          imageStyle={this.iconStyle} source={this.state.fullScreenDetailMode == 'comments' ? Images.fsCommentBubbleRed : Images.fsCommentBubbleWhite} />
				{kargoeTags && 
					<TouchableOpacity activeOpacity={0.8} style={{height: 40, alignItems: `center`, justifyContent: `center`}} onPress={() => this.fullScreenTagsTap(post, index)}>
						<Image style={this.iconStyle} source={Images.fsShoppingBagWhite} />
					</TouchableOpacity>
				}
        <TouchableOpacity activeOpacity={0.8} style={{marginLeft: 40, height: 40, alignItems: `center`, justifyContent: `center`}} onPress={() => this.iosShare(post)}>
          <Image style={this.iconStyle} source={Images.shareIconWhite} />
        </TouchableOpacity>
      </View>
    )

		if (true || this.state.fullScreenDetailMode == 'new_comment') {
			// selection={null} to make text white instead of black!
			// <TextInput selectionColor={`rgba(255,255,255,0.7)`} autoCorrect={!screenLandscape} autoFocus={true} selection={null} style={{color: 'white', height: 3 * textLineHeight, lineHeight: textLineHeight, fontSize: textFontSize}} multiline={true} placeholder="Add a comment here" placeholderTextColor='white' value={this.state.newComment} onChangeText={this.onChangeComment}/>
			textInfo.push((
				<View style={{backgroundColor: 'green', flex: 1, flexDirection: 'row', justifyContent: 'space-between',  marginTop: 2, marginBottom: 6, borderRadius: 6, padding: 8, backgroundColor: textBgColor}}>
					<View style={{flex: 5}}>
						<ScrollView keyboardShouldPersistTaps='always'>
							<TextInput onResponderGrant={(event) => this.setState({fullScreenDetailMode: 'new_comment'})} selectionColor={`rgba(255,255,255,0.7)`} autoCorrect={!screenLandscape} selection={null} style={{color: 'white', height: 3 * textLineHeight, lineHeight: textLineHeight, fontSize: textFontSize}} multiline={true} placeholder="Add a comment here" placeholderTextColor='white' value={this.state.newComment} onChangeText={this.onChangeComment}/>
						</ScrollView>
					</View>
					<TouchableOpacity style={{flex: 1, alignItems: `center`, justifyContent: `center`}} keyboardShouldPersistTaps='handled' activeOpacity={0.8} onPress={() => this.addNewComment(PostId)}>
						<Text style={{color: 'white'}}>{`Post`}</Text>
					</TouchableOpacity>
				</View>
			))
		}

		if (false) // info on row, etc
			textInfo.push((
				<View style={[textBoxStyle, {justifyContent: screenLandscape ? 'flex-end' : 'flex-start', textAlign: 'right'}]}>
					<Text style={{color: 'white', flex: 1, textAlign: 'right'}}>{`i: ${index} iPlay: ${this.state.currFullScreenVideoPlayIndex} paus: ${isPaused} adv: ${isAutoAdvance} ${this.state.fullScreenVideoProgress} of ${durationStr} mode: ${this.state.fullScreenDetailMode} last: ${isLastPost ? 'T' : 'F'} ratio: ${AspectRatio}`}</Text>
				</View>
			))
		// progress bar pause chars `▸` : `❙❙`  ❚

		let progressView = !slowNetwork && (this.state.fullScreenDetailMode == 'bare-no-more') ? null : (
			<Animated.View pointerEvents="box-none" style={{position: 'absolute', bottom: screenLandscape ? 28 : 48, left: 0, marginRight: leftRightOverlayMargin, flex: 1, flexDirection: 'row', opacity: this.fsDetailFadeInOut}}>
				{!slowNetwork && <TouchableOpacity activeOpacity={1} style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}
					onPressIn={() => {
						this.setState({fullScreenPaused: true, fullScreenProgressDragging: true})
						this.fullScreenResetDetailFadeTimer()
					}}
					onPressOut={() => {
						this.setState({fullScreenPaused: true, fullScreenProgressDragging: false})
						this.fullScreenResetDetailFadeTimer()
					}}
					>
					<TouchableOpacity activeOpacity={0.8} onPress={() => {
							this.setState({fullScreenPaused: !this.state.fullScreenPaused})
							if (this.state.fullScreenPaused)
								this.unmuteSound()
							else
								this.muteSound()
							this.fullScreenResetDetailFadeTimer()
						}} style={{opacity: 0.8, marginLeft: leftRightOverlayMargin - 6, width: 34, height: 32, alignItems : 'center', justifyContent: 'center', backgroundColor: 'transparent', borderRadius: 6}}>
						<Text style={[{letterSpacing: 2, fontSize: this.state.fullScreenPaused ? 32 : 14, lineHeight: 30, color: 'white'}, textShadowStyle]}>{this.state.fullScreenPaused ? `▸` : `❚❚`}</Text>
					</TouchableOpacity>
					<View
						/* https://github.com/jeanregisser/react-native-slider/blob/master/Example/app.js */
						style={{ flex: 1 /* width: (screenLandscape ? screenWidth - songWidth : screenWidth) - 31 - 34 - 45 */ }}
						step={.1}
						minimumValue={0}
						maximumValue={duration}
						value={drawingCurrentPlayingPost ? parseFloat(this.state.fullScreenVideoProgress) : 0}
						onSlidingStart={() => this.setState({fullScreenPaused: true, fullScreenProgressDragging: true})}
						onValueChange={(seconds) => {
							this.fullScreenUpdateVideoProgress(seconds)
							this.fullScreenResetDetailFadeTimer()
						}}
						onSlidingComplete={() => this.setState({fullScreenPaused: true, fullScreenProgressDragging: false})}
						animateTransitions={true}
						trackStyle={{
							height: 2, borderRadius: 0, backgroundColor: 'gray', shadowColor: 'black', shadowOffset: {width: 0, height: 1}, shadowRadius: 2, shadowOpacity: 0.25
						}}
						thumbStyle={{
							width: 14,
							height: 14,
							borderRadius: 7,
							borderWidth: 2,
							borderColor: 'white',
							backgroundColor: 'white', /* transparent */
							shadowColor: 'black',
							shadowOffset: {width: 0, height: 2},
							shadowRadius: 2,
							shadowOpacity: 0.35,
						}}
						minimumTrackTintColor={'rgba(255,03,03,1)'}
						maximumTrackTintColor={'gray'}
					/>
					<Text style={[counterTextStyle, { width: 45, textAlign: 'right', fontSize: textFontSize }]}>{this.formatTime(parseFloat(this.state.fullScreenVideoProgress))}</Text>
					{screenLandscape && songDetailView}
				</TouchableOpacity>}
			</Animated.View>
		)
		
		let postDetail = null
		if (this.state.fullScreenDetailMode == 'bare-no-more') {
			// nothing
		}
		else if (this.state.fullScreenDetailMode != 'tags' /* this.state.fullScreenDetailMode == 'new_comment' */ ) { // this.state.fullScreenDetailMode == 'comments' || 
			const postDetailStyle = screenLandscape ? {position: 'absolute', top: 0, left: 0, flex: 1, flexDirection: 'row'} : {position: 'absolute', bottom: 0, left: 0}
			// <ImageBackground resizeMode='stretch' source={Images.wallFullScreenBackground} style={{width: screenWidth}}>
			if (screenLandscape)
				postDetail = (
					<KeyboardAvoidingView style={{flex: 1, flexDirection: 'column', justifyContent: 'flex-end', ...postDetailStyle}} ref="keyboard" behavior="padding" keyboardVerticalOffset={(isIPhoneX( ) ? 24 : 0)}>
						<Animated.View keyboardShouldPersistTaps='handled' pointerEvents="box-none" style={{opacity: this.fsDetailFadeInOut}}>
							<View keyboardShouldPersistTaps='handled' style={{}}>
								<View style={{backgroundColor: 'transparent', display: 'flex', flexDirection: 'row', alignItems: `center`, justifyContent: 'space-between', marginLeft: 45 + leftRightOverlayMargin}}>
									{userInfoView}
									{statsView}
								</View>
								<View style={{width: textWidth, marginLeft: screenWidth - textWidth - leftRightOverlayMargin}}>
									{textInfo}
								</View>
							</View>
						</Animated.View>
					</KeyboardAvoidingView>
				)
			else {
				postDetail = (
					<KeyboardAvoidingView style={{flex: 1, flexDirection: 'column', justifyContent: 'flex-end', ...postDetailStyle}} ref="keyboard" behavior="padding" keyboardVerticalOffset={hasSong ? -170 : -140}>
						<Animated.View keyboardShouldPersistTaps='handled' pointerEvents="box-none" style={{opacity: this.fsDetailFadeInOut}}>
							<View keyboardShouldPersistTaps='handled' style={{}}>
								<ImageBackground resizeMode='stretch' source={Images.wallFullScreenBackground} style={{flex: 1, width: screenWidth}}>
									<View style={{paddingLeft: leftRightOverlayMargin, paddingRight: leftRightOverlayMargin, marginBottom: 97 }}>
										{userInfoView}
										{textInfo}
										{songDetailView}
										{statsView}
									</View>
									{progressView}
								</ImageBackground>
							</View>
						</Animated.View>
					</KeyboardAvoidingView>
				)
				progressView = null
			}
		}
		else if (this.state.fullScreenDetailMode == 'tags') {
			const hideTagsStyle = screenLandscape ? {position: 'absolute', top: 0, right: leftRightOverlayMargin + 3, alignItems: 'flex-end'} : {position: 'absolute', bottom: 100, height: 40, left: leftRightOverlayMargin - 8, right: leftRightOverlayMargin, flex: 1, flexDirection: 'row', alignItems: `center`, justifyContent: 'space-between'}
			const fundMeSummaryView = this.createFundMeSummaryStaticView(post, screenLandscape, textShadowStyle)
			postDetail = (
				<View style={hideTagsStyle}>
					<TouchableOpacity activeOpacity={0.8} style={{height: 40, width: 40, alignItems: `center`, justifyContent: `center`}} onPress={() => this.fullScreenTagsTap(post, index)}>
						<Image style={this.iconStyle} source={Images.fsShoppingBagRed} />
					</TouchableOpacity>
					{fundMeSummaryView}
				</View>
			)
		}
		let overlayTags = []
		if (this.state.fullScreenDetailMode == 'tags') {
			const showShopit = this.pressedTagDetails
			const hasSound = true // !isImage || (typeof post.Song != 'undefined' && post.Song != '')
      const isLiveStream = post.StreamStatus > 0
			if (post.TheySell && post.TheySell.length)
				overlayTags = overlayTags.concat(this.createTheySellTagViews(post, imageWidth, imageHeight, showShopit, false /*isLiveStream*/))
	
			if (post.ISell && post.ISell.length)
				overlayTags = overlayTags.concat(this.createISellTagViews(post, imageWidth, imageHeight, showShopit, thumbUrl))
	
			if (post.Donate && post.Donate.length)
				overlayTags = overlayTags.concat(this.createDonateViews(post, imageWidth, imageHeight, showShopit))
	
			// overlayTags = overlayTags.concat(this.createFundMeSummaryViews(post, imageWidth, imageHeight, showShopit, hasSound))
	
			if (post.UserTags && post.UserTags.length)
				overlayTags = overlayTags.concat(this.createUserTagViews(post, imageWidth, imageHeight, showShopit))
		}

		return (
      <View onStartShouldSetResponder={this.fullScreenToggleMode} key={rowKey} style={{overflow: 'hidden', width: screenWidth, height: screenHeight, backgroundColor: tileColor, alignItems : 'center', justifyContent: 'center'}}>
        <View style={{width: imageWidth, height: imageHeight}}>
          {postMedia}
					{overlayTags}
        </View>
				{loveAnimationView}
				{postDetail}
				{progressView}
        {switchViewMode}
        {switchStreamMode}
      </View>
    )
	} // rowRendererFullScreen

  // for playback
  stopFakeAudioWave() {
    if (this.fakeVoiceIntervalForPlay)
      clearInterval(this.fakeVoiceIntervalForPlay) // also do this on unmount just in case
    this.fakeVoiceIntervalForPlay = null
  }

  startFakeAudioWave() {
    this.fakeVoiceIntervalForPlay = setInterval(() => {
      this.setState({voiceLevel : this.getVoiceLevel()})
    }, 100)
  }

  // fake for now
  getVoiceLevel() {

    // anchored random random is 0 to 1 so make it -0.5 to 0.5
    let newVoiceLevel = 0.5 + 0.25 * this.state.voiceLevel + 0.5 * (Math.random() - 0.5)   
                    
    if (newVoiceLevel > 1) newVoiceLevel = 1
    else if (newVoiceLevel < 0.1) newVoiceLevel = 0.1

    return newVoiceLevel

  }
  //Given type and data return the view component
  rowRenderer(type, data, index, viewMode) {
    
    if (viewMode == 'list') {
      //console.log("row renderer index = " + index + " viewMode = " + viewMode)
    }
      
    // console.tron.log(`rowRenderer row ${index}`) // , state.viewMode: ${this.state.viewMode}, viewMode: ${viewMode}`)
    //console.log("rowRenderer data = " + JSON.stringify(data, null, 2))
    if (this.state.viewMode != viewMode || data.PostId == 0) { // fake first row for initial load
      // console.tron.log(`rowRenderer, fake first row, skip`)
      //console.log("fake first row, skip")
      //return (<Text>Fake first row</Text>)
    }

    if (PostWallBase.firstRender && index > 2) {
       console.log("skipping row render for row " + index)
       //return (<Text>skipping row render for row</Text>)// for speed up first draw of wall
    }

    if (PostWallBase.firstRender) {

      PostWallBase.firstRender = false

      setTimeout(() => {
        console.log('re-enable all row renders')
        this.setState({ forceUpdate: this.state.forceUpdate + 1 })
        // test
        if (!PostWallBase.firstRefreshAfterLaunch)
          this._onRefresh()
        PostWallBase.firstRefreshAfterLaunch = true
      }, 1000)

    }
    // fake row test
    //return (<View style={{width: 200, height: 100, backgroundColor: 'yellow'}}><Text>fake list row {index}</Text></View>)

    if (this.props.options.useRowComponent)
      return this.rowRenderer_UNUSED(type, data, index, viewMode)

    const specialFirstEntry = this.HomeWall && index == 0 && viewMode != FULL_SCREEN_MODE
    const topGapHeight = specialFirstEntry ? LIST_TOP_GAP : 0
    const topGap = specialFirstEntry ? (<View style={{height: LIST_TOP_GAP, width: screenWidth}}></View>) : null
    const useThumbBackground = index == this.state.lastJumpToIndex
    let url = `${KargoeConfig.baseUrlMedia}/${data.PostId}-thumb.jpg?${data.Version}`
    //console.log("image url jpeg " + url)
    let videoUrl = ''
    let thumbUrl = url
    const PostId = data.PostId
    let imageWidth = itemWidth
    let imageHeight = itemHeight
    let headerView = null
    let footerView = null
    let overlayIcons = null
    let overlayTags = []
    let shopitView = null
    let linkPostDetail = null
    let songDetail = null
    let playThisVideo = true
    let isLongVideo = null
    let isLongVideoStr = ' unknown'
    let postDurationStr = ' unknown'

    // console.tron.log(`rowRender - landscape: ${this.state.landscape}, mode: ${viewMode}`)
    if (this.state.landscape && viewMode == FULL_SCREEN_MODE) {
      const screenDim = Dimensions.get('screen');
      if (Platform.OS == 'web') {
        screenDim.width = screenWidth
        screenDim.height = screenHeight
      }
      imageWidth  = screenDim.width
      imageHeight = screenDim.height
    }
    else
      imageWidth = screenWidth

    let postMediaType = typeof data.MediaType != 'undefined' && !(this.props.options.disableVideos || this.props.slowNetwork) ? data.MediaType : 'JPEG'
    if (data.StreamURL) postMediaType = "MP4"
    let isImage = postMediaType == 'JPEG' && !data.StreamURL // test for web set to true
    if (Platform.OS == 'web' && window.isMobile()) {
      // isImage = true // force images for mobile now due to video going full screen mistakenly
    }

    const postSelling = typeof data.Selling != 'undefined' ? data.Selling : false
    const postType = typeof data.Type != 'undefined' ? data.Type : ''
    const meta = typeof data.Meta != 'undefined' ? data.Meta : null
    const refHash = this.indexToRefHash(index)
    let switchToStreamViewBtn = null
    switch (type) {
      case ViewTypes.GRID_LEFT:
      case ViewTypes.GRID_MIDDLE:
      case ViewTypes.GRID_RIGHT:
        break;
      default:
        if (!isImage)
          videoUrl = `${KargoeConfig.baseUrlMedia}/${data.PostId}.mp4?${data.Version}`
          if (data.StreamURL)
            videoUrl = data.StreamURL

        if (viewMode == LIST_MODE) {
          // console.tron.log("postId: " + data.PostId + ", locationName: " + locationName)

        }

        //   style={[styles.button, {backgroundColor: 'rgba(43, 230, 9, 1)'}]}>

        // green button from live broadcast screen
        const buttonStyle = {
          paddingHorizontal: 5,
          paddingVertical: 10,
          backgroundColor: 'rgba(43, 230, 9, 1)',
          borderRadius: 5
        }

        // don't show "join live" button if stream has ended
        const isLiveStream = this.postIsStreamAvailable(data)

        // fix crash on web
        const loginUsername = (this.props && this.props.auth && this.props.auth.user) ? this.props.auth.user.Username : ''

        const isOtherUserLiveStream = ((loginUsername != data.Username) && isLiveStream)
        switchToStreamViewBtn = isOtherUserLiveStream ? (
          <Button style = {[{position: 'absolute', left: 5, top: 40}, buttonStyle]} transparent onPress={() => this.onPressShowStreamView(data)}>
            <Text style={{color: 'white', backgroundColor: 'rgba(43, 230, 9, 1)'}}>{I18n.t('streaming.joinLive')}</Text>
          </Button>
        ) : null

        headerView = this.props.options.showHeader ?
          this.createHeaderView(data) :
          (<View style={{ height: LIST_HEADER_HEIGHT, backgroundColor: '#ffffff' }}></View>)

        const footerButtonView = this.props.options.showFooter ?
          this.createFooterButtonView(data, index) :
          (<View style={styles.footerContainer}></View>)

        //  this.createCaptionCommentView(data, index) :
        if (!this.moreButtonOn)
          this.moreButtonOn = {}
        commentView = this.props.options.showComments ?
          <CaptionCommentView post={data} index={index} navigation={this.props.navigation} moreButtonOn={this.moreButtonOn} forceUpdate={this.forceUpdate} onAvatarPress={this.onAvatarPress} showPostView={this.showPostView}/> :
          (<View style={{ backgroundColor: '#ffffff', height: 54 }}></View>)

        footerView = (
          <View>
            {footerButtonView}
            {commentView}
          </View>
        )

        // when auto display of thumb is done in low level iOS code, it computes the thumb url internally
        // so always pass the large image url
        // if (!useThumbBackground)
        url = `${KargoeConfig.baseUrlMedia}/${data.PostId}.jpg?${data.Version}`
        //console.log("full url = " + url)
        // imageWidth = screenWidth
        imageHeight = Math.round(imageWidth / data.AspectRatio) // aspect ratio
        // console.log(`rowRender PostId: ${data.PostId} imageWidth: ${imageWidth}, imageHeight: ${imageHeight}`)

        if (viewMode == LIST_MODE || viewMode == FULL_SCREEN_MODE) {
          linkPostDetail = this.createLinkPostDetailView(viewMode, data)
          if (this.state.showKargoeTagsPostId == data.PostId) {
            const showShopit = this.pressedTagDetails
            shopitView = this.createShopItView(data)

            const isLiveStream = data.StreamStatus > 0

            if (data.TheySell && data.TheySell.length)
              overlayTags = overlayTags.concat(this.createTheySellTagViews(data, imageWidth, imageHeight, showShopit, false))

            if (data.ISell && data.ISell.length)
              overlayTags = overlayTags.concat(this.createISellTagViews(data, imageWidth, imageHeight, showShopit, thumbUrl))

            if (data.Donate && data.Donate.length)
              overlayTags = overlayTags.concat(this.createDonateViews(data, imageWidth, imageHeight, showShopit))

            const hasSound = !isImage || (typeof data.Song != 'undefined' && data.Song != '')
            overlayTags = overlayTags.concat(this.createFundMeSummaryViews(data, imageWidth, imageHeight, showShopit, hasSound))

            if (data.UserTags && data.UserTags.length)
              overlayTags = overlayTags.concat(this.createUserTagViews(data, imageWidth, imageHeight, showShopit))
          }
          else if (this.state.hideKargoeDotsPostId != data.PostId) {
            let dotList = []
            if (data.TheySell && data.TheySell.length)
              dotList = dotList.concat(data.TheySell)

            if (data.ISell && data.ISell.length)
              dotList = dotList.concat(data.ISell)

            if (data.Donate && data.Donate.length)
              dotList = dotList.concat(data.Donate)

            overlayTags = this.createTagDots(data, index, dotList)
          }
          if (data.Song)
            songDetail = this.createMusicDetailView(data, imageWidth, imageHeight, linkPostDetail != null)
        } // LIST_MODE
      // imageHeight = screenWidth // try square to see how affects memory/recycling
    } // switch - single
    const hasSong = songDetail != null
    const postHeight = specialFirstEntry ? LIST_TOP_GAP + imageHeight + LIST_HEADER_HEIGHT + LIST_FOOTER_HEIGHT : imageHeight + LIST_HEADER_HEIGHT + LIST_FOOTER_HEIGHT

    // if we are jumping to an index, do simple render for all other rows
    if ((viewMode == LIST_MODE || viewMode == FULL_SCREEN_MODE) && this.state.jumpToIndex >= 0 && index != this.state.jumpToIndex) {
      console.tron.log(`rowRenderer just drawing a red box`)
      return (
      <View style={{ width : '100%', height : postHeight, flex : 1, display : 'flex', backgroundColor: 'rgba(255,255,255,1)' }}>
      </View> )
    }

    // consistent 'random' value
    const temp = Math.sin(1000 * Math.floor(data.TimeStamp)) * 100000
    const rand = temp - Math.floor(temp)
    const tileIndex = Math.floor(Colors.cellbg.length * rand)
    const tileColor = Colors.cellbg[tileIndex]
    // if (viewMode == LIST_MODE)
    //  console.tron.log("rowRender returning")
    // Use less memory if the screen isn't on top, ie: visible
    if (!this.state.nearTopScreen) { // this.state.visible)
      if (specialFirstEntry)
        return (
          <View
            style={{ backgroundColor: tileColor, width: imageWidth, height: imageHeight, marginTop: LIST_TOP_GAP }}
          />
        )
      else
        return (
          <View
            style={{ backgroundColor: tileColor, width: imageWidth, height: imageHeight }}
          />
        )
    }
    else { // might be possible to use ImageBackground with thumbs ***** Maybe set height for container view?
      if (!isImage && !this.state.topScreen) {
        // console.tron.log(`PostWallBase rowRenderer video not top screen`)
        // 2nd screen
        // isImage = true - causes white video screens to come up
        if (this.props.options.reduceHiddenVideos)
          videoUrl = Images.blankVideo.uri
      }
      // key={`V_${viewMode}_${data.PostId}`}
      // key={`T_${viewMode}_${data.PostId}L`}
      // key={`P${data.PostId}L`}
      if (viewMode == LIST_MODE || viewMode == FULL_SCREEN_MODE) { // } || viewMode == VID_MODE) {
        // https://github.com/react-native-community/react-native-video
        videoView = null
        imageView = null
        videoPlayButtonView = null

        /* debug video play trigger (or not playing when it should)

        let pausedDEBUG =(!this.state.topScreen && this.props.options.pauseHiddenVideos) || (this.props.options.useOnScroll && this.state.currVideoPlayIndex != index)

        console.log("pausedDEBUG = (!this.state.topScreen && this.props.options.pauseHiddenVideos) || (this.props.options.useOnScroll && this.state.currVideoPlayIndex != index")

        console.log("pausedDebug = " + pausedDEBUG)
        console.log("left  clause = " + (!this.state.topScreen && this.props.options.pauseHiddenVideos))
        console.log("right clause = " + (this.props.options.useOnScroll && this.state.currVideoPlayIndex != index))
        console.log("right clause LEFT  = " + this.props.options.useOnScroll)
        console.log("right clause RIGHT = " + (this.state.currVideoPlayIndex != index))
        console.log("currVideoPlayIndex = " + this.state.currVideoPlayIndex)
        console.log("             index = " + index)

        */

        if (!isImage && this.props.options.enableVideo) {
          // ref={component => this.refVideo[refHash] = component}
          if (!this.props.options.useVideoPosterFile)
            url = null
          // FUTURE ref used by components that support setNativeProps, which Video at present does not
          // ref=`${data.PostId}`
          // ref={component => {this.setVideoReference(data.PostId, component)}}
          // ref={`ref_${data.PostId}`}
          // ref={component => this.refs[`ref_${data.PostId}`] = component}

          /*
          let pausedDebug=(!this.state.topScreen && this.props.options.pauseHiddenVideos) || (this.props.options.useOnScroll && this.state.currVideoPlayIndex != index)

          console.log("----- video paused debug = " + pausedDebug)
          console.log("this.state.topScreen = " + this.state.topScreen)
          console.log("this.props.options.pauseHiddenVideos = " + this.props.options.pauseHiddenVideos)
          console.log("this.props.options.useOnScroll = " + this.props.options.useOnScroll)
          console.log("this.state.currVideoPlayIndex = " + this.state.currVideoPlayIndex)
          console.log("index = " + index)
          console.log("videoKeyBump = " + this.state.videoKeyBump)
          */

          //console.log("videoUrl = " + videoUrl)

          let allVidUrls = []

          let dataAll = this.state.dataProvider._data

          let foundCurrentVidIndex = dataAll.findIndex((element) => {
            return element.PostId == data.PostId
          })
          if (foundCurrentVidIndex >= 0) {
            // console.log("found video index at " + foundCurrentVidIndex)
            const maxVidUrls = 10 // the vid component only pre-loads a max of 10 forward now anyway so dont pass 100's of them
            // only send maxVidUrls to the video component for limited pre-load of thumb poster images
            for (let i = foundCurrentVidIndex; i < dataAll.length; i++) {
              const entry = dataAll[i]
              if (entry.MediaType === "MP4" || entry.MediaType === "3D") { // dont do for StreamURL, no thumb yet
                // console.log("post is " + JSON.stringify(entry, null, 2))
                const videoUrlForList = `${KargoeConfig.baseUrlMedia}/${entry.PostId}.mp4?${entry.Version}`
                allVidUrls.push(videoUrlForList)
                if (allVidUrls.length >= maxVidUrls)
                  break 
              }
            }
          }

          // now allVidUrls is just 'some' vid urls (say, 10) fwd from our current post

          if (this.pendingSongPostId) {
            const foundPost = dataAll.find((val) => {
              return val.PostId == this.pendingSongPostId
            })
            if (foundPost && foundPost.Song)  {
              console.log("found pending song, let it play")
              this.pendingSongPostId = null // only once
              this.setSong(foundPost.Song, `rowRenderer`) 
            }
            else { // music should already be off, see this.clearSong() in <VideoEfficientRender callback below
              // console.log("no pending song, shut off music")
              // this.clearSong() // !! causes recursive infinite render loop
            }
          }

          //console.log("found " + allVidUrls.length + " video URLs for player")

          const tooEarly = !this.state.videoPlaybackAllowed
          playThisVideo = true
          if (this.state.currVideoPlayIndex != index)
            playThisVideo = false
          if (this.getVideoDuration(PostId) == null)
            playThisVideo = false
          else {
            const duration = this.getVideoDuration(PostId)
            postDurationStr = (duration.toFixed(2)) + 's'
            isLongVideo = duration >= MAX_AUTOPLAY_VID_TIME
          }
          if (isLongVideo && this.state.currLongVideoPlayIndex != index)
            playThisVideo = false
          switch (isLongVideo) {
            case true: isLongVideoStr = ' long'; break;
            case false: isLongVideoStr = ' short'; break;
            default: isLongVideoStr = ' unknown'; break;
          }

          // test for live stream

          if ((this.state.currVideoPlayIndex == index) && data.StreamStatus > 0)
            playThisVideo = true
          if (tooEarly) {
            playThisVideo = false
            console.log(`Too Early`)
          }

          const playDiameter = 60
          let showPlayButton = isLongVideo === true && !this.shouldHidePlayButton(PostId, index)

          if (showPlayButton) {
            videoPlayButtonView = (
              <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() => this.onVideoPlayPress(data, index)}
                  style={{ flex: 1, backgroundColor: 'rgba(255,255,255,0.5)', position: 'absolute', width: playDiameter, height: playDiameter, top: (imageHeight - playDiameter)/2 + LIST_HEADER_HEIGHT + topGapHeight, left: (imageWidth - playDiameter)/2, borderRadius: playDiameter/2 }}>
                  <Text style={{position: 'absolute', top: Platform.OS == 'web' ? 8 : 14, left: 2, textAlign: 'center', textAlignVertical: 'center', fontSize:34, width: playDiameter, height: playDiameter, color: 'black'}}>▶︎</Text>
              </TouchableOpacity>
            )
            }
          else
            videoPlayButtonView = null

          const iconsIsListMode = viewMode == LIST_MODE || viewMode == FULL_SCREEN_MODE  // || viewMode == VID_MODE
          // do not show video wall button for non home wall; note:  component had to be modded to handle this
					overlayIcons = /*this.props.options.showOverlayIcons*/ this.HomeWall ?
						(
							<IconPostWallV2Component showPlayButton={showPlayButton} hasSong={songDetail != null} showVideoWall={this.showVideoWallNew.bind(this, data.PostId)} postId={data.PostId} viewMode={viewMode} viewModeList={iconsIsListMode} selling={postSelling} mediaType={postMediaType} type={postType} muted={this.isMuted()} playing={this.state.currVideoPlayIndex == index} onSoundToggle={this.onSoundToggle} />
						) :
						(
              <IconPostWallV2Component showPlayButton={showPlayButton} hasSong={songDetail != null} postId={data.PostId} viewMode={viewMode} viewModeList={iconsIsListMode} selling={postSelling} mediaType={postMediaType} type={postType} muted={this.isMuted()} playing={this.state.currVideoPlayIndex == index} onSoundToggle={this.onSoundToggle} />    
            )
          // overlayIcons = null // test no icons for speed
            
          if (this.props.options.enableVideoPauseMute) {
            let posterUrl = this.props.options.useVideoPosterFile ? thumbUrl : null
            let pausedFlag = this.state.landscape ? false : ( (!this.state.topScreen && this.props.options.pauseHiddenVideos) || (this.props.options.useOnScroll && this.state.currVideoPlayIndex != index) )
            // to temp remove an on* callback function, set it to a different name w/ prefix X
            // so the video module doesnt know about it and therefore won't call it 
            // note:  ZoomableVideo uses VideoEfficientRender 
            //console.log("proposed vid size " + JSON.stringify({ width: imageWidth, height: imageHeight }))

            // shut off underlying video play if this is a live stream to avoid audio confusion 
            // may be able to refine this later and shut off video play when live stream starts
            // probably should shut off music if any too?
            // maybe later, audio is off by default:  if (data.Caption === liveStream Caption) playThisVideo = false
            const isLiveStream = (data.Caption === liveStreamCaption)
            let resizeModeFlag = isLiveStream ? 'contain' : 'cover' // cover is orig way
            resizeModeFlag = 'cover' // hold on this, does funky stuff w/ background image (poster)
            // the problem we are having is that user can post a non 9:16 ratio video
            // and then if we do 'cover' mode, it effectively zooms and and crops, until/unless
            // the user saves the stream video which is 9:16 by default
            if (data.StreamURL) {
              videoUrl = data.StreamURL
              if (this.justSavedStreamPostId == data.PostId) {
                console.log("just saved stream vid, data.StreamURL should play = " + data.StreamURL)
                playThisVideo = true // if we just got this video, kick it into play mode 
              }
              resizeModeFlag = 'cover' // back to orig once we have a stream url
            }
            // ***
            // regular wall (not full screen)
            // *** 
            const currentVideoDuration = this.getVideoDuration(data.PostId) // used for spinner (waiting or saved live stream) 
            // console.log("currently playing video progress = " + this.state.currentlyPlayingVideoProgress)
            //console.info("video url = " + videoUrl)
            videoView = (
              <TouchableOpacity activeOpacity={1} 
                  onPress={() => this.onImagePress(data, index)}
                  delayLongPress={500}
                  onLongPress={(evt) => this.onLovePress(evt, data, index, 'wall')}>
                <Video
                  key={"videoKey" + data.PostId + '_' + this.state.videoKeyBump}
                  style={{  width: imageWidth, height: imageHeight /*, flex: 1 */}}
                  resizeMode={resizeModeFlag}
                  poster={posterUrl}
                  Xpreload={this.props.options.preloadVideoBeforePlaying /* this always happens now, flag is ignored in RCTVideo.m */}
                  source={{ uri: /*posterUrl*/ videoUrl }}
                  adjacentUrls={allVidUrls}
                  onPress={() => this.onImagePress(data, index)}
                  ref={(ref) => this.currentlyPlayingVideoRef = ref}
                  progressUpdateInterval={250 /* 100 no progress, 106%, drawing too slow... 250 default ms */}
                  onProgress={(progress) => { // dont go to the end for a video stream the is black there
                    //console.log("progress " + JSON.stringify(progress))
                    if (data.StreamURL) { 
                      if (progress.playableDuration - progress.currentTime < streamVidCutOut) { // chop off last few seconds and restart
                        if (this.currentlyPlayingVideoRef) {
                          this.currentlyPlayingVideoRef.seek(streamVidCutIn) // rewind
                        }
                      }
                      if (progress.currentTime > 0 && this.state.currentlyPlayingVideoProgress == 0) {
                        this.setState({currentlyPlayingVideoProgress: progress.currentTime}) // only do once to avoid recursive render
                      }
                    }
                    
                  }}
                  UNUSED_onSetSongForVidUrl={(args) => {
                    /* reference, data is from native code
                      vidUrl is a url changed to while playing the full screen video, not necessarily the original source videoUrl
                    args = {
                      "target": 1505,
                      "response": {
                        "vidUrl": "https://s3.amazonaws.com/kargoe2-dev/ZHLisNY3uQ5pH7.mp4?0",
                        "target": 1505
                      }
                    */
                    console.log("setSongForVidUrl called in post wall base args = " + JSON.stringify(args, null, 2))
                    if (args.response) {
                      let right = args.response.vidUrl.replace(/^.*\//,'')
                      let postId = right.replace(/\.mp4.*$/,'')
                      console.log("found postId = " + postId)
                      const foundPost = dataAll.find((val) => {
                          return val.PostId == postId
                      })

                      if (foundPost) {
                        console.log("found post to switch to = " + JSON.stringify(foundPost))
                        if (typeof foundPost.NumViews == 'undefined') { // no extended post data, get it

                            const options = {
                              PostId: foundPost.PostId, // take the first id, and leave the rest
                              PostIds: [foundPost.PostId],
                              GetLikes: true
                            }

                            console.log("for song, ready to read post to get extended data for post = " + foundPost.PostId)
                            this.props.readPosts(options) // how do we know readPosts is done?

                            this.pendingSongPostId = foundPost.PostId
                        }

                        if (foundPost && foundPost.Song)  {
                          console.log("found song, let it play")
                          this.setSong(foundPost.Song, `rowRenderer 2`)
                        }
                        else {
                          console.log("no song, shut off music")
                          this.clearSong()
                        }
                        
                      }
                      else
                        console.log("did not find post to switch to for postId " + postId + " cannot play song")
                      
                    }
                  }} 
                  
                  paused={!playThisVideo}
                  // paused= {false}
                  muted={this.currentlyPlayingVideoFullscreen ? (this.state.dynamicSong !== null) : (hasSong || !this.props.options.useOnScroll || this.isMuted() || this.state.currVideoPlayIndex != index || this.props.swiperIndex === 0 ) }
                  volume={this.state.videoVolume}
                  repeat={true}
                  isTilt={postMediaType === '3D'}
                  UNUSED_XonHeaderLoad={(header) => {
                    // above line use X prefix so underlying module doesnt know about this fn at all
                    return // DEBUG SCROLL GLITCH
                    //console.log("video header = " + JSON.stringify(header))
                    const bytes = header["Content-Length"];
                    // estimate duration in seconds from bytes using a nominal bitrate
                    const bitrate = 3000000
                    const byterate = bitrate / 8
                    const estimatedDuration = bytes / byterate
                    console.log("estimated video duration for post " + data.PostId + " = " + estimatedDuration)
                    // same code as below
                    this.setVideoDuration(PostId, estimatedDuration)
                      if (estimatedDuration <= MAX_AUTOPLAY_VID_TIME) { // make sure play button gets hidden
                          // may be expensive cpu-wise while scrolling
                        
                          this.setState({update: new Date().getTime()}) // reset at top level to trigger render
                      }
                  }}
                  onLoadStart={() => this.setState({currentlyPlayingVideoProgress : 0}) // init
                  }
                  onError={() => 
                    {
                      console.log("video on error")
                      return // kind of dangerous could lead to inf loop dont do this yet
                      // live saved vid may not be ready yet, trigger a re-render in a moment 
                      if (data.StreamURL) {
                        setTimeout(() => this.setState({currentlyPlayingVideoProgress : 1}), 1000)
                      }
                    }
                  }
                  /*NOWEB_*/onLoad={(loadData) => {
                    //alert("on load video loc 2")
                    console.log("onLoad video loc 2")
                    // FUTURE - LOOK INTO THIS - does the App need to know which video is really playing - more than 60s??
                      // return // DEBUG SCROLL GLITCH
                      // we leave this here for example and for more refined video duration if needed
                      // duration is estimated by onHeaderLoad above for estimating dur w/ less data from internet
                      //console.log("paused debug video load for post " + data.PostId + " " + JSON.stringify(loadData))
                      // console.log("actual video duration for post " + data.PostId + " " + loadData.duration)
                      // this is obj not array so we can do this
                      // look into not setting state directly
                      const duration = loadData.duration
                      console.log(`onLoad Video post ${data.PostId} length ${duration}`)
                      const changed = this.setVideoDuration(PostId, duration)
                      if (changed || duration <= MAX_AUTOPLAY_VID_TIME) { // make sure play button gets hidden
                        console.log("on load update 2")
                        this.setState({update: new Date().getTime()}) // reset at top level to trigger render
                      }

                      if (data.StreamURL) { // eventually compute cutff based on length estimate
                          if (this.currentlyPlayingVideoRef) {
                            this.currentlyPlayingVideoRef.seek(streamVidCutIn) 
                          }
                      }

                      }
                    }
                  UNUSED_onFullscreenPlayerWillPresent={
                    ()=> {
                      console.log('--- fullscreen will present')
                      this.videoInTransition = true
                    }
                  }
                  UNUSED_onFullscreenPlayerDidPresent={
                    ()=> {
                      console.log('--- fullscreen did present')
                      this.videoInTransition = false
                    }
                  }
                  UNUSED_onFullscreenPlayerWillDismiss={
                    ()=> {
                      console.log('--- fullscreen will dismiss')
                      this.videoInTransition = true
                      // backstop in case this callback doesnt get called
                      setTimeout(() => {
                        console.log("finally set video transition to false")
                        this.videoInTransition = false
                      }, 500)
                      this.clearSong() // stop playing song from full screen vid
                    }
                  }
                  UNUSED_onFullscreenPlayerDidDismiss={
                    ()=> {
                      // this gets called if you press the X to close the fulll screen player
                      // did dismiss not getting called maybe because the wall getting re-rendered scrolled to top?
                      console.log('--- fullscreen DID dismiss')
                      this.videoInTransition = false
                      this.currentlyPlayingVideoFullscreen = false // added for portrait use of full screen player
                    }
                  }
                  UNUSED_ref={(ref) =>
                    {
                      if (this.state.currVideoPlayIndex == index && !this.videoInTransition && !this.currentlyPlayingVideoFullscreen) {
                        if (ref) {
                          //console.log("for wall index " + index + " setting currently playing video to " + JSON.stringify(ref.props))

                          if (ref.props && ref.props.source) {

                            // if uri has changed, close prior
                            if (this.currentlyPlayingVideoUri && (this.currentlyPlayingVideoUri != ref.props.source.uri)) {
                              if (this.currentlyPlayingVideo) {
                                //console.log("dismiss full screen player loc 3")
                                if (this.currentlyPlayingVideoFullscreen && !this.videoInTransition) {
                                  this.currentlyPlayingVideo.dismissFullscreenPlayer()
                                  // this.presentedFullScreenAtOffsetY
                                  this.currentlyPlayingVideoFullscreen = false
                                }

                              }
                            }

                            this.currentlyPlayingVideoUri = ref.props.source.uri

                          }

                          this.currentlyPlayingVideo = ref
                          this.currentlyPlayingVideoIsTilt = (postMediaType === '3D')

                        }
                        else {
                          // console.log("SHOULD BE clearing currentlyPlayingVideo")
                          // note:  was working if we commented out this, but crashes
                          // w/ red screen on dismissFullscreenPlayer
                          // this.currentlyPlayingVideo = ref
                          // this.currentlyPlayingVideoIsTilt = false
                        }

                      }
                    }

                  } // first arg of ref
                />
                {(this.state.currentlyPlayingVideoProgress == 0 && data.StreamURL) && 
                <ActivityIndicator color='blue' size='large' style={{position: 'absolute', top: '50%', left: 0, width: '100%', height: 60}}/>}

              </TouchableOpacity>
            )
            // temp remove videos from the render to see if any errors due to muting videos causing audio problems in agora live stream
            if (false)
            videoView = (
              <Image
                key={"videoKey" + data.PostId + '_' + this.state.videoKeyBump}
                style={{ flex: 1 }}
                resizeMode="cover"
                source={{ uri: thumbUrl }}
              />
            )
          }
          else if (!this.props.options.playWithoutControls)
            videoView = (
              <Image
                style={{ flex: 1 }}
                resizeMode="cover"
                poster={url}
                source={{ uri: /*videoUrl*/imageUrl}}
                paused={true}
                repeat={true}
                isTilt={postMediaType === '3D'}
              />
            )
          else if (this.props.options.alwaysMute)
            videoView = (
              <Image
                style={{ flex: 1 }}
                resizeMode="cover"
                poster={url}
                source={{ uri: /*videoUrl*/imageUrl }}
                muted={true}
                repeat={true}
                isTilt={postMediaType === '3D'}
              />
            )
          else
            videoView = (
              <Image
                style={{ flex: 1 }}
                resizeMode="cover"
                poster={url}
                source={{ uri: /*videoUrl*/imageUrl }}
                repeat={true}
                isTilt={postMediaType === '3D'}
              />
            )

          /*
                    imageView = (
                      <ImageRecycler
                        style={{ width: 1, height: 1 }}
                        resizeMode="cover"
                        source={Images.space}
                      />
                    )
          */
        }
        else {
          // ***** NOTE: if we dont do this then videos stick around forever, and use lots of memory, playing, etc
          // blankVideo is a 4kb, 1 second 20x20 pixel silent video
          //               poster={Images.space}
          // **** WARNING **** video attributes must match real video attributes or scrolling will have 2 second hiccup
          if (this.props.options.enableVideoPauseMute) {
            //console.log("loc 1 poster = " + thumbUrl)
            // try to avoid continual re-rendering of one pixel video by passing style as an unchanging pointer
            if (!this.onePixelVidStyle) this.onePixelVidStyle = { flex: 0, width: 1, height: 1, display: 'none' }
            videoView = (
              <Image
                style={this.onePixelVidStyle}
                resizeMode="none"
                poster={null /*thumbUrl speed test*/}
                showPosterAlways={false}
                source={Images.blankVideo /* should already be unchanging*/}
                paused={true}
                muted={true}
                repeat={false}
                isTilt={false}
              />
            )
          }
          else if (!this.props.options.playWithoutControls) {
            console.log("loc 2 poster = " + thumbUrl)
            videoView = (
              <Image
                style={{ flex: 0, width: 1, height: 1 }}
                resizeMode="none"
                poster={thumbUrl}
                source={Images.blankVideo}
                paused={true}
                repeat={false}
                isTilt={false}
              />
            )
          }
          else if (this.props.options.alwaysMute) {
            console.log("loc 3 poster = " + thumbUrl)
            videoView = (
              <Image
                style={{ flex: 0, width: 1, height: 1 }}
                resizeMode="none"
                poster={thumbUrl}
                source={Images.blankVideo}
                muted={true}
                repeat={false}
                isTilt={false}
              />
            )
          }
          else {
            console.log("loc 4 poster = " + thumbUrl)
            videoView = (
              <Image
                style={{ flex: 0, width: 1, height: 1 }}
                resizeMode="none"
                poster={thumbUrl}
                source={Images.blankVideo}
                repeat={false}
                isTilt={false}
              />
            )
          }
          /*
          does not work as advertized, only perhaps 1 out of 10 pinches work
          <ScrollView
            style={{ width: imageWidth, height: imageHeight }}
            minimumZoomScale={0.05}
            maximumZoomScale={10}
            zoomScale={1}
            >
          Maybe this instead
          https://medium.com/@audytanudjaja/react-native-ui-challenge-building-instagram-zoom-draggable-photo-9127413b1d29
          https://github.com/AudyOdi/react-native-instagram-photo
          OR this hack
          https://stackoverflow.com/questions/36368919/scrollable-image-with-pinch-to-zoom
          */
          // console.tron.log(`post: ${data.PostId}, width: ${imageWidth}, height: ${imageHeight}, aspect: ${data.AspectRatio}`)
          // this should be ZoomableImage... go back to regular FastImage to test picks
          // this was trying to do thumb image in JS, now do it low level buried in iOS code under ZoomImage --> FastImage
          // for cleaner transition from thumb to full

          //console.log("image uri = " + url)
          if (!isImage) console.log("thumbUrl = " + thumbUrl)

          console.log("image wh = " + imageWidth + " " + imageHeight)

          if (false && useThumbBackground)
            imageView = (
              <ImageBackground source={thumbUrl} style={{ width: imageWidth, height: imageHeight }}>
                <Image
                  useCache={this.props.options.useCache}
                  style={{ width: imageWidth, height: imageHeight }}
                  resizeMode="cover"
                  source={{ uri: url, cache: 'force-cache' }}
                  loadingOpacity={0 /*this.props.options.loadingOpacity*/}
                  onPress={( ) => this.onImagePress(data, index)}
                  onDoublePress={( ) => this.onLovePress(false, data, index, 'wall')}
                  onLongPress={( ) => this.onLovePress(false, data, index, 'wall')}
                  setParentState={this.setState.bind(this)}
                  setSwiperState={this.props.screenProps.setSwiperState}
                />
              </ImageBackground>
            )
          else 
            imageView = (
              <Image
                key={`wall-image-${data.PostId}`}
                useCache={this.props.options.useCache}
                style={{ width: imageWidth, height: imageHeight }}
                resizeMode="cover"
                source={{ uri: isImage ? url : thumbUrl, cache: 'force-cache' }}
                loadingOpacity={this.props.options.loadingOpacity}
                onPress={( ) => this.onImagePress(data, index)}
                onDoublePress={( ) => this.onLovePress(false, data, index, 'wall')}
                onLongPress={(evt) => this.onLovePress(evt, data, index, 'wall')}
                setParentState={this.setState.bind(this)}
                setSwiperState={this.props.screenProps.setSwiperState}
                goFullScreen={(uri, scale) => {console.log('image should go full screen ' + uri + ' to scale ' + scale)
                                               this.setState({fullScreenURI: uri, fullScreenImageAR: imageWidth/imageHeight, prelimZoomScale: scale})

                                              }

                             }
              />
            )

        }

        // test to push live broadcast screen on to the nav stack
        // also now test to put viewing side of live stream on wall
        // console.log("user = " + JSON.stringify(this.props.auth.user))
        // console.log("post data = " + JSON.stringify(data))
        let goLiveButton = null
        let liveViewerWaitMessage = null
        let liveViewer = null
        // only show go live button if it's our own post (and, for now, if caption has our keywords)
        // broadcaster , width: 80
        // dont show go live button if stream has already ended
        if ((this.props.auth.user.Username === data.Username) && this.postIsStreamAvailable(data))
          goLiveButton = (<TouchableOpacity style={{position: 'absolute', top: 40, left: 5, paddingLeft: 8, paddingRight: 8, height:30, 
                           backgroundColor: 'rgba(43, 230, 9, 1)', justifyContent: "center", alignItems: "center", borderRadius: 15}} 
            onPress={() => this.onPressShowStreamView(data)}>
              <Text style={{color: 'white'}}>{I18n.t('streaming.go_live')}</Text>
            </TouchableOpacity>
          )
        // audience
        if ((this.props.auth.user.Username != data.Username) && data.StreamStatus > 0) {

          let msg = I18n.t('streaming.startShortly')
          let col = 'rgba(255,255,255,0.5)'
          if (this.state.isPostBroadcasting[data.PostId]) {
            msg = I18n.t('streaming.liveStreamingNow')
            col = 'rgba(255,255,0,0.5)'
          }
          //console.log("data stream status = " + data.StreamStatus)
          if (data.StreamStatus == 12345 /*LiveBroadcastScreen.POST_STREAM_STATUS_DONE*/) {
            msg = 'This live stream has ended'
            col = 'rgba(255,0,0,0.5)'
          }

          liveViewerWaitMessage = (
            <View style={{justifyContent: 'center', position: 'absolute', top: 100, left: 0, width: '100%', height:60}}>
              <Text numberOfLines={1} adjustsFontSizeToFit style={{textAlign: 'center', overflow: 'hidden', borderRadius: 0, backgroundColor: col, fontSize: 20}}>{msg}</Text>
            </View>
          )
          // june 12 2012 dont show will start shortly bar across the post per KW
          if (msg == I18n.t('streaming.startShortly'))
            liveViewerWaitMessage = null
        }

        let postToUseForPopup = false
        if (this.state.twoCircleCommentPopupPost && (this.state.twoCircleCommentPopupPost.PostId == data.PostId)) postToUseForPopup = true

         
        let isSmallWidth = true // (Dimensions.get('window').width == 320) // small phone

        // duplicated from post view component due to lack of time to commonize

        let voiceIcon = true ? (
        <TouchableOpacity onPress={()=>{
              console.log("ready to change audio play state from icon")
              if (this.state.playOn) {
                console.log("switching play off voice")
                this.setState({playOn: false})
                this.stopFakeAudioWave()
              }
              else {
                console.log("switching play on voice")
                this.setState({playOn: true})
                this.startFakeAudioWave()
              }
           }} 
           style={
           [{position: 'absolute', left: 40, top : 15, width: 23*2, height: 20}, 
            {transform: [{ scaleY: this.state.voiceLevel }]} 
           ]}>
          <Image style={{position: 'absolute', top: 0, width:23, height:17, left:5}} source={Images.audioWave1} />
          {true && <Image style={{position: 'absolute', top: 0, width:23, height:17, left:23+5+1}} source={Images.audioWave1} />}
          {false && <Image style={{position: 'absolute', top: 0, width:23, height:17, left:23*2+5}} source={Images.audioWave1} />}
        </TouchableOpacity>
        ) : null

        // duplicated from post view component due to lack of time to commonize
        let theAudioDuration = this.state.audioDurationSeconds ? this.state.audioDurationSeconds.toFixed(1) : 0.0

        let time = this.state.audioDurationSeconds

        let playText = (this.state.isPlaying /*this.state.audioUrlPlaying == theAudioURL*/) ? " ◼︎" : " ▶︎ " 

        durationText = this.secondsToMinSec(time) 

        // note:  this assumes we are on main wall, have to test for profile wall to hook up readPost properly
        // set to true to remove for web
        if (false) this.postViewComponentForAudio = null
        else 
        this.postViewComponentForAudio = (
          <PostViewComponent key='onepvc'
              readPost={this.props.readPost /*func*/}
              isPopup={true}
              ref={(r) => this.postViewComponentRef = r /* so we can call functions on post view component */}
              parent={this /* is this needed? */} 
              Post={this.state.twoCircleCommentPopupPost} 
              defaultTab={'Comments'} 
              onRefresh={this.updateForPostView /* may not be needed */ }
              commentTimeStamp={0 /* for scrolling to comment so who cares?*/} 
              navigation={this.props.navigation} 
              auth={this.props.auth} 
              close={( ) => null }
              following={[]/*this.props.following*/}
              loveChanges={[]/*this.props.loveChanges*/}
              recordOn={this.state.recordOn}
              playOn={this.state.playOn}
              addVoiceComment={this.state.addVoiceComment}
              audioStateChanged={(s) => { // pass back the whole state obj
                let s1 = JSON.parse(JSON.stringify(s)) // deep copy
                s1.Post = {} // get rid of stuff for a moment, too much to log
                s1.loves = []
                s1.tags = []
                s1.comments = []
                s1.following = []
                //console.log("pvc state " + JSON.stringify(s1))

                if (this.state.isRecording != s.isRecording) // make sure it is only done once
                  this.setState({isRecording: s.isRecording})

                if (this.state.isPlaying != s.isPlaying) // make sure it is only done once
                  this.setState({isPlaying: s.isPlaying})

                if (this.state.audioDurationSeconds != s.audioDurationSeconds)
                  this.setState({audioDurationSeconds: s.audioDurationSeconds})

                 if (this.state.recordingTimeMillisec != s.recordingTimeMillisec) {

                    this.setState({recordingTimeMillisec: s.recordingTimeMillisec, 
                                   recordingTimeStart : s.recordingTimeStart,
                                   voiceLevel: this.getVoiceLevel()})

                  
                 }
               
              }}

            />)

        //console.log("this.state.directCommentEntryOn " + this.state.directCommentEntryOn)

        // not really percent assume 30 sec max to try (update to 60)

        let percentRecorded = ((this.state.recordingTimeMillisec - this.state.recordingTimeStart)/1000.0)/60

        let recordingTime = ((this.state.recordingTimeMillisec-this.state.recordingTimeStart)/1000)

        if (isNaN(recordingTime)) recordingTime = 0

        recordingTimeDisplay = this.secondsToMinSec(recordingTime) 
        
        // temp let the left round button just bring up full screen, should bring up typing area (complex, not just a text input)
        let twoCircleCommentPopupView = (postToUseForPopup && this.state.twoCircleCommentPopup) ? (
          <View style={{position: 'absolute', bottom: 20, left: 0, width: '100%', height: 170, backgroundColor: 'rgba(0,0,0,0)'}} > 
            <View style={{position: 'absolute', left: 0, height: '100%', width: '50%'}}>
              <TouchableOpacity onPress={() => {
                  if (this.state.directCommentEntryOn)
                    this.setState({directCommentEntryOn: false}) 
                  else
                    this.setState({directCommentEntryOn: true}) 
                  }
                  /*this.showPostView(data,'Comments')*/
                } style={{position: 'absolute', backgroundColor: 'white', right: 50, bottom: 10, height: 80, width: 80, borderRadius : 40, borderColor: 'black', borderWidth: 1}}> 
                <Text style={{textAlignVertical: "center", textAlign: "center", position: 'absolute', fontSize: 10, top: 10, left: 10, width: 60, height: 60, paddingTop:15}}>Reply with Comment</Text>
              </TouchableOpacity>
            </View>

            {(Platform.OS != 'web') && <View style={{position: 'absolute', left: '50%', height: '100%', width: '50%'}}>
              <TouchableOpacity onPress={() => {

                // doesnt work this.postViewComponentForAudio.externalRecordAudio()
                // do by passing a prop to the above component 
                let shouldSwitchRecordingOn = false
                if (this.state.recordOn)
                  this.setState({recordOn: false}) 
                else {
                  this.setState({recordOn: true}) 
                  shouldSwitchRecordingOn = true
                }

                console.log('ready to render post view component for audio, this.state.playOn = ' + this.state.playOn)

                if (shouldSwitchRecordingOn)
                  this.setState({voiceNoteEntryOn : false})
                else // when recording stops then we show the playback bar
                  this.setState({voiceNoteEntryOn : true})
              }}
              style={{overflow: 'hidden', position: 'absolute', backgroundColor: /*this.state.recordOn ? 'rgba(255,100,100,1.0)' : */ 'white', left: 50, bottom: 10, height: 80, width: 80, borderRadius: 40, borderColor: 'black', borderWidth: 1}}> 

                <View style={{backgroundColor : 'rgba(255,100,100,1.0)', position: 'absolute', bottom: 0, left: 0, width: '100%', height: isNaN(percentRecorded) ? 0 : (percentRecorded * 80)}}></View>
                <Image source={Images.micOnWall} style={{position: 'absolute', top: 10, left: (80-9)/2, width: 9, height: 26}}/>
                <Text style={{textAlignVertical: "center", textAlign: "center", position: 'absolute', fontSize: 10, bottom: 10, left: 10, width: 60, height: 60, paddingTop:40}}>Voice Note</Text>
                <Text style={{textAlignVertical: "center", textAlign: "center", position: 'absolute', fontSize: 10, bottom: 5, left: 10, width: 60, height: 20, paddingTop:5}}>{recordingTimeDisplay}</Text>

              </TouchableOpacity>
            </View>}
            {/*!this.state.isRecording && */ ((theAudioDuration > 0) || this.state.isRecording) && 
            <View style={{position: 'absolute', top: 0, left: '10%', width: '80%', height: 50, backgroundColor: 'white', borderRadius:7, borderColor: 'black', borderWidth: 1}}>
           
                  {voiceIcon}
                  <Text style={{position: 'absolute', left: 5, top: 15, height:20}} onPress={ () => 
                    {
                        console.log("ready to play prelim audio from wall")
                        //this.playAudio.call(this, theAudioURL)
                        if (this.state.playOn) {
                          console.log("switching play off")
                          this.setState({playOn: false})
                          this.stopFakeAudioWave()
                        }
                        else {
                          console.log("switching play on")
                          this.setState({playOn: true})
                          this.startFakeAudioWave()
                        }
                        
                    }
                  }>{playText}</Text>

                  <Text style={{position: 'absolute', left: 125, top: 15, height:20}}>{durationText}</Text>

                  {(!this.state.addVoiceComment && (theAudioDuration > 0)) && <Text style={{position: 'absolute', right: 5, top: 15, height:20}} onPress={ () => 
                    {
                      this.setState({addVoiceComment: true})
                      setTimeout(() => {
                        this.setState({addVoiceComment: false})
                      }, 1500)
                    }
                  }>Add Reply</Text>}

            </View>}
            
            <View style={this.state.directCommentEntryOn ? {height: 170, width: '100%'} : {height: 1, width: 1, overflow: 'hidden'}}>
            {this.postViewComponentForAudio /* hidden component used for audio */}
            </View>

          </View>
        ) : null

        //console.log("twoCircleCommentPopupView = " + twoCircleCommentPopupView)

        // force image until we figure out a Video component for web
        //console.info("rendering videoView = " + videoView + " url = " + videoUrl)
        return  isImage 
          ? <View style={{ width : '100%', height : postHeight, flex : 1, display : 'flex' }}>
              {topGap}
              {headerView}
              <View style={{ backgroundColor: tileColor, width: imageWidth, height: imageHeight, margin: 0 }}>
                {videoView}
                {imageView}
                {/*goLiveButton*/}
                {/*liveViewerWaitMessage*/}
                {/*liveViewer*/}
                {/*<Text style={{fontSize: 12, backgroundColor: "rgba(255,0,0,0.5)", position: 'absolute', left: 5, top: 80, paddingLeft: 3, paddingRight: 3}}>{data.PostId + " row " + index + " cvpi " + this.state.currVideoPlayIndex + " clvpi " + this.state.currLongVideoPlayIndex + (playThisVideo ? " play" : " paused") + isLongVideoStr + ' ' + postDurationStr}</Text>*/}
                {songDetail}
                {linkPostDetail}
                {overlayTags}
                {overlayIcons}
                {shopitView}
                {switchToStreamViewBtn}
                {twoCircleCommentPopupView}
              </View>

              {footerView}
              
              { (this.state.animatedLove && this.lastPostLove && this.lastPostLove.Kind == 'wall' && (this.lastPostLove.PostId === data.PostId)) ? this.heartsAnimation : null }

            </View>
          : <View style={{ width : '100%', height : postHeight, flex : 1, display : 'flex' }}>
              {topGap}
              {headerView}
              <TouchableOpacity
                activeOpacity={1}
                MOVEDonPress={() => this.onImagePress(data, index)}
                style={{ backgroundColor: tileColor, width: imageWidth, height: imageHeight, margin: 0 }}>
                {videoView}
                {/*<Text style={{fontSize: 12, backgroundColor: "rgba(255,0,0,0.5)", position: 'absolute', left: 5, top: 80, paddingLeft: 3, paddingRight: 3}}>{data.PostId + " row " + index + " cvpi " + this.state.currVideoPlayIndex + " clvpi " + this.state.currLongVideoPlayIndex + (playThisVideo ? " play" : " paused") + isLongVideoStr + ' ' + postDurationStr}</Text>*/}
                {imageView}
                {goLiveButton}
                {liveViewerWaitMessage}
                {liveViewer}
                {songDetail}
                {linkPostDetail}
                {overlayTags}
                {overlayIcons}
                {shopitView}
                {switchToStreamViewBtn}
                {twoCircleCommentPopupView}
              </TouchableOpacity>
              {videoPlayButtonView}

              {footerView}
              { (this.state.animatedLove && this.lastPostLove && this.lastPostLove.Kind == 'wall' && (this.lastPostLove.PostId === data.PostId)) ? this.heartsAnimation : null }


            </View>
      }
      else // https://stackoverflow.com/questions/33761012/how-to-place-an-image-on-top-of-other-image-in-react-native
        //             <View style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}>
        return (
          <TouchableOpacity
            activeOpacity={1}
            onPress={() => this.onImagePress(data, index)}
            style={{ backgroundColor: tileColor, width: imageWidth - 2, height: imageHeight - 2, margin: 2 }}>
            {topGap}
            <ImageRecycler
              useCache={this.props.options.useCache}
              style={{ width: imageWidth - 4, height: imageHeight - 4 }}
              resizeMode="cover"
              source={{ uri: url, cache: 'force-cache' }}
              loadingOpacity={this.props.options.loadingOpacity}
            />
            {songDetail}
            {linkPostDetail}
            {overlayTags}
            {overlayIcons}
            {shopitView}
          </TouchableOpacity>
        )
        }
    }

  setVideoReference = (PostId, component) => {
    // console.tron.display does not work here
    if (!component) {
    }
    else {
      /*
            component.setNativeProps({
              muted: false,
            })
      */
    }

    // record the last 20 or 30 here.  If one sound is playing, try to turn off the previous one

    // this.scroll.video = newPlayIndex != -1 ? candidates[bestCandidate] : { rowIndex: -1 }
    // this.setState({ currVideoPlayIndex: newPlayIndex })

  }

  postIdToRef(postId) {
    return `ref_${postId}`
  }

  playVideo(details) {

    // if we dont want to hide the play button it means it is a long video and so we shouldnt auto play it
    // if (!this.shouldHidePlayButton(details.postId, details.rowIndex)) return
    // if (!this.shouldHidePlayButton(details.postId, details.rowIndex))
    //  details = { postId: null, rowIndex: -1 };

    if (this.scroll.video.rowIndex != details.rowIndex) {
      console.tron.log(`playVideo postId: ${details.postId}, rowIndex: ${details.rowIndex}`)
      this.scroll.video = details
      this.setState({ currVideoPlayIndex: details.rowIndex, currLongVideoPlayIndex: -1 })
    }
    /*
        // FUTURE will only be useable when setNativeProps function is written for the Video component
        console.tron.log(`playVideo postId: ${details.postId}, refs: ${this.refs.length}`)
        if (this.scroll.video.PostId)
          if (this.refs[this.postIdToRef(this.scroll.video.PostId)])
            this.refs[this.postIdToRef(this.scroll.video.PostId)].setNativeProps({
              muted: true,
              opacity: 1,
            })
        this.scroll.video = Object.assign({}, details)
        if (details.postId)
          if (this.refs[this.postIdToRef(details.postId)])
            this.refs[this.postIdToRef(details.postId)].setNativeProps({
              muted: false,
              opacity: 0.50,
            })
    */
  }

  _onScrollThumbs = (event) => {
    // console.tron.log(`_onScrollThumbs ${JSON.stringify(event.nativeEvent)}`)
    const offsetY = event.nativeEvent.contentOffset.y

    if (!this.props.options.useOnScroll)
      return
    const now = Date.now()
    this.scroll.lastChecked = now
    this.scroll.lastOffsetY = offsetY
  }

  // https://github.com/Flipkart/recyclerlistview/blob/master/src/core/RecyclerListView.tsx
  // https://github.com/Flipkart/recyclerlistview/issues/115
  // _onScroll(event) {
  _onScroll = (rawEvent) => {
    const offsetY = rawEvent.nativeEvent.contentOffset.y
    // console.log(`_onScroll offsetY ${offsetY}`)
    // save in case we want to go directly back to it
    this.scrollOffsetY = offsetY
    if (this.props.transparentPanels) {
      Animated.timing(this.buttonsFadeInOut, { toValue: 0, duration: 100 }).start( )
      if (this.fadeInThread) {
        clearTimeout(this.fadeInThread)
        delete this.fadeInThread
        this.fadeInThread = null
      }
      this.fadeInThread = setTimeout(() => Animated.timing(this.buttonsFadeInOut, { toValue: 1, duration: 200 }).start( ), 100)
    }

		if (this.props.slowNetwork) // no auto-play video and music
			return

		// make sure we are playing the post's video and music, if available
		const now = Date.now()
    const minScrollDelta = 7
    const scrollDelta = Math.abs(this.scroll.lastOffsetY - offsetY)
    this.scroll.lastChecked = now
    this.scroll.currOffsetY = offsetY
    if (!this.inScrollCheck && scrollDelta > minScrollDelta) {
      this.inScrollCheck = true
      this.scroll.lastOffsetY = offsetY
      newPlayPost = this.findMostVisiblePost(rawEvent, offsetY)
      if (newPlayPost) {
        if (this.scroll.video.rowIndex != newPlayPost.rowIndex) {
          this.preloadNearbyPosts(newPlayPost.rowIndex) 
          this.setSong(newPlayPost.Song, `_onScroll`)
          this.playVideo(newPlayPost)
        }
      }
      else {
        this.clearSong()
        this.playVideo({ postId: null, rowIndex: -1 })
      }
      // this._playVisibleVideo(rawEvent, offsetY, newPlayPost)
      this.inScrollCheck = false
    }
  }

  _onScrollFullScreen = (rawEvent) => {
		if (this.props.slowNetwork) // no auto-play music
			return

		const offsetY = rawEvent.nativeEvent.contentOffset.y
		const offsetX = rawEvent.nativeEvent.contentOffset.x
		const now = Date.now()
		const movedEnough = this.state.landscape ? Math.abs(this.scroll.lastOffsetX - offsetX) > 15 : Math.abs(this.scroll.lastOffsetY - offsetY) > 15
		this.scroll.lastChecked = now
    if (!this.inScrollCheckFullScreen && movedEnough) {
      this.inScrollCheckFullScreen = true
			this.scroll.lastOffsetY = offsetY
			this.scroll.lastOffsetX = offsetX
			const minFrameDimension = Math.min(screenHeight, screenWidth)
			const maxFrameDimension = Math.max(screenHeight, screenWidth)
			const isLandscape = offsetX > 0
			const frameSize = maxFrameDimension // isLandscape ? minFrameDimension : maxFrameDimension
			const offset = isLandscape ? offsetX : offsetY
			const postIndex = Math.floor(0.1 + offset / frameSize) // 17.005, 17.999 (should be 18)

      if (this.fullScreenPortraitProgress && this.fullScreenPortraitProgress.playIndex != postIndex)
        this.fullScreenPortraitProgress = null
      if (this.fullScreenLandscapeProgress && this.fullScreenLandscapeProgress.playIndex != postIndex)
        this.fullScreenLandscapeProgress = null

      if (postIndex == this.fsMusicPostIndex)
        return
      this.fsMusicPostIndex = postIndex
			console.log(`_onScrollFullScreen offsetX: ${offsetX} offsetX: ${offsetY} postIndex: ${postIndex} isLandscape: ${JSON.stringify(isLandscape)} offset: ${offset} frameSize: ${frameSize}`)
			const postData  = this.state.dataProviderFullScreen.getAllData()
			if (postIndex != null && postIndex < postData.length) {
				const newPlayPost = postData[postIndex]
				const nextPlayPost = postIndex + 1 < postData.length ? postData[postIndex+1] : null
				if (newPlayPost)
					this.setSong(newPlayPost.Song, `_onScrollFullScreen postIndex ${postIndex}`)
				// Current sound player only has a single buffer, so preloading is problematic
				// if (!newPlayPost.Song && nextPlayPost) // only one song buffer, so only load next one if current post does not have a song
				//	this.preloadSong(nextPlayPost.Song, `_onScrollFullScreen postIndex ${postIndex}`)
			}
      else
        this.clearSong()
      // this._playVisibleVideo(rawEvent, offsetY, newPlayPost)
      this.inScrollCheckFullScreen = false
    }
  }

  preloadNearbyPosts(mostVisibleRowIndex) {
    const postData = this.state.dataProvider._data
    const nFwd = 5 // note:  this is 5 posts fwd...if all of those are videos, we won't preload any of these full JPGs
    let firstPreloadIndex = mostVisibleRowIndex + 1
    let maxFwd = firstPreloadIndex + nFwd
    // clamp to max
    if (firstPreloadIndex > postData.length - 1) firstPreloadIndex = postData.length - 1
    if (maxFwd > postData.length - 1) maxFwd = postData.length - 1
    let sources = []
    for (let i = firstPreloadIndex; i < maxFwd; i++) {
      const post = postData[i]
      if (post.MediaType === 'JPEG') {
        const url = `${KargoeConfig.baseUrlMedia}/${post.PostId}.jpg?${post.Version}`
        if (!PostWallBase.preloadedImageUrls[url]) {
          //console.log("url to preload = " + url)
          PostWallBase.preloadedImageUrls[url] = true
          sources.push({uri : url})
        } else {
          // debug console.log("already preloaded image dont do it again " + url)
        }
      }
    }
    if (false)
    FastImage.preload(sources)
  }

  findMostVisiblePost = (rawEvent = null, offsetY = 0) => {
    // TODO - could make this more efficient in future, not always starting from the beginning
    // ***** NOTE: only one call to console.tron.log will be seen within onScroll??? *****
    // console.tron.display causes some sort of recursive loop, uses tons of memory and crashes
    // console.tron.log(`_onScroll rawEvent.nativeEvent: ` + JSON.stringify(rawEvent.nativeEvent)) // lots of details
    offsetY = Math.round(offsetY)
    const postData = this.state.dataProvider._data // this.state.viewMode !== VID_MODE ? this.state.dataProvider._data : this.state.vidDataProvider._data
    const screenTop = offsetY
    const screenBottom = rawEvent ? Math.round(offsetY + rawEvent.nativeEvent.layoutMeasurement.height) : Math.round(offsetY + screenHeight)
    const screenMiddle = (screenTop + screenBottom) / 2
    const videoInfo = this.scroll.video
    const topGap = this.HomeWall ? LIST_TOP_GAP : 0
    // April 23, 2020 - We are using this for playing Music as well, can be for image
    let rowIndex = 0
    let rowTop = 0
    let bestCandidate = 0 // ... for video and music playback, there can only be one!
    let candidates = [] // which one to play, and in future which to cache
    for (rowIndex = 0; rowIndex < postData.length && rowTop < screenBottom; rowIndex++) {
      const isHeader  = rowIndex == 0 && typeof postData[rowIndex].Header != 'undefined'
      const rowHeight = isHeader ? this.headerRowHeight : postData[rowIndex]['ListHeight'] + (rowIndex == 0 ? topGap : 0)
      const rowBottom = rowTop + rowHeight
      if (true) // postData[rowIndex]['MediaType'] != 'JPEG')
        if (rowBottom - LIST_VIDEO_BOTTOM_SLOP > screenTop && rowTop + LIST_VIDEO_TOP_SLOP < screenBottom) {
          let coverage = 100 // fully on the screen
          const postImageTop = rowTop + LIST_HEADER_HEIGHT
          const postImageBottom = rowBottom - LIST_FOOTER_HEIGHT
          if (postImageTop < screenTop)
            coverage -= Math.round(100 * (screenTop - postImageTop) / rowHeight)
          if (postImageBottom > screenBottom)
            coverage -= Math.round(100 * (postImageBottom - screenBottom) / rowHeight)
          candidates.push({
            postId: postData[rowIndex]['PostId'],
            mediaType: postData[rowIndex]['MediaType'],
            rowIndex: rowIndex,
            rowHeight: rowHeight,
            rowTop: rowTop,
            rowBottom: rowBottom,
            coverage: coverage,
            Song: postData[rowIndex]['Song']
          })
          if (coverage > candidates[bestCandidate].coverage)
            bestCandidate = candidates.length - 1
        }
      rowTop += rowHeight
    } // rowIndex

    let newVisiblePost = false

    const post = candidates.length > 0 ? candidates[bestCandidate] : null
    if (!post)
      this.lastVisiblePostId = null
    else {
      if (this.lastVisiblePostId != post.postId) {
        //console.log(`findMostVisiblePost offsetY ${offsetY}, screenTop ${screenTop}, postId ${post.postId}, row ${post.rowIndex}, rHeight ${post.rowHeight}`)
        this.lastVisiblePostId = post.postId
        newVisiblePost = true
      }
    }
    // console.tron.log(`findMostVisiblePost: ` + JSON.stringify(post))

    // hack for testing web right side view, put in redux later instead of on window
    if (Platform.OS == 'web' && newVisiblePost) {

      console.info("setting most visible post = " + JSON.stringify(post, null, 2))
      //window.mostVisiblePost = post

      // is this efficient or does it do it every time even if it doesnt need it?  should check...
      // after the refresh occurs is when we want to send it (hence should do thru redux anyway)

      console.log("post keys = " + Object.keys(post))

      this.updateForPostView(post) // make sure we have extended data

      // this is a hack to get things going on aux view

      setTimeout(() => {
        const refreshedPost = postData.find((p) => p.PostId == post.postId) // lower case postId here wow
        //console.info("refreshedPost = " + JSON.stringify(refreshedPost, null, 2))

        // check this also earlier to avoid re-pulling the post from server

        if (newVisiblePost) {

          console.info("***** different post!")

          window.mostVisiblePost = refreshedPost

          window.updateForPostView = this.updateForPostView // need some better way to get this to the alt comments panel on right

          this.props.setForceRefreshIndex(Math.random()) // force refresh at swiper level so right side window gets updated
        }

      }, 0)

    }

    return post
  }

  _playVisibleVideo = (rawEvent = null, offsetY = 0, newPlayPost = null) => {
    if (!this.props.options.useOnScroll)
      return
    if (newPlayPost == null)
      newPlayPost = this.findMostVisiblePost(rawEvent, offsetY)
    // do not compare using state as that change is not immediate
    if (newPlayPost && this.scroll.video.rowIndex != newPlayPost.rowIndex) {
      // console.tron.log(`_playVisibleVideo newPlayIndex offsetY ${offsetY} change ${newPlayPost.rowIndex}`)
      // if (newPlayPost.mediaType != 'JPEG') // need to always call, in case we need to turn off video...
      this.playVideo(newPlayPost != null ? newPlayPost : { postId: null, rowIndex: -1 })
    }
    else {
      // console.tron.log(`_play VisibleVideo newPlayIndex ${newPlayIndex} unchanged`)
    }
  }

  _indexesChanged(all, now, notNow) {

    this.currentVisibleIndexes = all

    // all contains indexes of all rows visible, even partially. now is sometimes empty, if first row partly visible, now is the one that is fully visible

    // details about visible cellIndicies
    // perhaps use initialRenderIndex to maintain position when changing between grid and list views
    // see initialRenderIndex property https://github.com/Flipkart/recyclerlistview/blob/593b7636264a49eb17bf75f88513420b8f0c9b85/src/core/RecyclerListView.tsx#L478-L547
    // TODO - AND NOT FETCHING DETAIL...
    if (!this.props.options.getExtendedData)
      return
    const postData = this.state.dataProvider.getAllData()

/*
    let haveVideos = false
    for (let i = 0; i < all.length && i < postData.length; i++) {
      if (postData[all[i]]['MediaType'] != 'JPEG') {
        haveVideos = true
        this.visibleRowsHaveVideos = haveVideos
      }
    }
*/
    // console.tron.log(`_indexesChanged, postData.length: ${postData.length}, mode: ${this.state.viewMode}, fetching: ${this.props.postdetails.fetching}, all.length: ${all.length}`)
    // console.tron.log(`_indexesChanged, all: ${JSON.stringify(all)}, now: ${JSON.stringify(now)}, postData.length: ${postData.length}, mode: ${this.state.viewMode}, fetching: ${this.props.postdetails.fetching}, all.length: ${all.length}`)

    let postIndex = all.length > 0 ? (all.length > 2 ? all[1] : all[0]) : null
    const isHeader = postIndex == 0 && typeof postData[postIndex].Header != 'undefined'
    if (isHeader)
      postIndex = 1
    // if (postIndex != null && postData && postData.length > postIndex && postData[postIndex].Song)
    //  this.setSong(postData[postIndex].Song)

    if (this.state.viewMode == LIST_MODE && !this.props.postdetails.fetching && all.length > 0 && postData.length > 0) {
      let firstRow = Math.max(0, all[0] - 2)
      let lastRow = Math.min(postData.length - 1, all[all.length - 1] + 2)

      let preLoadOk = true // have 2 before and 2 after
      for (let i = firstRow; i <= lastRow && preLoadOk; i++)
        if (typeof postData[i].NumViews == 'undefined')
          preLoadOk = false

      if (!preLoadOk) {

        let missingDetailedPostIds = []
        let preloadImageList = []
        firstRow = Math.max(0, all[0] - 4) // up to 4 beforefor a total of 10
        lastRow = Math.min(postData.length - 1, all[all.length - 1] + 50)
        for (let j = firstRow; j <= lastRow && missingDetailedPostIds.length < 10; j++) {
          const post = postData[j]
          if (post.PostId != 0 && typeof post.NumViews == 'undefined') {
            if (missingDetailedPostIds.length < 10)
              missingDetailedPostIds.push(post.PostId)
            if (this.props.options.preloadLargeImages)
              preloadImageList.push({
                uri: `${KargoeConfig.baseUrlMedia}/${post.PostId}-thumb.jpg?${post.Version}`
              })
          }
        }
        console.tron.log(`_indexesChanged, missingDetailedPostIds: ` + JSON.stringify(missingDetailedPostIds))


        if (missingDetailedPostIds.length > 0) {
          if (false && this.props.options.useCache)
            FastImage.preload(preloadImageList)
          // api call can only handle 10 postIds per call
          const options = {
            PostId: missingDetailedPostIds.splice(0, 1), // take the first id, and leave the rest
            PostIds: missingDetailedPostIds,
            GetLikes: true
          }
          if (this.lastReadPostOptions && this.lastReadPostOptions == JSON.stringify(options)) {
            console.tron.log(`_indexesChanged duplicate readPosts call, skipping`)
            return
          }
          this.lastReadPostOptions = JSON.stringify(options)
          this.props.readPosts(options)
        } // missingDetailedPostIds
      } // preLoadOk
    } // LIST_MODE

    // handle pause/play handling of videos - works but not exacting
    /*
        if (this.state.viewMode == LIST_MODE && all.length > 0 && postData.length > 0) {
          // https://github.com/Flipkart/recyclerlistview/blob/master/src/core/RecyclerListView.tsx
          // getCurrentScrollOffset, findApproxFirstVisibleIndex
          const mainViewIndex = now.length > 0 ? now[0] : all[0]
          const newPlayIndex = postData[mainViewIndex]['MediaType'] != 'JPEG' ? mainViewIndex : null
          if (newPlayIndex != this.state.currVideoPlayIndex) {
            console.tron.log(`PostWallBase IndexesChanged, newPlayIndex: ${newPlayIndex}`)
            this.setState({currVideoPlayIndex: newPlayIndex})
          }
        }
    */
	}

	fullScreenFadeDetailNow = (fadeoutDuration = 666) => {
		// .stop() to stop any animations
		this.fsDetailState = 'fadingOut'
		Keyboard.dismiss()
		Animated.timing(this.fsDetailFadeInOut, {toValue: 0, duration: fadeoutDuration}).start(({finished}) => {
			if (finished)
				this.fsDetailState = 'hidden'
		})
	}
	
	fullScreenShowDetailNow = (fadeInDuration = 333) => {
		this.fsDetailState = 'fadingIn'
		Animated.timing(this.fsDetailFadeInOut, {toValue: 1, duration: fadeInDuration}).start(({finished}) => {
			if (finished)
				this.fsDetailState = 'showing'
		})
	}
	
	fullScreenResetDetailFadeTimer = (timeToFadeout = 5000, timeToFadeIn = 333) => {
		if (timeToFadeout == null)
			timeToFadeout = 5000
		console.log(`fullScreenResetDetailFadeTimer ms: ${timeToFadeout}`)
		this.fullScreenShowDetailNow(timeToFadeIn)
		timeToFadeout = timeToFadeout + timeToFadeIn
		if (this.fsDetailFadeInOutTimer)
			clearTimeout(this.fsDetailFadeInOutTimer)
		this.fsDetailState = 'fadeOutTimer'
		this.fsDetailFadeInOutTimer = setTimeout(() => {
			console.log(`fullScreenResetDetailFadeTimer animation begins`)
			this.fsDetailFadeInOutTimer = null
			this.fullScreenFadeDetailNow()
		}, timeToFadeout)
	}

	fullScreenClearDetailFadeTimer = () => {
		if (this.fsDetailFadeInOutTimer) {
			console.log(`fullScreenClearDetailFadeTimer clearing timer`)
			clearTimeout(this.fsDetailFadeInOutTimer)
			this.fsDetailFadeInOutTimer = null
			this.fullScreenShowDetailNow(1)
		}
	}

  _indexesChangedFullScreen(all, now, notNow) {
    if (!this.props.options.getExtendedData)
			return
		const fsViewingSinglePost = all.length == 1
		console.log(`_indexesChangedFullScreen single: ` + JSON.stringify(fsViewingSinglePost) + ` all:` + JSON.stringify(all) + ` now: ` + JSON.stringify(now))
    const postData  = this.state.dataProviderFullScreen.getAllData()
		const postIndex = all.length > 0 ? all[0] : null
		
		// fade out post details after 5 seconds
		if (fsViewingSinglePost) {
			this.currentFullScreenPostIndex = postIndex
			if (this.fsDetailFadeInOutTimer == null) {
				console.log(`_indexesChangedFullScreen fade setting timer`)
				this.fullScreenResetDetailFadeTimer(null, 1)
				if (postIndex < postData.length) {
					const newPlayPost = postData[postIndex]
					if (newPlayPost)
						this.setSong(newPlayPost.Song, `_indexesChangedFullScreen postIndex ${postIndex}`)
				}
				else
					this.clearSong()
			}
		}
		else if (!fsViewingSinglePost && this.fsDetailFadeInOutTimer)
			this.fullScreenClearDetailFadeTimer()

    if (!this.props.postdetails.fetching && all.length > 0 && postData.length > 0) {
      const firstRow = Math.max(0, postIndex - 2)
      let missingDetailedPostIds = []
      let preloadImageList = []
      for (let j = firstRow; j < postData.length && missingDetailedPostIds.length < 10; j++) {
        const post = postData[j]
        if (post.PostId != 0 && typeof post.NumViews == 'undefined') {
          missingDetailedPostIds.push(post.PostId)
          if (false && this.props.options.preloadLargeImages) // not sure how this helps...
            preloadImageList.push({
              uri: `${KargoeConfig.baseUrlMedia}/${post.PostId}-thumb.jpg?${post.Version}`
            })
        }
      }
      console.tron.log(`_indexesChangedFullScreen, missingDetailedPostIds: ` + JSON.stringify(missingDetailedPostIds))

      if (missingDetailedPostIds.length > 0) {
        if (false && this.props.options.useCache)
          FastImage.preload(preloadImageList) // note:  this was not getting called (as of Feb 11 2021) because we had fake fast image
                                              // included, which does not have preload (.preload call crashes)
                                              // see other call to FastImage.preload in PostWallBase.js for more info
        // api call can only handle 10 postIds per call
        const options = {
          PostId: missingDetailedPostIds.splice(0, 1), // take the first id, and leave the rest
          PostIds: missingDetailedPostIds,
          GetLikes: true
        }
        if (this.lastReadPostOptions && this.lastReadPostOptions == JSON.stringify(options)) {
          console.tron.log(`_indexesChangedFullScreen duplicate readPosts call, skipping`)
				}
				else {
					this.lastReadPostOptions = JSON.stringify(options)
					this.props.readPosts(options)
					}
      } // missingDetailedPostIds
    } // LIST_MODE

    // handle pause/play handling of videos - works but not exacting
    if (postIndex != null) {
      if (postIndex != this.state.currFullScreenVideoPlayIndex) {
        console.tron.log(`PostWallBase _indexesChangedFullScreen, newPlayIndex: ${postIndex}`)
        this.setState({fsViewingSinglePost, fullScreenVideoProgress: 0, currFullScreenVideoPlayIndex: postIndex, fullScreenAutoAdvance: true, fullScreenDetailMode: null})
      }
      else
        this.setState({fsViewingSinglePost, fullScreenVideoProgress: 0, fullScreenAutoAdvance: true, fullScreenDetailMode: null})
		}
		else
			this.setState({fsViewingSinglePost})
  }

  componentDidUpdate(prevProps, prevState) {

		//console.log(`PostWallBase componentDidUpdate`)
    if (this.props && this.props.auth && this.props.auth.user)
    if (prevProps.auth.user.UserId != this.props.auth.user.UserId) {
      this.askForRefresh();
    }
    else { // web:  just logged out no UserId, route to auth
      // console.log("route to auth from post wall base hmm no shouldnt")
      //this.props.navigation.navigate({routeName:'auth'})
      // may want to reset the stack 
      //return
    }
    if (prevState.refreshing !== this.state.refreshing && this.state.refreshing == true) {
      console.tron.log(`PostWallBase componentDidUpdate refreshing`)
      //console.log(`PostWallBase componentDidUpdate refreshing`)
      this._loadMoreData()
    }
    if (prevState.hasNewPost !== this.state.hasNewPost && this.state.hasNewPost == true) {
      console.tron.log(`PostWallBase componentDidUpdate hasNewPost`)
      console.log(`PostWallBase componentDidUpdate hasNewPost`)
      this._loadMoreData()
    }
    if (prevState.data !== this.state.data && this.state.viewMode == LIST_MODE) {

      // if (this.state.data.length > 0) {
      //   const index = this.listScrollView.findApproxFirstVisibleIndex()


      //   this._indexesChanged([index], [index], null)
      // }

    }
    if (this.state.actionOptions !== prevState.actionOptions) {
      this.actionSheet.showActionSheet()
    }
    let alreadyCalledScrollModeToIndex = false
    if (prevState.data !== this.state.data &&  this.state.data.length > 0 && this.initialRow > 0) {
      console.tron.display({ name: `initialRow`, preview :`componentDidUpdate`, value: { initialRow:  this.initialRow } })

      this.scrollModeToIndex(this.state.viewMode, this.initialRow)
      this.initialRow = -1
      alreadyCalledScrollModeToIndex = true
    }
    if (!alreadyCalledScrollModeToIndex && prevState.data !== this.state.data &&  this.state.data.length > 0  && this.initialPostId != null) {

      //console.log("this.state.data = " + JSON.stringify(this.state.data))
      const nextIndexScroll2 = this.state.data.findIndex(e => e.PostId === this.initialPostId)
      //console.log("nextIndexScroll2 = " + nextIndexScroll2) // this is showing -1
      if( nextIndexScroll2 !== -1 ) {
         setTimeout(() => {
          this.scrollModeToIndex(this.state.viewMode, nextIndexScroll2, 1000 /*delay use default*/, this.state.thenOpenPostView, this.state.commentTimeStamp)

          this.state.thenOpenPostView = false // just clear it dont use setState so it doesnt re-render
          this.state.commentTimeStamp = 0 

            // need to find the full post associated w/ the initialPostId
            // this.showPostView(post, 'Comments')

         }, 250)
      }
      //else alertView("Deleted", "This post has been deleted.")
      this.initialPostId = null
      alreadyCalledScrollModeToIndex = true
    }

    if (!alreadyCalledScrollModeToIndex && this.state.dataProvider._data.length > 0 && this.state.indexScroll >= 0 && (this.state.indexScroll !== prevState.indexScroll || prevState.viewMode != this.state.viewMode) && this.state.viewMode == LIST_MODE) {
      this._indexesChanged([this.state.indexScroll], [this.state.indexScroll], [this.state.indexScroll])
      // this.lastModeScrollIndex = this.state.viewMode + this.state.indexScroll
      this.lastModeScrollIndex = this.state.viewMode
      const nextIndexScroll = this.state.indexScroll
      console.tron.log(`PostWallBase componentDidUpdate viewMode ${this.lastModeScrollIndex}, nextIndexScroll: ${nextIndexScroll}`)
      // setTimeout(() => {
      this.scrollModeToIndex(this.state.viewMode, nextIndexScroll)
      //  }, 250) // 250 *** Works *** otherwise scrollTo was called before RecyclerListView was measured, wait for mount to finish
      // this.scrollToNextTime = this.state.indexScroll
    }

    if (this.props.nav.routes.length == 1 && this.props.kargoeTags && prevProps.kargoeTags.modified != this.props.kargoeTags.modified) {
      // result from a scan of an item
      const { kargoeTags } = this.props
      if (!kargoeTags.error) {
        console.tron.display({name: `PostWallBase`, preview : `componentDidUpdate, kargoeTags changed`, value: { kargoeTags, class: this.constructor.name }})
        const items = kargoeTags.kargoeTags
        if (items.length == 1) {
          console.tron.log(`Found an item, switching to camera`)
          // alertView("👍", "Take a photo or video, or pick from your gallery and follow further instructions to get a Coupon") // switching to camera, must use native alert
          // this.props.changeIndex({indexChange : 0, 'barcoderOutput' : kargoeTags.data.search}) // for EditPostScreen use
          this.props.changeIndex({ indexChange : 0, ktagCallerInfo : items[0] })
        }
        else {
          this.setErrorMessage("This item is unknown")
        }
      }
    }

    if (this.props.coupon && this.props.nav.routes.length == 1) {
      if (prevProps.coupon.getVendor.modified != this.props.coupon.getVendor.modified) {
        if (this.props.coupon.getVendor.phase == 'success' && this.props.coupon.getVendor.record) {
          if (!this.alertCount) this.alertCount = 0
          else this.alertCount += 1
          if (this.alertCount === 0 && this.props.swiperIndex === 1) {
            alertView("👍", I18n.t("editpost.afterQR")) // switching to camera, must use native alert
            this.props.changeIndex({indexChange : 0, 'barcoderOutput' : 'kargoev-' + this.props.coupon.getVendor.UserId}) // for EditPostScreen use
          }
        }
        else {
          this.setErrorMessage("This vendor is unknown") // alertView("👎",
        }
      }

      if (prevProps.coupon.getOffer.modified != this.props.coupon.getOffer.modified) {
        console.log("prevProps.coupon.getOffer = " + JSON.stringify(prevProps.coupon.getOffer))
        console.log("this.props.coupon.getOffer = " + JSON.stringify(this.props.coupon.getOffer))
        console.log("in this class:  " + this.constructor.name)
        const newOffer = this.props.coupon.getOffer
        console.tron.display({name: `PostWallBase`, preview : `componentDidUpdate, getOffer changed`, value: { newOffer, class: this.constructor.name }})
        if (newOffer.phase === 'success' && newOffer.record) {
          const offer = newOffer.record
          // cannot store in "this", the whole post wall base seems to get re-created and then this
          // alert re-pops on tagging page

          if (!this.alertCount) this.alertCount = 0
          else this.alertCount += 1
          console.log("calling alert view from post wall base, count = " + this.alertCount)

          // this is getting displayed twice, so count, only do it the first time
          // when to clear this?  after a post is made or when wall is refreshed?

          // route name is home both times

          // we only want to alert the user if this is a "from wall" qr code, not from internal to camera.
          // if internal to camera, we're already in camera, and we have already popped an alert.
          // how to do this?

          // model from swiper container screen in map state to props:  swiperIndex: state.swiper.indexChange,
          // but we need to use subclass post wall v2 screen to set this up, what?
          // 2nd term:  only pop the alert and slide to camera if we are not already there

          console.log("staring to think of alert in post wall base, this.props.swiperIndex is " + this.props.swiperIndex)

          if (this.alertCount === 0 && this.props.swiperIndex === 1) {
            if (offer.UserKind == USER_KIND.MERCHANT) {
              this.setErrorMessage("QR Code is for an Offer from a Merchant, which is invalid") // alertView("👎",
            }
            else {
              alertView("👍", I18n.t("editpost.afterQR")) // switching to camera, requires native alert
              // how to pass this barcoder result along ... to camera screen i guess
              console.log("this.props.coupon.getOffer = " + JSON.stringify(this.props.coupon.getOffer))
              this.props.changeIndex({indexChange : 0, 'barcoderOutput' : 'kargoeo-' + this.props.coupon.getOffer.OfferId})
            }
          }
        }
        else if (newOffer.phase === 'error' && newOffer.error) {
          // if no nicely printable error detail, dump the whole thing so we can debug
          let strToPrint = newOffer.error.detail || JSON.stringify(newOffer.error)
          strToPrint = strToPrint + ' ... Look around for more Kargoe QR codes for more special offers!'
          // reference for error situtation expired:
          // this.props.coupon.getOffer = {"phase":"error","error":
          // {"httpCode":404,"code":8910,"title":"Get Offer Exception","detail":"This offer expired 2019-08-12"},
          // "logRef":"iAyxBU","modified":1565975547581,"OfferId":"AS5758b527028b600001ac1f18a32d6c-1565643525.164228","Code":null,"record":null}
          let title = "👎"
          if (strToPrint.match("expired")) title = "QR code expired"
          this.setErrorMessage(strToPrint)
        }
        else
          this.setErrorMessage("This QR code is unknown")
      }
    }

    if (prevProps.posts.updatePostSuccess != this.props.posts.updatePostSuccess && this.props.nav.routes.length == 1) {
      const { newPostMeta = null } = this.props.posts
      console.tron.log(`PostWawllBase this.props.posts.updatePostSuccess, meta: ` + JSON.stringify(newPostMeta))
      if (newPostMeta && newPostMeta.couponList && newPostMeta.couponList.length) {
        console.tron.log(`PostWawllBase this.props.posts.updatePostSuccess showing alert`)
        this.setAlertMessage("You can view your new Coupons in My Wallet") // alertView("👍",
      }
    }
  }
  
  mergePost(miniPost, post) {
    // console.tron.log(`mergePost begins`)
    const fakeOverrides = typeof miniPost.FakeMiniPost != 'undefined' ? {
      UserId: post.UserId,
      AspectRatio: post.AspectRatio,
      Origin: post.Origin,
      MediaType: post.MediaType,
      Version: post.Version,
      Selling: post.Selling,
      HasUser: post.HasUser,
      Type: post.Type,
      MiniMeta: post.MiniMeta
    } : {}
    let metaConv = null
    try {
      if (typeof post.Meta === 'string') // old way parse
        metaConv = post.Meta ? JSON.parse(post.Meta) : null
       else // new way just pass it thru
        metaConv = post.Meta
    }
    catch (Exception) {
      // do nothing
      console.tron.log(`Post ${post.PostId}, Meta: ${post.Meta}`)
    }
    // ItemId:59462-0480177233782_shop
    let theySell = deepClone(post.TheySell)
    if (typeof theySell != 'undefined')
      theySell = theySell.filter(entry => KargoeConfig.shoppable.active || !entry.ItemId.includes('_shop'))
    //console.log("post = " + JSON.stringify(post, null, 2))
    const StreamStatus = 0 // post.Caption == liveStreamCaption && post.StreamStatus == 0 ? LiveBroadcastScreen.POST_STREAM_STATUS_NOT_STARTED : post.StreamStatus
    let mergedPost = Object.assign(miniPost, {
      Username: post.Username,
      Caption: post.Caption,
      NumViews: post.NumViews,
      NumLikes: post.NumLikes,
      NumComments: post.NumComments,
      RecentComments: post.RecentComments,
      UserLovesPost: post.UserLikesPost,
      LocationName: post.LocationName,
      LocationCoord: post.LocationCoord, // string "lat,long" (maybe lat long or is it long, lat, dont know yet)
      LocationId: post.LocationId, // string, google location id 
      Donate: post.Donate,
      ISell: post.ISell,
      TheySell: theySell,
      UserTags: post.UserTags,
      Meta: metaConv,
      Modified: post.Modified * 1000,
      Tags: post.Tags,
      Censor: post.Censor,
      Song: post.Song,
      StreamStatus,
      StreamURL: post.StreamURL
    },
      fakeOverrides)
    //console.log(`mergePost: ` + JSON.stringify(mergedPost))
    // console.tron.log(`mergePost finished`)
    return mergedPost
  }

  updateExtendedPostData(postdetails, nextLove = null) {
    //console.log("update extended post data for " + JSON.stringify(postdetails, null, 2))
    // console.tron.log("PostWallBase updateExtendedPostData");
    if (true) {
      // update data
      let changeCount = 0
      let changed = false
      let updatedPosts = this.state.dataProvider._data.concat()
      var postIds = updatedPosts.map(function (a) {
        return a.PostId
      })

      if (postdetails.posts) {
        postdetails.posts.forEach((post, i) => {
					// console.tron.display({name: `updateExtendedPostData`, preview: `post`, value: post})
          const index = post && typeof post.PostId != 'undefined' ? postIds.indexOf(post.PostId) : -1
          // if (index !== -1 && (typeof updatedPosts[index].NumViews == 'undefined')) {
          if (index !== -1) { // accept updates
            changed = true
            changeCount++
            if (typeof this.userNames[post.UserId] == 'undefined')
              this.userNames[post.UserId] = post.Username

            updatedPosts[index] = this.mergePost(updatedPosts[index], post)
/*
            const fakeOverrides = typeof updatedPosts[index].FakeMiniPost != 'undefined' ? {
              UserId: post.UserId,
              AspectRatio: post.AspectRatio,
              Origin: post.Origin,
              MediaType: post.MediaType,
              Version: post.Version,
              Selling: post.Selling,
              HasUser: post.HasUser,
              Type: post.Type,
              MiniMeta: post.MiniMeta
            } : {}
            let metaConv = null
            try {
              if (typeof post.Meta === 'string') // old way parse
                metaConv = post.Meta ? JSON.parse(post.Meta) : null
               else // new way just pass it thru
                metaConv = post.Meta
            }
            catch (Exception) {
              // do nothing
              console.tron.log(`Post ${post.PostId}, Meta: ${post.Meta}`)
            }
            // ItemId:59462-0480177233782_shop
            let theySell = deepClone(post.TheySell)
            if (typeof theySell != 'undefined')
              theySell = theySell.filter(entry => KargoeConfig.shoppable.active || !entry.ItemId.includes('_shop'))
            updatedPosts[index] = Object.assign(updatedPosts[index], {
              Username: post.Username,
              Caption: post.Caption,
              NumViews: post.NumViews,
              NumLikes: post.NumLikes,
              NumComments: post.NumComments,
              RecentComments: post.RecentComments,
              UserLovesPost: post.UserLikesPost,
              LocationName: post.LocationName,
              Donate: post.Donate,
              ISell: post.ISell,
              TheySell: theySell,
              UserTags: post.UserTags,
              Meta: metaConv,
              Modified: post.Modified * 1000,
              Tags: post.Tags,
              Censor: post.Censor,
              Song: post.Song,
            },
              fakeOverrides)
*/
            if (typeof updatedPosts[index].UserLovesPost === 'undefined') {
              // if undefined, set to false to try fix random broken love bug (not sure if this is correct solution)
              if (typeof post.NumLikes !== 'undefined') {
                log("**** caution. undefined UserLovesPost, set it to false to work around bug but may be wrong")
                updatedPosts[index].UserLovesPost = false
              }
              else log("**** caution, undefined UserLovesPost and NumLikes undefined also, what to do?")
            }

            log("just set updatedPosts[" + index + "] and set UserLovesPost to " + updatedPosts[index].UserLovesPost)

          }
        }) // forEach
      } // postdetails

      let mostRecentLoveTimeStamp = this.state.loveModified
      if (nextLove && nextLove.changes && nextLove.changes.length) { //  && nextLove.changes.length && nextLove.changes[0].TimeStamp > mostRecentLoveTimeStamp) {
        // oldest to most recent changes.  could improve by looking at toggling same Post state
        mostRecentLoveTimeStamp = nextLove.changes[0].TimeStamp
        for (let i = nextLove.changes.length - 1; i >= 0; i--) {
          const entry = nextLove.changes[i]
          if (entry.State != 'failure') {
            const love = entry.Relationship == 'Love'
            const index = postIds.indexOf(entry.PostId)
            if (index !== -1 && (typeof updatedPosts[index].UserLovesPost == 'undefined' || updatedPosts[index].UserLovesPost != love)) {
              changed = true
              changeCount++
              updatedPosts[index].UserLovesPost = love
              updatedPosts[index].NumLikes += love ? 1 : -1
            }
          }
        } // for
      } // love
      //console.log('clone with rows loc X')
      if (changed) {
        this.setState({
          loveModified: mostRecentLoveTimeStamp,
          postdetailsModified: this.props.postdetails.modified,
          postdetailsIntegrated: Date.now(),
          dataProvider: this.state.dataProvider.cloneWithRows(updatedPosts),
        })

        if (this.delayedInitialRow > 0) {
          const nextIndexScroll = this.delayedInitialRow
          setTimeout(() => {
            console.tron.log("PostWallBase updateExtendedPostData timed nextIndexScroll2: " + nextIndexScroll)
            this.scrollModeToIndex(this.state.viewMode, nextIndexScroll)
          }, 250)
          this.delayedInitialRow = -1
        }
        /*
                // we don't see extended post details right away for some reason, so force an update a bit later
                setTimeout(() => {
                  console.tron.log("PostWallBase updateExtendedPostData later state change...");
                  this.setState({postdetailsIntegrated: Date.now()})
                }, 500)
        */
      }
      else {
        console.tron.log("PostWallBase updateExtendedPostData no changes");
        this.setState({
          loveModified: this.props.love.modified,
          postdetailsModified: this.props.postdetails.modified
        })
      }
    }
  } // updateExtendedPostData

  componentWillReceiveProps(nextProps) {
		//console.log(`PostWallBase componentWillReceiveProps`)
		const stateChanges = calcScreenDepthState(this.state, nextProps.nav.routes, this.screenNavKey)
    if (nextProps.user && typeof nextProps.user.UserIsFollowing != 'undefined') {
			if (this.fullScreenIsFollowing) {
				//console.log(`PostWallBase componentWillReceiveProps fullScreenIsFollowing`)
				const userId = nextProps.user.UserId
				const needsUpdate = typeof this.fullScreenIsFollowing[userId] == 'undefined' || this.fullScreenIsFollowing[userId] != nextProps.user.UserIsFollowing
				// console.tron.log(`componentWillReceiveProps userId ${userId}, needsUpdate ${needsUpdate ? 'T' : 'F'} this.fullScreenIsFollowing: ` + JSON.stringify(this.fullScreenIsFollowing))
				if (needsUpdate) {
					//console.log(`PostWallBase componentWillReceiveProps fullScreenIsFollowing needsUpdate`)
					this.fullScreenIsFollowing[userId] = nextProps.user.UserIsFollowing
					this.setState({ forceUpdate: this.state.forceUpdate + 1 })
				}
			}
		}

    if (stateChanges)
      this.setState(stateChanges)
    if (this.props.unreadMessages !== nextProps.unreadMessages && nextProps.unreadMessages !== null) {

    }
    if (this.props.heightBio !== nextProps.heightBio && nextProps.heightBio !== null) {

      this.setState({
        heightBio: nextProps.heightBio
      })
    }
    if (this.props.currentPost !== nextProps.currentPost && nextProps.currentPost !== null) {

      const newState = this.state.data.map((val, index) => {
        return (val.PostId === nextProps.currentPost.PostId) ? nextProps.currentPost : val;
      });
      //console.log('clone with rows loc y')
      this.setState({
        dataProvider: this.state.dataProvider.cloneWithRows(newState),
        data: newState
      })

    }

    // if (nextProps.newPost != null && nextProps.newPost !== this.props.newPost && nextProps.updatePostSuccess && nextProps.updatePostSuccess != this.props.updatePostSuccess) {
    if (nextProps.updatePostSuccess && nextProps.updatePostSuccess != this.props.updatePostSuccess) {
      if (nextProps.posts.updatePostWasNew) {
        console.tron.log(`PostWallBase componentWillReceiveProps _onRefresh for new post`)
        this._onRefresh()
        this.singleScrollToFirstImage()
      }
      else {
        const updatedPostDetails = {
          posts: [nextProps.posts.updatePost]
        }
        // console.tron.display({name: `componentWillReceiveProps`, display: `calling updateExtendedPostData`, value: updatedPostDetails})
        this.updateExtendedPostData(updatedPostDetails)
      }
    }

    if (this.props.postCreation.lastCreation != nextProps.postCreation.lastCreation) {
      console.tron.log(`componentWillReceiveProps newPost`)
      const isNewPost = true
      const res = {
        'data': [nextProps.postCreation.post],
      }
      this._loadMoreDataProcess(res, isNewPost)
    }

    if (nextProps.updatePost != null && nextProps.updatePost != this.props.updatePost && this.state.viewMode != FULL_SCREEN_MODE) {
      const index = this.state.data.findIndex(e => e.PostId === nextProps.updatePost.PostId)
      this.setState({
        viewMode: LIST_MODE,
      })
      this._onRefresh()
    }
    if (nextProps.deletePost && nextProps.deletePost !== this.props.deletePost) {
      const deletedPostId = nextProps.deletePost
      const newDataState = this.state.data.filter((data, index) => {
        return deletedPostId !== data.PostId
      })

      const mosaicList = this.mosaicDataFromPostList(newDataState)
      const fullScreenList = this.fullScreenDataFromPostList(newDataState)
      //console.log('clone with rows loc 1')
      this.setState({
        data: newDataState,
        dataProvider: this.state.dataProvider.cloneWithRows(newDataState),
        dataProviderMosaic: this.state.dataProviderMosaic.cloneWithRows(mosaicList),
        dataProviderFullScreen: this.state.dataProviderMosaic.cloneWithRows(fullScreenList),
      })
      this._onRefresh()
      // TODO - what about video wall?
		}
		
		// add comments to post record, used by Full Screen feature
		if (typeof nextProps.comments != 'undefined' && nextProps.comments != null && typeof nextProps.comments.comments != 'undefined') {
			const {comments, updated, loading, PostId} = nextProps.comments
			if (PostId != null && !loading && updated != this.props.comments.updated) {
				console.log(`componentWillReceiveProps comments loaded, comments: ` + JSON.stringify(comments))
				let found = false
				let posts = [...this.state.data]
				for (let i = 0; i < posts.length; i++) {
					if (posts[i].PostId == PostId) {
						console.log(`componentWillReceiveProps comments post found, postId: ${PostId}`)
						found = true
						posts[i].RecentComments = [...comments].reverse()
						posts[i].LoadedMoreComments = true // no spinner
						i = posts.length // quick exit
						const mosaicList = this.mosaicDataFromPostList(posts)
						const fullScreenList = this.fullScreenDataFromPostList(posts)
						//console.log('clone with rows loc 1')
						this.setState({
							data: posts,
							dataProvider: this.state.dataProvider.cloneWithRows(posts),
							dataProviderMosaic: this.state.dataProviderMosaic.cloneWithRows(mosaicList),
							dataProviderFullScreen: this.state.dataProviderMosaic.cloneWithRows(fullScreenList),
						})
					}
				}
			}
		}

    // this.requestedPreflightItemId == nextProps.order.itemId
    if (this.lastPreflight != this.props.order.modified && this.props.order.kind == 'preflight' && this.requestedPreflightItemId == nextProps.order.itemId) {
      console.tron.log(`componentWillReceiveProps preflight itemId state: ${nextProps.order.itemId}, requested: ${this.requestedPreflightItemId}`)
      this.lastPreflight = this.props.order.modified
      this.setState({ preflightPostId: nextProps.order.postId, preflightItemId: nextProps.order.itemId })
      return
    }

    if (this.props.postdetails.posts != nextProps.postdetails.posts || this.props.love.changes != nextProps.love.changes)
      this.updateExtendedPostData(nextProps.postdetails, nextProps.love)

    // check for shoppableCheckout or will red screen / crash if shoppableCheckout not defined (noted in crashlytics)
    if (this.props.shoppableCheckout && nextProps.shoppableCheckout) {
      if (this.props.shoppableCheckout.modified != nextProps.shoppableCheckout.modified && nextProps.shoppableCheckout.url !== null)
        this.safariView(nextProps.shoppableCheckout.url)
    }

    // recheck agora tokens if this is a new auth user on this instance of the wall
    if (nextProps.auth && nextProps.auth.user && (this.checkedAgoraTokensForUsername !== nextProps.auth.user.Username)) {
      // note, if this fails e.g. bad internet, we should re-call it later
      // perhaps when tokens are retreived
      makeSureUserHasAgoraToken(nextProps.auth) // from utils.js
      this.checkedAgoraTokensForUsername = nextProps.auth.user.Username
    }
  }

  mosaicDataFromPostList(posts) {
    if (this.ProfileWall) {
      const headerMosaic = {
        startIndex: 0,
        count: 0,
        hash: 'HEADER',
        type: 'HEADER',
        mosaicHeight: this.headerRowHeight,
        layout: [],
      }
      let temp = posts.slice() // clone
      temp.shift() // get rid of HEADER post entry
      return [headerMosaic].concat(postListToMosaicList(temp))
    }
    else
      return postListToMosaicList(posts)
  }

  fullScreenDataFromPostList(posts) {
		// return posts.slice() // clone
		console.tron.display({name: 'fullScreenDataFromPostList', preview: "post", value: {type: typeof posts, count: posts.length}})
		const result = posts.filter(post => post.MediaType === 'MP4' || post.MediaType === '3D' || post.StreamURL)
		console.tron.display({name: 'fullScreenDataFromPostList', preview: "result", value: {type: typeof result, count: result.length, postCount: posts.length, arrayType: typeof []}})
		return result
  }

  _loadMoreDataProcess(res, isNewPost = false) {
    console.log("load more data process")
    console.tron.log(`PostWallBase _loadMoreDataProcess`)
    let doingRefresh = false
    if (typeof res.pagination != 'undefined') {
      console.tron.log(`PostWallBase _loadMoreDataProcess pagination: ` + JSON.stringify(res.pagination))
      if (res.pagination.index == 0)
        doingRefresh = true
    }
    //
    // make sure we are adding unique posts https://jsperf.com/merge-two-arrays-keeping-only-unique-values
    // ******** TODO - avoid extra copies of data, use dataProvider
    // *********** REMOVE most things from State, just leave dataProvider
    const headerRow = {
      PostId: -1,
      NumViews: 0, // so we skip trying to load information about this row
      Header: true,
      ListHeight: this.headerRowHeight,
    }
    const addHeader = this.ProfileWall && this.state.data.length == 0
    const currentPosts = addHeader ? [headerRow] : this.state.data.concat()
    var postIds = currentPosts.map(function (a) {
      return a.PostId
    })
    // ************** DEBUG TEST FOR RecyclerListView - what if all rows were same height? **********
    //console.log("res.data = " + JSON.stringify(res.data, null, 2))
    let debugRes = res.data.concat()
    if (!this.props.options.forceSquare) {
      // need special () => anonymous function style automatically gives us 'this' in scope of function
      res.data.forEach( (v, i) => {
        if (typeof debugRes[i]['AspectRatio'] != 'undefined') {
          const initialAspect = debugRes[i]['AspectRatio']
          //console.log("initialAspect = " + initialAspect)
          let finalAspect = debugRes[i]['AspectRatio']
          //console.log("finalAspect = " + finalAspect)
          const square        = Math.abs(initialAspect - 1)
          const threeQuarters = Math.abs(initialAspect - 0.75)
          const fourThirds    = Math.abs(initialAspect - 1.333)
          const portraitHD    = Math.abs(initialAspect - 0.563) // 9/16
          const landscapeHD   = Math.abs(initialAspect - 1.778) // 16/9
          const wideHD        = Math.abs(initialAspect - 2.167) // 19.5/9 iPhone XS and above
          const narrowHD      = Math.abs(initialAspect - 0.462) // 9/19.5
          const minDeviation  = Math.min(square, threeQuarters, fourThirds, portraitHD, landscapeHD, wideHD, narrowHD)
          if (minDeviation == square)
            finalAspect = 1
          else if (minDeviation == threeQuarters)
            finalAspect = 0.75
          else if (minDeviation == fourThirds)
            finalAspect = 1.333
          else if (minDeviation == portraitHD)
            finalAspect = 0.563
          else if (minDeviation == landscapeHD)
            finalAspect = 1.778
          else if (minDeviation == wideHD)
            finalAspect = 2.167
          else
            finalAspect = 0.462
          if (finalAspect != initialAspect)
            debugRes[i]['AspectRatio'] = finalAspect
          debugRes[i]['ListHeight'] = Math.round(screenWidth / finalAspect) + LIST_EXTRA_GAP
        } // AspectRatio
          
        if (typeof debugRes[i]['complete'] != 'undefined') {
          //console.log(`_loadMoreDataProcess calling mergePost`)
          let completePost = deepClone(debugRes[i]['complete'])
          debugRes[i]['complete'] = ''
          tempResult = this.mergePost(debugRes[i], completePost)
          //console.log("load more data mergePost result: " + JSON.stringify(tempResult))
          debugRes[i] = tempResult
        }
      })
    }
    else {
      res.data.forEach(function (v, i) {
        debugRes[i]['AspectRatio'] = 1
        debugRes[i]['ListHeight'] = screenWidth + LIST_EXTRA_GAP
      })
    }
    let mergedPosts;
    if (isNewPost) {
      if (this.ProfileWall)
        mergedPosts = [headerRow, debugRes[0]].concat(currentPosts.slice(1))
      else
        mergedPosts = debugRes.concat(currentPosts)
    }
    else if (doingRefresh || this.state.hasNewPost == true) {
      this.lastReadPostOptions = null
      if (this.ProfileWall)
        mergedPosts = [headerRow].concat(debugRes)
      else
        mergedPosts = debugRes
    } else {
      mergedPosts = currentPosts.concat(
        debugRes.filter(function (i) {
          return postIds.indexOf(i.PostId) == -1
        }))
    }

    if (mergedPosts)
      console.log("n merged posts = " + mergedPosts.length)

    const mosaicList = this.mosaicDataFromPostList(mergedPosts)
    const fullScreenList = this.fullScreenDataFromPostList(mergedPosts)
    console.tron.display({name: 'mosaicList', preview: "result", value: {mergedPosts: mergedPosts, mosaicList: mosaicList}})

    let start = res.pagination.next ? res.pagination.next : this.state.start
    var target = ''
    if( this.HomeWall ) target = 'homeWallData'
    else if( this.state.userId ) target = `profileWallData-${this.state.userId}` // profile
    else target = 'unknownWallData'
    // SaveToCache ( target, JSON.stringify({ start : start, data : mergedPosts }) )
    //console.log('clone with rows loc 2')
    if (this.state.refreshing)
      this.lastFinishedRefresh = new Date().getTime()

    let dp = this.state.dataProvider.cloneWithRows(mergedPosts)
    let dpm = this.state.dataProviderMosaic.cloneWithRows(mosaicList)
    let dpfs = this.state.dataProviderFullScreen.cloneWithRows(fullScreenList)

    this.setState({
      start: start,
      dataProvider: dp, /*this.state.dataProvider.cloneWithRows(mergedPosts)*/
      dataProviderMosaic: dpm, /*this.state.dataProviderMosaic.cloneWithRows(mosaicList)*/
      dataProviderFullScreen: dpfs, /*this.state.dataProviderFullScreen.cloneWithRows(fullScreenList),*/
      data: mergedPosts, // page === 1 ? res.data : [...this.state.data, ...res.data],
      error: res.data.length === 0 ? true : null,
      refreshing: false,
      calledAPI: Date.now(),
      hasNewPost: false,
      havePosts: mergedPosts.length > 0
    }, () => {
      this.inLoadMoreData = false
      // this.inLoadMoreVidData = false

      if (this.HomeWall) {
        // handle case where you have a new user and the follow job is so slow that you have no posts first time running
        if (this.state.havePosts === true && this.noPostsTimeout) {
          console.tron.log("clearing noPostsTimeout")
          clearTimeout(this.noPostsTimeout)
          this.noPostsTimeout = null
        }
        if (this.state.havePosts === false && !this.noPostsTimeout) { //// ******* MAIN WALL ONLY
          console.tron.log("setting noPostsTimeout")
          this.noPostsTimeout = setTimeout(() => this.setState({refreshing: true, refreshCount: this.state.refreshCount+1}, () => this._loadMoreData()), 30000)
        }
      }

      if (this.state.viewMode == LIST_MODE && this.state.start == 0)
        this.singleScrollToFirstImage(1000)

      // make sure new posts have extended details
      let missingExtended = []
      for (let i = 0; i < Math.min(10, mergedPosts.length); i++)
        if (typeof mergedPosts[i].NumViews == 'undefined')
          missingExtended.push(i)
      if (missingExtended) {
        console.tron.log(`_loadMoreDataProcess missingExtended ` + JSON.stringify(missingExtended))
        this._indexesChanged(missingExtended, [], [])
      }
      // this._playVisibleVideo() // always plays the first video because scroll event is not being passed
    })
  }

/*
  _loadMoreVidData = async ( ) => {
    if (this.inLoadMoreVidData) {
      console.tron.log("PostWallBase _loadMoreVidData already in loading state")
      return
    }
    this.inLoadMoreVidData = true
    let { url, options } = this.loadMoreVidDataUrl ( )
    const res = await fetch(url, options)
      .then(res => res.json ( ))
      .catch(err => {
        this.inLoadMoreVidData = false
      })
    if( this.inLoadMoreVidData ) {
      const currentPosts = this.state.vidData.concat( )
          , postIds = currentPosts.map( v => v.PostId )
          , mergedPosts = currentPosts.concat(
              res.data.filter(function (i) {
                return postIds.indexOf(i.PostId) == -1
              }))
      var debugRes = mergedPosts
      debugRes.forEach(function (v, i) {
        const initialAspect = debugRes[i]['AspectRatio']
        let finalAspect = debugRes[i]['AspectRatio']
        const square = Math.abs(initialAspect - 1)
        const threeQuarters = Math.abs(initialAspect - 0.75)
        const fourThirds = Math.abs(initialAspect - 1.25)
        if (square < threeQuarters && square < fourThirds)
          finalAspect = 1
        else if (threeQuarters < square && threeQuarters < fourThirds)
          finalAspect = 0.75
        else if (fourThirds < square && fourThirds < threeQuarters)
          finalAspect = 1.25
        if (finalAspect != initialAspect)
          debugRes[i]['AspectRatio'] = finalAspect
        debugRes[i]['ListHeight'] = Math.round(screenWidth / finalAspect) + LIST_EXTRA_GAP
      })

      let vidStart = res.pagination.next ? res.pagination.next : this.state.vidStart
        , cache = JSON.stringify({ vidStart : vidStart, vidData : mergedPosts })

      var target = ''
      if( this.HomeWall ) target = 'homeVidData'
      else if( this.state.userId ) target = `profileVidData-${this.state.userId}` // profile
      else target = 'unknownVidData'

      // SaveToCache ( target, cache )
      this.setState({
        vidStart: vidStart,
        vidDataProvider: this.state.vidDataProvider.cloneWithRows(debugRes),
        vidData: mergedPosts,
        error: null,
        refreshing: false,
        calledAPI: Date.now(),
        hasNewPost: false
      }, ( ) => { this.inLoadMoreVidData = false })
    }
  }
*/

  _loadMoreData = async () => {
    console.log(`PostWallBase _loadMoreData begins authUserId ${this.props.auth.user.UserId}, switchToUserId ${this.switchToUserId}`)
    if (this.props.auth.user.UserId == this.switchToUserId) {
      console.log(`_loadMoreData switch clearing switchToUserId`)
      this.switchFromUserId = null
      this.switchToUserId = null
      this.switchPostHints = null
    }

    if (this.noPostsTimeout) {
      clearTimeout(this.noPostsTimeout)
      this.noPostsTimeout = null
    }

    const { page, seed } = this.state
    if (this.inLoadMoreData) {
      console.tron.log("PostWallBase _loadMoreData already in loading state")
      return
    }
    if (this.state.calledAPI && !this.state.start && !this.state.refreshing) {
      console.tron.log("PostWallBase makeRemoteRequest no more data")
      console.log("PostWallBase makeRemoteRequest no more data")
      return
    }
    this.inLoadMoreData = true;
    console.tron.log("PostWallBase makeRemoteRequest page: " + page)

    /*
        // seed is used to force an update and get new stuff, in this example...
        // const url = `https://randomuser.me/api/?seed=${seed}&page=${page}&results=20`;
        const length = 100
        const userId = this.state.userId ? this.state.userId : ""
        const start = this.state.start && !this.state.refreshing ? this.state.start : ""
        const url = `https://de v-a pi.kar goe.com/webapi/v1/post?UserId=${userId}&limit=${length}&start=${start}`
        console.tron.log(url)
    */

    const { url, options } = this.loadMoreDataUrl( )

    // this doesnt go thru api therefore not cached in cache trial, ah

    // console.log("wall get more data url = " + url)

    // if not online, try to get from cache
    // or if first render, try to get from cache for faster initial load

    let responseTextTest = this.getResponseTextFromCache(url)

    if ((!this.kargoeIsConnected || PostWallBase.firstRender) && responseTextTest) {

      //console.log('kargoe is not connected in wall, try to get from cache')

      //console.log('get from cache fn = ' + this.getResponseTextFromCache)

      let responseText = this.getResponseTextFromCache(url) // silent fail puke

      //console.log('got responseText from cache len = ' + responseText.length)

      try {
        const response = JSON.parse(responseText)
        this._loadMoreDataProcess (response)
        // this._loadMoreVidData ( )
        this.setState({ networkOffline : false })
      } catch ( e ) {
        console.log(`probable JSON parse error processing cached data: ${e}`)
        this.inLoadMoreData = false
      }

      return
    }
    //else console.log("apparently, wall is connected to server")

    if (!this.xhrRequests) this.xhrRequests = []

    var req = new XMLHttpRequest ( )

    this.xhrRequests.push(req) // in case we need to cancel it

    let t1xhr = Date.now()

    req.open('GET', url)
    req.timeout = 10000
    req.ontimeout = ( ) => {
      console.log('request timed out')
      // TODO: refine network offline state condition, somehow occurs during launch
      // this.setState({ networkOffline : true })
      this.inLoadMoreData = false
      // remove from array of requests
      this.xhrRequests = this.xhrRequests.filter(item => item !== req)
    }
    req.onerror = ( ) => {
      console.log('post wall base xhr error')
      // see if we have it in cache
      let responseText = this.getResponseTextFromCache(url)
      if (responseText) { // hey we got something, process it, just like below but dont recache it

        try {
          const response = JSON.parse(req.responseText)
          this._loadMoreDataProcess (response)
          // this._loadMoreVidData ( )
          this.setState({ networkOffline : false })
        } catch ( e ) {
          console.log(`probable JSON parse error processing cached data: ${e}`)
          this.inLoadMoreData = false
        }
      }
      else // nothing in cache,
      this.inLoadMoreData = false

      // remove from array of requests
      this.xhrRequests = this.xhrRequests.filter(item => item !== req)
    }
    req.onreadystatechange = ( event ) => {
      if( req.readyState === 4 && req.status === 200 ) {
        try {
          //console.log('got xhr total time = ' + (Date.now() - t1xhr))
          this.storeResponseTextToCache(url, req.responseText)
          const response = JSON.parse(req.responseText)
          this._loadMoreDataProcess (response)
          // this._loadMoreVidData ( )
          this.setState({ networkOffline : false })
          if (!this.state.videoPlaybackAllowed)
            this.setState({ videoPlaybackAllowed: true })
        } catch ( e ) {
          console.log(`probable JSON parse error: ${e}`)
          this.inLoadMoreData = false
        }
        // remove from array of requests
        this.xhrRequests = this.xhrRequests.filter(item => item !== req)
      }
    }
    req.setRequestHeader('Authorization', options.headers.Authorization)
    //console.log('ready to send xhr at ' + t1xhr)
    req.send( )
  }

  askForRefresh = () => {
    this.fullScreenIsFollowing = {}
    this.setState({ refreshing: true, refreshCount: this.state.refreshCount+1 })
  }

  _onRefresh = ( force ) => {
		if (force || (new Date().getTime() > this.lastFinishedRefresh + 5000) ) { // every 5 seconds max
      this.askForRefresh()
			// this.fullScreenIsFollowing = {}
			// this.setState({ refreshing: true, refreshCount: this.state.refreshCount+1 })
		}
    else {
      console.tron.log(`_onRefresh called too soon`)
      console.log(`_onRefresh called too soon`)
    }
  }

  singleScrollToFirstImage(delay = 1000) {
    console.tron.log(`singleScrollToFirstImage delay ${delay}`)
    setTimeout(() => {
      if (this.listScrollView)
        if (this.HomeWall) {
          if (this.props.transparentPanels)
            this.listScrollView.scrollToOffset(0, LIST_TOP_GAP + LIST_HEADER_HEIGHT + 1, true)
          else
            this.listScrollView.scrollToOffset(0, 0, true)
        }
        else
          this.scrollTo(0)
      console.tron.log(`singleScrollToFirstImage delayed`)
    }, delay)
  }

  renderHeader(makeTransparentHeader, progress) {
    return null
  }

  postLink() {
    return null
  }


  changeMode = (newViewMode, indexScroll = null) => {
    const currentVisibleIndexes = this.currentVisibleIndexes.length > 0 ? this.currentVisibleIndexes : []
    const offsetGrid = this.gridScrollView ? this.gridScrollView.getCurrentScrollOffset() : 0
    // const indexScroll = this.state.viewMode == GRID_MODE ? Math.round(offsetGrid / (screenWidth / 3)) * 3 : this.currentVisibleIndexes.length > 1 ? this.currentVisibleIndexes[1] : this.currentVisibleIndexes[0]
    // const indexScroll = this.state.viewMode == GRID_MODE ? Math.round(offsetGrid / (screenWidth / 3)) * 3 : this.currentVisibleIndexes.length > 0 ? this.currentVisibleIndexes[0] : 0
    console.tron.log(`changeMode: ${newViewMode} offsetGrid ${offsetGrid}, indexScroll ${indexScroll}, currentVisibleIndexes: ` + JSON.stringify(currentVisibleIndexes))
    if (newViewMode == FULL_SCREEN_MODE) {
      this.fsMusicPostIndex = -1
			this.fullScreenIsFollowing = {}
			this.fullScreenVideoRef = []    
      this.fullScreenLandscapeProgress = null
      this.fullScreenPortraitProgress = null
      //Orientation.unlockAllOrientations()

			const postIndex = this.fullScreenStartIndex
			this.setState({fullScreenAutoAdvance: true, fullScreenPaused: false, currFullScreenVideoPlayIndex: postIndex, fsCapComScrollHeights: []})
			const postData  = this.state.dataProviderFullScreen.getAllData()
			if (postIndex != null && postIndex < postData.length) {
				const newPlayPost = postData[postIndex]
				if (newPlayPost)
					this.setSong(newPlayPost.Song, `changeMode`)
			}			
    }
    else {
      this.clearSong()
      //Orientation.lockToPortrait()
    }

    this.props.setCameraLockout(newViewMode == FULL_SCREEN_MODE)

    // this.setState({ viewMode: newViewMode, indexScroll: 0 })
    if (newViewMode == LIST_MODE && indexScroll != null && indexScroll < 2)
      this.singleScrollToFirstImage(1000)
    this.setModeAndScrollIndex(newViewMode, indexScroll)
    // this.emitter.emit('SCROLLTO_EVENT', { newPosition: 0 }, false)

    if (newViewMode != LIST_MODE && newViewMode != FULL_SCREEN_MODE)
      window.mostVisiblePost = null // clear this when we switch modes (controls what is shown in right view)

  }

  clickMode = (indexScroll = null) => {
    console.tron.log(`clickMode`)
    let newViewMode = GRID_MODE
    switch (this.state.viewMode) {
      case LIST_MODE: newViewMode = GRID_MODE; break;
      case GRID_MODE: newViewMode = MOSAIC_MODE; break;
      // case MOSAIC_MODE: newViewMode = LIST_MODE; break;
			case MOSAIC_MODE: 
				if (this.HomeWall) {
					this.fullScreenStartIndex = 0
					newViewMode = LIST_MODE; // skip full screen for now for web FULL_SCREEN_MODE;
				}
				else
					newViewMode = LIST_MODE;
				break;
      case FULL_SCREEN_MODE: newViewMode = LIST_MODE; break;
    }
    this.changeMode(newViewMode, indexScroll)

    this.props.setForceRefreshIndex(Math.random()) 

  }

/*
  showVideoWall ( ) {
    return // not anymore
    if( this.DiscoverWall ) return // just don't
    var post = this.state.dataProvider._data [this.currentVisibleIndexes[0]]
      , posts = this.state.vidDataProvider._data
      , index = 0
    for( var i = 0 ; i < posts.length ; ++ i ) {
      if( posts[i].PostId === post.PostId )
        index = i
    }
    this.setState({ prevMode : this.state.viewMode, viewMode : VID_MODE, vidIndexScroll : index })
  }
*/

  exitFullScreenMode = (postId) => {
		console.log("exitFullScreenMode postId " + postId)
		this.fullScreenClearDetailFadeTimer()
		// find current full screen video post in list of all posts
    let indexScroll = 0
    const data = this.state.dataProvider._data // array of video posts, not all posts
    for (let i = 0; i < data.length; i++)
      if (data[i].PostId == postId)
      indexScroll = i

    this.clickMode(indexScroll)
  }

  showVideoWallNew(postId) {
    console.log("showVideoWallNew postId " + postId)
		this.fullScreenResetDetailFadeTimer()
		this.fullScreenStartIndex = 0
    const data = this.state.dataProviderFullScreen._data // array of video posts, not all posts
    for (let i = 0; i < data.length; i++)
      if (data[i].PostId == postId)
				this.fullScreenStartIndex = i
    this.changeMode(FULL_SCREEN_MODE) // future - go to the specific post
    // this.orientationDidChange.call(this, null, true)
  }

  onDonatePress = data => {
    // this.onDonatePress({ price, charityName: tag.CharityName, itemId, postId: post.PostId })}
    console.tron.display({ name: `onDonatePress`, preview: `params`, value: { data } })
    if(this.props.currentUser && this.props.currentUser.user) {
      const { currentUser: { user: { PurchaseSecured } } } = this.props
      if(PurchaseSecured) {
        console.log('purchase secured')
        TouchID.authenticate('Scan your fingerprint please')
        .then(success => { this.props.showPayPal({ isShow: true, data: Object.assign({}, data, {clickTime: Date.now()}) }) })
        .catch(error => { console.log(error) })
      } else {
        console.log('purchase not secured')
      this.props.showPayPal({ isShow: true, data: Object.assign({}, data, {clickTime: Date.now()}) })
      }
    }
  }

  gotoShoppableVariant(post, tag, item, id) {
    const params = { post, tag, item, id }
    console.tron.display({ name: `gotoShoppableVariant`, preview: `params`, value: { params: params } })
    this.props.navigation.navigate('shoppableVariant', params)
  }

  gotoOrderConfirmation(PostId, TagId, tagKind, tag, item) {
    const itemData = Object.assign({}, item, { isISell: tagKind == 'ISell' })
    // see ScreenSettings.js line 147
    const params = {
      data: item,
      api: { PostId, TagId },
      tag: tagKind == 'ISell' ? tag : false
    }
    console.tron.display({ name: `gotoOrderConfirmation`, preview: `params`, value: { params: params } })
    console.log("PostWallBase gotoOrderConfirmation params", JSON.stringify(params))
    this.props.navigation.navigate('orderConfirm', params)
  }

  onShopitPress(shortCut = false) {
    // use this.pressedTagDetails
    console.tron.log(`onShopitPress, should call OrderConfirmation...`)
    const isShoppable = this.props.order.meta && this.props.order.meta.shoppable
    if (isShoppable) {
      if (!this.props.options.useShoppableShopIt) {
        console.tron.log(`shoppable is disabled...`)
        return
      }
      this.gotoShoppableVariant(this.pressedTagDetails.post, this.pressedTagDetails.tag, this.props.order.item)
      if (shortCut)
        this.pressedTagDetails = null
      return
    }
    if (this.pressedTagDetails.kind == 'Donate') {
      console.tron.log(`donate is supported elsewhere...`)
      return
    }
    if (this.pressedTagDetails.kind != 'ISell' && this.pressedTagDetails.kind != 'TheySell') {
      console.tron.log(`kind is not iSell or TheySell`)
      return
    }
    if (this.pressedTagDetails.kind == 'ISell' && this.pressedTagDetails.tag.Sold) {
      console.tron.log(`iSell has been sold`)
      return
    }
    console.tron.display({
      name: `onShopitPress`,
      preview: `order state`,
      value: {
        requestedPreflightItemId: this.requestedPreflightItemId,
        order: this.props.order,
      }
    })
    // if (this.pressedTagDetails.kind == 'TheySell' && (!this.props.order || !this.props.order.item || this.props.order.itemId != this.requestedPreflightItemId)) {
    if (!this.props.order || !this.props.order.item || this.props.order.itemId != this.requestedPreflightItemId) {
      console.tron.log(`preflight has not yet returned`)
      return
    }

    const itemData = Object.assign({}, this.props.order.item, {
      isISell: this.pressedTagDetails.kind == 'ISell',
    })
    this.gotoOrderConfirmation(
      this.pressedTagDetails.post.PostId,
      this.pressedTagDetails.id,
      this.pressedTagDetails.kind,
      this.pressedTagDetails.tag,
      itemData)
    if (shortCut)
      this.pressedTagDetails = null
    return true
  }

  onTagPress(data, kind, tag, id) {
    const extended = this.findExtendedTagDetails(data.PostId, kind, tag, id)

    console.log('extended tag = ' + JSON.stringify(extended, null, 2))

    console.log('tag kind = ' + kind)

    let username = 'unknown'

    if (this.props.auth && this.props.auth.user) username = this.props.auth.user.Username
    // send firebase analytics event to test 

    if (kind == 'TheySell') 
    analytics().logEvent('onTheySellPress', {
      TapUsername : username,
      PostId : data.PostId,
    
      Url: extended.url,
      Price: extended.price,
      
      ItemId: extended.complete.ItemId,
      Brand: extended.complete.Brand,
      ExtStoreItemId: extended.complete.ExtStoreItemId,
      Charity: extended.complete.Charity,
      StoreId: extended.complete.StoreId,
      Title: extended.complete.Title,
      TagUserId: extended.complete.UserId,

      // amazon & the like external links
      External: extended.complete.External,
      ProductId: extended.complete.ProductId,
      ProductUrl: extended.complete.ProductUrl
    })

    console.tron.display({ name: `onTagPress`, preview: ``, value: { data: data, kind: kind, tag: tag, id: id, extended: extended } })
    this.scrollToPost(data)

    if (kind == 'FundMeSummary') {
      if (this.fundMeHidden)
        Animated.timing(this.fundMeSummaryRight, { toValue : 0, duration : 250, useNativeDriver: true }).start( )
      else
        Animated.timing(this.fundMeSummaryRight, { toValue : this.fundMeWidth - 15, duration : 250, useNativeDriver: true }).start( )
      this.fundMeHidden = !this.fundMeHidden
      return
    }

    if (this.pressedTagDetails && this.pressedTagDetails.id == id) {
      console.tron.log(`onTagPress clicked same one again`)
      this.pressedTagDetails = null
      this.setState({ forceUpdate: this.state.forceUpdate + 1 })
      return
    }

    if (SKIP_SHOP_IT_OVERLAY && (kind == 'Donate')) {
      const { name, url, price, rawPrice, userName = '' } = extended
      console.tron.log(`onTagPress donate skip overlay price ${price}`)
      const details = Object.assign({}, { fundMe: typeof tag.FundMe != 'undefined', price, rawPrice, userName, charityName: tag.CharityName, charityId: tag.CharityId, itemId: id, postId: data.PostId })
      console.tron.display({ name: `onTagPress`, preview: `donate`, value: { details } })
      this.onDonatePress(details)
      return
    }

    if (SKIP_SHOP_IT_OVERLAY && (kind == 'ISell' || kind == 'TheySell')) { // SKIP_SHOP_IT_OVERLAY
      // bypass Shop It, quickie purchase
      const isISell = kind == 'ISell'
      console.tron.log(`onTagPress iSell or TheySell skip overlay`)
      let item = isISell ? extended : extended.complete
/*
      if (isISell)
        item = { // TODO - place in API for extended detail.
          Title: tag.Name,
          Brand: "",
          Options: "",
          OptionNames: [
            "Default"
          ],
          OptionValues: [
            "Default Title"
          ],
          StoreName: "ziggystardust", // PROBLEM
          Availability: tag.Sold ? 0 : 1,
          State: 1,
          PriceMin: tag.PriceMin,
          PriceMax: tag.PriceMax,
          isISell: true,
          tagKind: "ISell"
        }

        if (!item)
          item = {
            ItemId: id,
            Active: true,
            PriceMin: 0,
            PriceMax: 0,
          }
*/
      const isShoppable = isShoppableItemId(id)
      const isExternal = item.External
      if (true) { // (isISell && extended.Availability != 0) || (!isISell && item && (!isShoppable || item.Active) && item.Availability == 1)) {
        if (isExternal)
          this.safariView(item.ProductUrl)
        else if (isShoppable)
          this.gotoShoppableVariant(data, tag, item, id)
        else
          this.gotoOrderConfirmation(data.PostId, id, kind, tag, item) // item
        return
      }
    }

    console.tron.log(`onTagPress PostId: ${data.PostId}, Kind: ${kind}, Id: ${id}, tag: ` + JSON.stringify(tag))
    this.pressedTagDetails = {
      post: data,
      kind: kind,
      tag: tag,
      id: id,
      extended,
    }
    if ((kind == 'TheySell' || kind == 'ISell')) { //  && id != this.state.preflightItemId) {
      this.requestedPreflightItemId = id
      console.tron.log(`calling orderPreflight`)
      this.props.orderPreflight(data.PostId, id)
    }
    else
      this.setState({ forceUpdate: this.state.forceUpdate + 1 })
    // when preflight is done, normally show shoppit dialog, but in this case we will navigate to OrderConfirmation
	}
	
	onFullScreenShowTags = (data, index) => {
    console.tron.log(`onFullScreenShowTags Index: ${index}, PostId: ${data.PostId}, Modified: ${data.Modified}, mod: ${this.props.order.modified}, showKargoeTagsPostId: ${this.state.showKargoeTagsPostId}, hideKargoeDotsPostId: ${this.state.hideKargoeDotsPostId}`)
		this.setState ( { hideKargoeDotsPostId: null }
			, ( ) => {
					Animated.timing(this.state.tagPop, {toValue:1,duration:500,useNativeDriver:true}).start( )
					Animated.timing(this.fundMeSummaryRight, { toValue : 0, duration : 1, useNativeDriver: true }).start( )
					this.fundMeWidth = 0
					this.fundMeHidden = false
				}
		)
	}

	onFullScreenHideTags = (data) => {
		this.setState(  { showKargoeTagsPostId: null, hideKargoeDotsPostId: data.PostId, preflightPostId: -1 }
			, ( ) => Animated.timing(this.state.tagPop, { toValue : 0, duration : 2 }).start( )
			) // off
	}

  onKargoePress(data, index) {
    console.tron.log(`onKargoePress Index: ${index}, PostId: ${data.PostId}, Modified: ${data.Modified}, mod: ${this.props.order.modified}, showKargoeTagsPostId: ${this.state.showKargoeTagsPostId}, hideKargoeDotsPostId: ${this.state.hideKargoeDotsPostId}`)
    if (this.pressedTagDetails) {
      this.pressedTagDetails = null
      this.setState({ forceUpdate: this.state.forceUpdate + 1, hideKargoeDotsPostId: null })
      return
    }
    this.pressedTagDetails = null
    if (this.state.showKargoeTagsPostId == data.PostId)
      this.setState(  { showKargoeTagsPostId: null, hideKargoeDotsPostId: data.PostId, preflightPostId: -1 }
        , ( ) => Animated.timing(this.state.tagPop, { toValue : 0, duration : 2 }).start( )
        ) // off
    else if (this.state.hideKargoeDotsPostId == data.PostId) {
      this.setState ( { hideKargoeDotsPostId: null }
        , ( ) => {
            Animated.timing(this.state.tagPop, {toValue:1,duration:500,useNativeDriver:true}).start( )
            Animated.timing(this.fundMeSummaryRight, { toValue : 0, duration : 1, useNativeDriver: true }).start( )
            this.fundMeWidth = 0
            this.fundMeHidden = false
          }
      )
    }
    else {
      // removed code
      this.setState (   { showKargoeTagsPostId: data.PostId }
        , ( ) => Animated.timing(this.state.tagPop, {toValue:1,duration:500,useNativeDriver:true}).start( )
      )
      if (this.props.order.postId != data.PostId || this.props.order.modified < data.Modified)
        this.props.tagDetails(data.PostId)
    }
  }

  onStreamRemoteLoveActivate = () => {
    const post = this.state.streamFullScreenPost
    console.log(`onStreamRemoteLoveActivate ${post.PostId}`)

    this.lastPostLove = {
      Kind: 'stream',
      Modified: Date.now(),
      UserId: null,
      PostId: post.PostId,
      Loves: true,
    }

    if (this.loveAnimation && this.loveAnimation.playing) {
      console.log(`love animation is already playing`)
      return
    }

    console.tron.log(`onStreamRemoteLoveActivate, enabling animatedLove`)
    this.setState({animatedLove: true, animatedOriginX: screenWidth - 200, animatedOriginY: screenHeight - 100})

    console.log("animatedLove ***love anim play")
    const f = function() {
      if (this.loveAnimation && !this.loveAnimation.playing) {
        console.log("animatedLove should see hearts anim playing")
        this.loveAnimation.play() // try for web
        this.loveAnimation.playing = true
      }
      else console.log("animatedLove trying to play love anim, but it is not defined yet")
    }
    setTimeout(f.bind(this), 250) // fire sometime after the render
  }

  onStreamLoveActivate = () => {
    const post = this.state.streamFullScreenPost
    if (this.streamLastPostIdLoved == post.PostId)
      return // already loved
    this.streamLastPostIdLoved = post.PostId
    this.onStreamRemoteLoveActivate()
    this.lastPostLove.UserId = this.authUserId
  }

  onLovePress(e, data, index, kind) {
    if( e ) {
      console.tron.log(`onLovePress ${data.PostId}, ${index}, e.nativeEvent.pageX,Y: ${e.nativeEvent.pageX}, ${e.nativeEvent.pageY}`)
      log("on love press")
    }
    if (typeof data.UserLovesPost != 'undefined') {
      if (data.UserLovesPost) {
        this.instantPostLove = {
          Modified: Date.now(),
          PostId: data.PostId,
          Loves: false,
        }
        this.props.unlovePost(data.PostId)
        this.props.quickLove(data.PostId, 'Unlove')
      }
      else {
        this.lastPostLove = {
          Kind: kind, // wall, fsvideo, stream
          Modified: Date.now(),
          PostId: data.PostId,
          Loves: true,
        }
        this.props.lovePost(data.PostId)
        this.props.quickLove(data.PostId, 'Love')

        console.tron.log(`onLovePress, enabling animatedLove`)
        if (e && e.nativeEvent && e.nativeEvent.pageX && e.nativeEvent.pageY)
          this.setState({animatedLove: true, animatedOriginX: e.nativeEvent.pageX, animatedOriginY: e.nativeEvent.pageY})
        else // put it someplace if we dont know where
          this.setState({animatedLove: true, animatedOriginX: 150, animatedOriginY: 400})

        console.log("animatedLove ***love anim play")
        const f = function() {
          if (this.loveAnimation && !this.loveAnimation.playing) {
            console.log("animatedLove should see hearts anim playing")
            this.loveAnimation.play() // try for web
            this.loveAnimation.playing = true
          }
          else console.log("animatedLove trying to play love anim, but it is not defined yet")
        }
        setTimeout(f.bind(this), 250) // fire sometime after the render

        /** do when animation ends w/ new lottie update
        if (this.loveTimeout) { clearTimeout(this.loveTimeout) }
        this.loveTimeout = setTimeout(() => {
          this.setState({animatedLove: false})
        }, 3000)
        **/
      }
    } else log("*** caution data.UserLovesPost is undefined cannot love this post")

  }

  // https://codeburst.io/6-simple-ways-to-speed-up-your-react-native-app-d5b775ab3f16
  onImagePress(data, index) {
    console.log(`onImagePress...`)
    switch (this.state.viewMode) {
      // case VID_MODE: this.onPressVid(data, index); break;
      case FULL_SCREEN_MODE: this.onPressFullScreen(data, index); break;
      case MOSAIC_MODE: this.onPressMosaic(data, index); break;
      case LIST_MODE: this.onPressList(data, index); break;
      default: this.onPressGrid(data, index); break;
    }
  }

  onGoLivePress() {
    //console.log("on go live press, auth = " + JSON.stringify(this.props.auth));

    let username = null
    let userId = null
    if (this.props.auth && this.props.auth.user) username = this.props.auth.user.Username
    if (this.props.auth && this.props.auth.user) userId = this.props.auth.user.UserId

    this.props.navigation.navigate('liveBroadcast', { authUsername : username, authUserId : userId })
  }

  onPressFullScreen = (data, index) => {
    this.onKargoePress(data, index)
  }

  onPressVid = (data, index) => {
    // TODO - find postId in main list this.state.data
    const postId = data.PostId
    const posts = this.state.dataProvider._data
    for (let i = 0; i < posts.length; i++)
      if (posts[i]['PostId'] == postId) {
        this.setModeAndScrollIndex(LIST_MODE, i)
        return
      }
    this.setModeAndScrollIndex(LIST_MODE, 0)
  }

  onPressGrid = (data, index) => {

    this.setModeAndScrollIndex(LIST_MODE, index)
    // this.emitter.emit('SCROLLTO_EVENT', { newPosition: index }, false)
  }

  onPressMosaic = (data, index) => {

    this.setModeAndScrollIndex(LIST_MODE, this.ProfileWall ? index + 1 : index)
    // this.emitter.emit('SCROLLTO_EVENT', { newPosition: index }, false)
  }

  onPressList = (data, index) => {

    // const { PostId, UserId } = data
    // this.goToPost(PostId, UserId)
    this.onKargoePress(data, index)
  }

  setModeAndScrollIndex(newMode, index) {
    console.tron.log(`setModeAndScrollIndex newMode: ${newMode}, index: ${index}`)
    const all = [index]
    const now = [index]
    const notNow = []
    if (this.state.viewMode != newMode) {
      this.pressedTagDetails = null
      // later. there may be a better way to do this
      setTimeout(function() {
        this.setState({currVideoPlayIndex : index}) // so that when we tap on a video in grid or mosaic, it will play on large wall
      }.bind(this), 1500)
    }
    this.setState ( { viewMode: newMode, indexScroll: index, showKargoeTagsPostId: null, hideKargoeDotsPostId: null }
      , ( ) => Animated.timing(this.state.tagPop, {toValue:0,duration:2,useNativeDriver:true}).start( )
      )

  }

  onCaptionPress = (comments, index) => {


    const currentPostCaption = {
      comments: comments,

    }
    this.setState({
      showPostCaptionIndex: index,
      currentPostCaption: currentPostCaption
    })
  }

  onCloseCaption = () => {
    // console.tron.log(`onCloseCaption`)
    this.setState({ showPostCaptionIndex: null })
  }

  showCommentDialog = (data) => {
    console.tron.display({
      name: `showCommentDialog`,
      preview: ``,
      value: {
        navigation: this.props.navigation,
        key: data.PostId
      }
    })
    if (this.props.navigation && data.PostId) {
      this.showPostView(post,'Comments')
    }
  }

  showActionSheet = (data) => {
    var optionEditPost = [
      I18n.t('editpost.title'), I18n.t('editpost.copyLink'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'), I18n.t('editpost.delete')
    ]

    // havent coded some of these for web yet
    if (Platform.OS == 'web')
      optionEditPost = [
        I18n.t('editpost.title'), /*I18n.t('editpost.copyLink'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'),*/ I18n.t('editpost.delete')
      ]

    var optionRepost = [
      I18n.t('editpost.copyLink'), I18n.t('editpost.repost'), I18n.t('editpost.messageKargoe'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'), I18n.t('editpost.report')
    ]

    if (Platform.OS == 'web')
    optionRepost = [
      /*I18n.t('editpost.copyLink'),*/ I18n.t('editpost.repost'), /*I18n.t('editpost.messageKargoe'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'),*/ I18n.t('editpost.report')
    ]

    this.setState({
      dataPost: data,
      actionOptions: data.UserId === this.state.authUserId ? optionEditPost : optionRepost
    }, () => {
      this.actionSheet.showActionSheet()
    })

  }

  iosShare = async (post) => {
    // const post = this.state.dataPost
    console.log(`iosShare begins`)
    // const url = `https://admin.kargoe.com/post_link.php?PostId=${post.PostId}&UserId=${post.UserId}`
    const url = `https://social.kargoe.com/share.php?${post.PostId}`
    const message = url
    const emailSubject = `Kargoe: ` + post.Caption
    try {
      const result = await Share.share({
        message,
        url // won't work in simulator
      },
      {
        subject: emailSubject
      });

      if (result.action === Share.sharedAction) {
        if (result.activityType) {
          // shared with activity type of result.activityType
        } else {
          // shared
        }
      } else if (result.action === Share.dismissedAction) {
        // dismissed
      }
    } catch (error) {
      alert(error.message);
    }
  }

  actionSheetPress = (index, type) => {
    let nav = this.props.navigation.navigate
      , post = this.state.dataPost

    let optionReport = {
      0: I18n.t('editpost.sexualContent'),
      100: I18n.t('editpost.violence'),
      200: I18n.t('editpost.hateful'),
      300: I18n.t('editpost.illegalProduct'),
      400: I18n.t('editpost.myRight'),
      500: I18n.t('editpost.dangerous'),
      600: I18n.t('editpost.other')
    }
    let optionType = optionTypeDynamic( ) // recompute for lang setting
    console.log("PostWallBase actionSheetPress type = " + type + " " + optionType.EDIT)
    switch ( type ) {
			case optionType.COPY_LINK:
				console.log(`PostWallBase actionSheetPress COPY_LINK start`)
				// krgovndev://post?PostId=5wUWDbKwthO9B7&UserId=s8h2uG09N2CyA7 // &TimeStamp=${post.TimeStamp}
				const url = `${KargoeConfig.appDetails.urlScheme}://post?PostId=${post.PostId}&UserId=${post.UserId}`
				console.log(`PostWallBase actionSheetPress COPY_LINK url ${url}`)
				Clipboard.setString(url)
				console.log(`PostWallBase actionSheetPress COPY_LINK alertView`)
				setTimeout(() => alertView('', I18n.t('editpost.linkCopied')), 500)
				break
      case optionType.REPOST:
        console.tron.display({name: 'PostWallBase', preview: "actionSheetPress Post", value: {post: post}})
        if (typeof post.Censor != 'undefined' && post.Censor != 'none') {
          setTimeout(() => alert("You cannot Repost a censored Post."), 500)
          break
        }
        // fall through
      case optionType.EDIT:
        console.log("going to edit post")
        nav ('editPost', { data : post, postType : type })
        break
      case optionType.DELETE:
        this.props.deletePostAction({ postId : post.PostId })
        break
      case optionType.FACEBOOK:
        //this.shareLinkWithShareFacebook(post) // old way share the link only
        this.shareMediaWithShareFacebook(post, markImageWithWatermark)  // new way share the photo/video
        break
      case optionType.TWITTER:
        this.shareWithTwitter(post, markImageWithWatermark)
        break
      case optionType.TUMBLR:
        this.shareWithTumblr(post, markImageWithWatermark)
        break
      case optionType.INSTAGRAM:
        this.setState({ auxLoading: true })
        this.shareWithInstagram(post, markImageWithWatermark)
        // shut off automatically because we dont know when instagram will be done
        setTimeout(() => this.setState({ auxLoading: false }), 5000)
        break
      case optionType.SHARE:
        this.setState({ actionOptions : optionShare })
        break
      case optionType.REPORT:
        this.setState({ actionOptions : Object.values(optionReport) })
        break
      case optionType.MESSAGE_KARGOER:
        nav ('chat', { PhoneUser : this.props.currentUser, OtherUserId: post.UserId, OtherUserName: post.Username, isScroll: true })
        break
      case optionType.SEND_DIRECT:
        nav ('sendDirect', { post : post })
        break

      case "Sexual content or nudity":
      case "Violence or profanity":
      case "Hateful":
      case "Illegal product or service":
      case "Infringes on my rights":
      case "Dangerous acts":
      case "Other":
        this.showPopUp(type)
        break

      default : break
    }
  }
  shareWithTumblr = (data, imageMarkerFn) => {
    console.log("share with tumblr data = " + data)
    if( data === 'badge' && this.badgeGenerator ) {
      this.badgeGenerator.delegateFunction = image => {
        console.log('got image data to share to tumblr')
        console.log('image b64 len = ' + image.length) // large, b64
        // create a path you want to write to (tmp dir path already has / at end)
        let d = new Date()
        let n = d.getTime()

        let path = RNFS.TemporaryDirectoryPath + 'tumblrBadge' + n + '.jpg'
        // write the file
        let trimmed = image.replace('data:image/jpeg;base64,','')
        if (false)
        RNFS.writeFile(path, trimmed, 'base64')
          .then((success) => {
            console.log('TMP FILE WRITTEN path = ' + path)
            // if a file url we must set a path not a file url, what...
            //http://blog.tijo.me/post/140102837552/tumblr-sharing-with-the-flurry-sdk
            // obsolete:  TumblrShare.postImage(path)
          })
          .catch((err) => {
            console.log('error writing tmp file for tumblr share ' + err.message)
          })
      }
      this.badgeGenerator.generateBadge( )
    } else {
    setTimeout(function () {
      let url = getUriNothumb(data.PostId, '')

      console.log("ready to call imageMarkerFn for 3dot tumblr, input url = " + url)
      // tumblr requires a path not a file url see above doc link
      // obsolete if (imageMarkerFn) imageMarkerFn(url, TumblrShare.postImage, true /*pathNotUrl*/) // watermarking happens async so have to do theShare later
      // obsolete else TumblrShare.postImage(url) // if no need for watermark just do it now

    }, 1000);
  }
  }
  shareWithTwitter = (data, imageMarkerFn) => {
    if( data === 'badge' && this.badgeGenerator ) {
      this.badgeGenerator.delegateFunction = image => {
        console.log('got image data to share to twitter')
        console.log('image b64 len = ' + image.length) // large, b64
        // create a path you want to write to (tmp dir path already has / at end)
        let d = new Date()
        let n = d.getTime()
        
        let path = RNFS.TemporaryDirectoryPath + 'twitterBadge' + n + '.jpg'
        // write the file
        let trimmed = image.replace('data:image/jpeg;base64,','')
        //console.log("image = " + image)
        //console.log("trimmed = " + trimmed)
        if (false)
        RNFS.writeFile(path, trimmed, 'base64')
          .then((success) => {
            console.log('TMP FILE WRITTEN path for twitter = ' + path)
            // dont mark badge image w/ watermark
            imageMarkerFn = null
            shareit('file://' + path)
            console.log("after shareit() for twitter badge")
          })
          .catch((err) => {
            console.log('error writing tmp file for twitter share ' + err.message)
          })
      }
      this.badgeGenerator.generateBadge( )
    }
    else shareit(getUriNothumb(data.PostId, '')) // 3dot

    function shareit(url) {

      console.log("ready to call imageMarkerFn for 3dot twitter " + imageMarkerFn)
      if (imageMarkerFn) imageMarkerFn(url, theShare) // watermarking happens async so have to do theShare later
      else theShare(url) // if no need for watermark just do it now

        function theShare(url) {
      //let url = getUriNothumb(data.PostId, '')
      var shareOptions = {
        title: "hello from Kargoe",
        url: url,
      };
          console.log('ready to call twitter share dot tweet')
      TwitterShare.tweet(shareOptions).then(result => {
        console.log("tweet success result = " + JSON.stringify(result))
            var msg = 'Tweet success 3dot'
        if (typeof result === 'array' && result.length > 0) msg = result[0]
        else if (typeof result === 'string') msg = result

        if (msg.match("cancelled")) msg = I18n.t('editposttwitterInstalled2') // "To share from Kargoe, make sure the Twitter app is installed and you are logged in to it."

        alertView(msg, "")
      }).catch(error => { // this is not working if, say, twitter app is not installed
        // not sure if error is an object, array, or string yet...
        console.log("twitter error in post wall base = " + JSON.stringify(error))
        alertView(error, "Make sure you have the Twitter app installed and are logged in to it.")
      })
      } // theshare

    } // shareit
  } // shareWithTwitter

  shareWithInstagram = (data, imageMarkerFn) => {
    //console.log("instagram data = " + JSON.stringify(data))
    if( data === 'badge' && this.badgeGenerator ) {
      this.badgeGenerator.delegateFunction = image => {
        console.log('got image data to share to instagram')
        console.log('image b64 len = ' + image.length) // large, b64
        // create a path you want to write to (tmp dir path already has / at end)
        let d = new Date()
        let n = d.getTime()
      
        let path = RNFS.TemporaryDirectoryPath + 'instaBadge' + n + '.jpg'
        // write the file
        let trimmed = image.replace('data:image/jpeg;base64,','') // no web prefix
        if (false)
        RNFS.writeFile(path, trimmed, 'base64') // this turns b64 string into raw bytes in the file
          .then((success) => {
            console.log('TMP FILE WRITTEN path for instagram = ' + path)
            ishareit('file://' + path)
            console.log("after ishareit() for instagram badge")
          })
          .catch((err) => {
            console.log('error writing tmp file for instagram share ' + err.message)
          })
      }
      this.badgeGenerator.generateBadge( )
    } else ishareit(getUriNothumb(data.PostId, ''), imageMarkerFn) // 3dot
    function ishareit(url, imageMarkerFn) {
      //let url = getUriNothumb(data.PostId, '')
      let isVid = false
      if (data.MediaType === 'MP4' || data.MediaType === '3D') { // see below for StreamURL
        url = getUriVideo(data.PostId, '')
        isVid = true
      }
      else if (data.StreamURL) {
        url = data.StreamURL
        isVid = true
      }
      else {
        console.log("ready to call imageMarkerFn " + imageMarkerFn)
        if (imageMarkerFn) imageMarkerFn(url, theShare) // watermarking happens async so have to do theShare later
      }
      // video or no image marker, do theShare now
      if (isVid || !imageMarkerFn) {
        console.log("direct share dont want for marking")
        theShare(url)
      }

      function theShare(url) {
      RNInstagramShare.createPost(
        { url: url },
        (res) => {
          console.tron.display({
            name: `RNInstagramShare`,
            preview: ``,
            value: {
              state: res
            }
          })
        },
      );
    }
  }
  }
  // transfer from tagging share, modify for 3dot share
  // pass in file:// url which we have anyway
  shareMediaWithShareFacebook = (data, imageMarkerFn) => {
    if ( data === 'badge' && this.badgeGenerator ) {
      this.badgeGenerator.delegateFunction = image => {
        console.log('got image data to share to facebook')
        // create a path you want to write to (tmp dir path already has / at end)
        let d = new Date()
        let n = d.getTime()
     
        let path = RNFS.TemporaryDirectoryPath + 'facebookBadge' + n + '.jpg'
        // write the file
        let trimmed = image.replace('data:image/jpeg;base64,','') // no web prefix
        if (false)
        RNFS.writeFile(path, trimmed, 'base64') // this turns b64 string into raw bytes in the file
          .then((success) => {
            console.log('TMP FILE WRITTEN path for facebook = ' + path)
            imageMarkerFn = null // no watermarking
            fshareit('file://' + path)
            console.log("after fshareit() for facebook badge")
          })
          .catch((err) => {
            console.log('error writing tmp file for facebook share ' + err.message)
          })
      }
      this.badgeGenerator.generateBadge( )
    } else fshareit(getUriNothumb(data.PostId, ''), imageMarkerFn) // regular 3dot share, large image

    function fshareit(url) {
      console.log("updated media share fb")
      //let url = getUriNothumb(data.PostId, '') // large image
      let isVideo = false
      if (data.MediaType === 'MP4' || data.MediaType === '3D' || data.StreamURL) {
        console.log("ready to call app installed checker for FB video share 3dot")
        /*
        AppInstalledChecker
        .checkURLScheme('fb') // omit the :// suffix
        .then((isInstalled) => {
            // isInstalled is true if the app is installed or false if not
            console.log("facebook app is installed for 3dot = " + isInstalled)
            if (isInstalled) shareVid()
            else alert("Please install the Facebook app to share Kargoe videos to Facebook.")
        })
        .catch((err) => {
          console.log("error in checking fb app installed for 3dot " + JSON.stringify(err))
        })
        */

        // eventually we call this code in above

        function shareVid( ) {

        let dirs = RNFetchBlob.fs.dirs
        let vidurl = getUriVideo(data.PostId, '')
        RNFetchBlob
        .config({
          // response data will be saved to this path if it has access right.
          path : dirs.DocumentDir + '/facebookShare.mp4'
        })
        .fetch('GET', vidurl, {
          //some headers ..
        })
        .then((res) => {

          // the path should be dirs.DocumentDir + 'path-to-file.anything'
          console.log('mp4 file saved to ' + res.path())

          var localvid = 'file://' + res.path()

          CameraRoll.saveToCameraRoll(
            localvid,
            'video'
          )
          .then(r => {
            console.log("got video asset url for fb 3dot " + JSON.stringify(r))

            shareMediaContent = {
              contentType: 'video',
              // this works w/ local url does not work w/ remote link so patch or do here?
              video: {localUrl: r}, // according to doc, maybe this needs to be special asset library url not ordinary file://
              // try this for remote url (does not work)
              //contentUrl: url
              //localUrl: url
            };

            ShareDialog.canShow(shareMediaContent).then(
              (canShow) => {
                console.log('can show facebook content video 3dot')
                if (canShow)
                  return ShareDialog.show(shareMediaContent);
                else
                  alert('Cannot share video to Facebook at this time.  Make sure you have the Facebook app installed and are logged in to it.');
              }
            ).then(
              (result) => {
                if (result.isCancelled) {
                } else {
                }
              },
              function (error) {
                alert('Facebook video share (3dot video) fail with error: ' + JSON.stringify(error));
              }
            );

          })
          .catch((err) => {
            //Error Loading Images
            console.log("camera roll error saving recent video = " + JSON.stringify(err))
          });

        })

        } // shareVid function

        isVideo = true
      }

      if (!isVideo) { // regular image share

        console.log("ready to call imageMarkerFn " + imageMarkerFn)
        if (imageMarkerFn) imageMarkerFn(url, theShare) // watermarking happens async so have to do theShare later
        else theShare(url) // if no need for watermark just do it now

        function theShare(url) {
        var shareMediaContent = {
          contentType: 'photo',
          photos: [{imageUrl: url}]
        }

        ShareDialog.canShow(shareMediaContent).then(
          (canShow) => {
            console.log('can show facebook content')
            if (canShow) {
              return ShareDialog.show(shareMediaContent);
            }
            else
              alert('Cannot share image to Facebook at this time.  Make sure you have the Facebook app installed and are logged in to it.');
          }
        ).then(
          (result) => {
            if (result.isCancelled) {
            } else {
            }
          },
          function (error) {
            // ugly but informative alert('Facebook media share (3dot still) fail with error: ' + JSON.stringify(error));
            alert(I18n.t("editpost.facebookError1"))
          }
        );
        } // theShare
      }
    } // fshareit
  }
  // not used any more but left for reference in case they want to add link share later
  shareLinkWithShareFacebook = (data) => {
    let url = getUriNothumb(data.PostId, '')

    // later
    if (data.MediaType === 'MP4' || data.MediaType === '3D') // see below for StreamURL
      url = getUriVideo(data.PostId, '')

    if (data.StreamURL)
      url = data.StreamURL

    // to do:  change to direct uplaod not share link (see tagging share)
    const shareLinkContent = {
      contentType: 'link',
      contentUrl: url,
      contentDescription: '',
    };

    ShareDialog.canShow(shareLinkContent).then(
      (canShow) => {
        if (canShow) {
          return ShareDialog.show(shareLinkContent);
        }
      }
    ).then(
      (result) => {
        if (result.isCancelled) {

        } else {

        }
      },
      function (error) {
        alert('Share fail with error: ' + error);
      }
    );
  }
  reportButtonClick = (reason, comment) => {

    let optionReport = {
      0: I18n.t('editpost.sexualContent'),
      100: I18n.t('editpost.violence'),
      200: I18n.t('editpost.hateful'),
      300: I18n.t('editpost.illegalProduct'),
      400: I18n.t('editpost.myRight'),
      500: I18n.t('editpost.dangerous'),
      600: I18n.t('editpost.other')
    }

    const data = {
      reason: getKeyByValue(optionReport, reason),
      comment: comment,
      postId: this.state.dataPost.PostId
    }
    this.props.reportPost(data)
  }

  showPopUp = (reason) => {
    this.popup.showModal(reason)
  }

  onAvatarPress = (userId, username, postId = null, forced = false) => {
    console.log(`onAvatarPress UserId: ${userId}, username: ${username}`)
    if (!forced && this.state.isProfile && this.state.userId == userId) {
      console.log("onAvatarPress scroll to top")
      this.onTitlePress() // just scroll to top
      return
    }

    let firstItem = null
    const data =  this.state.dataProvider._data
    if (this.HomeWall && data && data.length > 0) {
        console.log("onAvatarPress firstItem before nav to profile = " + JSON.stringify(data[0]))
        // firstItem = data[0] // default just use most recent post on main wall
        const foundPost = data.find(post => post.UserId == userId)
        if (foundPost)
          firstItem = foundPost
        console.log(`onAvatarPress firstItem for userid: ${this.authUserId} profile = ` + JSON.stringify(firstItem))
    }
    console.log(`onAvatarPress calling navigation to profilewallv2`)
    this.props.navigation.push('profilewallv2', { userId: userId, username: username, firstItem })
  }

  goToPost = (postId, OtherUserId) => {
    // Given go-ahead to display list from that point on.  ie: read that PostId, get the timestamp, and page from there on
    // want newer posts?  do a refresh.
    /*
        const { navigate } = this.props.navigation
        if (OtherUserId != this.state.authUserId) {
          navigate('postDetail', { postId, userId: OtherUserId })
        } else {
          navigate('profile', { postId, userId: OtherUserId })
        }
    */
  }

  static navigationOptions = {
    header: null
  }

  cancelPost = () => { // now what?
     console.log("cancel post pressed")
     // this should tell objective C camera to cancel video rendering which
     // is happening on background queues
     NotificationManager.postNotification("PostWallBase_cancelPost")
     // it make take a moment for the background process to quit, so do this later
     let zprog = function() {
       if (this.props.createStandardPostProgress) this.props.createStandardPostProgress(0.0) // set progress bar back back to 0 in case we cancelled a vid render
     }
     setTimeout(zprog.bind(this), 2000)
  }
  onNewPost = () => {

    if (Platform.OS == 'web') {
      this.setState({selectMedia: true})
      return
    }

    console.log("on new post this.props.cameraLockout = " + this.props.cameraLockout)
    // if camera has locked side scroll since it is already processing, put up an alert if user press big round Post button
    // somehow, in subsquent video posts, camera scroll is not locked during rendering
    // first video post = ok, this popup shows
    if (!this.state.camIsScroll) {
       console.log("should show cam blocking alert onNewPost button")
       Alert.alert(
            '',
            'Hey, please wait for your last post to finish processing before you get back into the camera.  Thanks!',
            [
              {text: I18n.t("editpost.gotIt"), onPress: () => console.log('got it pressed')},
              {text: I18n.t("editpost.cancel"),  onPress: () => this.cancelPost()}
            ],
            { cancelable: false }
       )
       return
    }
    this.props.changeIndex({ indexChange: 0 }) // otherwise, slide over to camera
  }

  onTitlePress = () => {
    this.scrollModeToIndex(this.state.viewMode, 0, 10)
  }

  scrollToPost = (post) => {
    console.log("should scroll to post, this.listScrollView = " + this.listScrollView)
    const postId = post.PostId
    const posts = this.state.dataProvider._data
    for (let i = 0; i < posts.length; i++)
      if (posts[i]['PostId'] == postId) {
        // console.tron.log(`scrollToPost found ${postId} at ${i}`)
        if (i == 0 && this.listScrollView)
          this.listScrollView.scrollToIndex(0, true)
        else
          this.scrollTo(i)
        return
      }
    console.tron.log(`Error: post ${postId} was not found.`)
  }

  getMyProfileBar = () => {
    return null
  }
  getUserProfileView = () => {
    return null
  }
  getFollowView = () => {
    return null
  }

  getBlockUserView = () => {
    return null
  }

/*
  otherProfileLayout = (event) => {
    const { height } = event.nativeEvent.layout;
    this.state.newBio = height // dont rerender during anim let the next render handle it
  }
*/

  profileLayout = (event) => {
    return // it is a fixed height now
    const { height } = event.nativeEvent.layout;
    console.log(`profileLayout height: ${height}`)
    this.headerRowHeight = height // + 10
  }

  headerRowRender() {
    // console.tron.log(`headerRowRender`)
    const makeTransparentHeader = ([LIST_MODE,GRID_MODE,MOSAIC_MODE].indexOf(this.state.viewMode) >= 0 && !this.props.options.gridShowNavigation)
                                  && typeof this.ISNOTTRANSPARENT === 'undefined' // :)
    if (this.state.isProfile)
      if (this.state.isMyProfile)
        return (
          <View onLayout={this.profileLayout} key={`my_profile_prog_${this.props.updatePostProgress}`}>
            {this.renderHeader(makeTransparentHeader, this.props.updatePostProgress)}
          </View>
        )
      else
        return (
          <View onLayout={this.profileLayout}>
            {this.getUserProfileView()}
            {this.getFollowView()}
            {this.getBlockUserView()}
            <View style={{width: screenWidth, height: 20}}></View>
          </View>
        )
    return null
  }

  yesPerformBlock() {
  }

  onLayoutRecyclerList(e) {
    console.log("on layout recycler list")
    const {width, height} = Dimensions.get('window')
    console.log("done layout recycler list")
    console.log("window size is now " + width + " " + height)
	}
	
	onLongPressAvatar = () => {
		// just remove the reference to this function to remove account switching functionality
		console.log("PostWallBase onLongPressAvatar function")
		// test getGroup
		// this.props.getGroup()

		// test switchToGroupUser
		// const newUserId = this.props.auth.user.UserId == 'AS5758b527028b600001ac1f18a32d6c' ? 's8h2uG09N2CyA7' : 'AS5758b527028b600001ac1f18a32d6c'
		// this.props.switchToGroupUser(newUserId)

		// test addGroupUser
		// const newUserId = 'vAcFeeasaigZE7' // ziggy2020
		// this.props.addGroupUser(newUserId)

		// teset removeGroupUser
		// const newUserId = 'vAcFeeasaigZE7' // ziggy2020
		// this.props.removeGroupUser(newUserId)
		const msDelayAfterLogin = 2000 // make sure that getGroups have time to complete
		const now = new Date().getTime()
		if (this.props.group && (this.props.auth.user.UserId != this.props.auth.group.userId || (this.props.group.fetching === false &&  now > this.props.auth.modified + msDelayAfterLogin)))
			this.props.getGroup()
		this.setState({showSwitchUserView: true})
	}

  switchToGroupUser = (switchToUserId) => {
    const switchFromUserId = this.props.auth.user.UserId
    const switchPostHints = this.state.dataProvider._data.slice(0, 2)
    this.props.navigation.dispatch(NavigationActions.reset({
      index: 0, key: null, actions: [NavigationActions.navigate({ routeName: 'home', params: { switchFromUserId, switchToUserId, switchPostHints, isScroll : true, from: 'PostWallBase' } })]
    }))
    return
		this.setState({switchingUserInProgress: true, showSwitchingUsersScreen: true})
    this.props.switchToGroupUser(userId, switchPostHints)    
  }

  render() {
    //console.log("post wall base render")
    // console.tron.log(`Render ${this.screenRouteName}, HomeWall: ${this.HomeWall}, viewMode: ${this.state.viewMode}, orientation: ${this.orientation}, loveLayoutFromEvent: ${JSON.stringify(this.loveLayoutFromEvent)}`)

    this.musicNotesAnimationView = null

    // https://www.lottiefiles.com/preview
    const heartHeight = 300
		const heartWidth  = heartHeight * 0.4659863946
		const isFullScreenPortrait  = this.HomeWall && this.state.viewMode == FULL_SCREEN_MODE && !this.state.landscape
		const isFullScreenLandscape = this.HomeWall && this.state.viewMode == FULL_SCREEN_MODE && this.state.landscape
		StatusBar.setHidden(isFullScreenLandscape)
		const heartRelativeStandard = {
			position: 'relative',
			display: 'flex',
			top: -heartHeight - 90,
			left: 20,
			backgroundColor: 'transparent'
		}
		const heartRelativeFSPortrait = {
			position: 'absolute',
			bottom: 80,
			left: 40,
			backgroundColor: 'transparent'
		}
		const heartRelativeFSLandscape = {
			position: 'absolute',
			top: 30,
			right: 60,
			backgroundColor: 'transparent'
		}
		const heartRelativeFSStream = {
			position: 'absolute',
			bottom: 90 + (this.keyboardIsShowing ? 310 : 0),
			right: 5,
			backgroundColor: 'transparent'
		}
    let heartRelative = heartRelativeStandard
    if (isFullScreenPortrait)
      heartRelative = heartRelativeFSPortrait
    if (isFullScreenLandscape)
      heartRelative = heartRelativeFSLandscape
    if (this.state.streamFullScreenPost)
      heartRelative = heartRelativeFSStream
    const loveAnimation = true || this.state.animatedLove ? (
      <View style={{
        width: heartWidth,
				height: heartHeight,
				... heartRelative
      }}>
        <LottieView style={{
            width: heartWidth,
						height: heartHeight,
          }}
          ref={(view) => {
            this.loveAnimation = view
          }}
          loop={false}
          source={Images.loveAnimation}
          onAnimationFinish={() => { console.log("heart anim finish inline, shutting off anim"); this.loveAnimation.playing = false; this.setState({animatedLove: false})} }
        />
      </View>
    ) : null

    this.heartsAnimation = loveAnimation // store in class so row renderer can get to it

    const refreshChild = null

    // force drawing when we have new postdetails
    // https://github.com/Flipkart/recyclerlistview/blob/master/src/core/viewrenderer/BaseViewRenderer.tsx
    const extendedStateGrid = {
      ViewMode: GRID_MODE,
    }
    const extendedStateMosaic = {
      ViewMode: MOSAIC_MODE,
    }
    const extendedStateList = {
      ViewMode: LIST_MODE,
      ...this.state
    }
    const screenDimensions = Dimensions.get("window")

    if (Platform.OS == 'web') {
      screenDimensions.width = screenWidth
      screenDimensions.height = screenHeight
    }

    const extendedStateFullScreenPortrait = {
      ViewMode: FULL_SCREEN_MODE,
			isLandscape: false,
			screenWidth: Math.min(screenDimensions.width, screenDimensions.height),
			screenHeight: Math.max(screenDimensions.width, screenDimensions.height)
    }
    const extendedStateFullScreenLandscape = {
      ViewMode: FULL_SCREEN_MODE,
			isLandscape: true,
			screenWidth: Math.max(screenDimensions.width, screenDimensions.height),
			screenHeight: Math.min(screenDimensions.width, screenDimensions.height)
    }
    const styleGrid = {
      flex: 1,
      backgroundColor: '#ffffff',
      display: this.state.viewMode == GRID_MODE || this.state.viewMode == FULL_SCREEN_MODE ? 'flex' : 'none' // cannot scroll to zero when switching mode
    }
    const styleMosaic = {
      flex: 1,
      backgroundColor: '#ffffff',
      display: this.state.viewMode == MOSAIC_MODE ? 'flex' : 'none'
    }
    const styleList = {
      flex: 1,
      backgroundColor: '#ffffff',
      display: this.state.viewMode == LIST_MODE ? 'flex' : 'none'
    }
    const styleVid = {
      flex: 1,
      backgroundColor: '#ffffff',
      display: this.state.viewMode !== VID_MODE ? 'none' : 'flex',
      width : width, height : height - 50
    }
    const styleFullScreen = {
      flex: 1,
      backgroundColor: '#000000',
      display: this.state.viewMode !== FULL_SCREEN_MODE ? 'none' : 'flex',
    }

    const makeTransparentHeader = ([LIST_MODE,GRID_MODE,MOSAIC_MODE].indexOf(this.state.viewMode) >= 0 && !this.props.options.gridShowNavigation)
                                  && typeof this.ISNOTTRANSPARENT === 'undefined' && this.HomeWall // :)
    const header = (this.state.streamFullScreenPost != null) || this.state.viewMode == FULL_SCREEN_MODE ? null : this.renderHeader(makeTransparentHeader, this.props.updatePostProgress)
    const initialRenderIndex = this.state.indexScroll >= 0 ? this.state.indexScroll : 0
    const initialMosaicRenderIndex = this.postIndexToMosaicIndex(initialRenderIndex)
    let recyclerMosaic = (
      <RecyclerListView
        dataProvider={this.state.dataProviderMosaic}
        extendedState={extendedStateMosaic}
        initialRenderIndex={initialMosaicRenderIndex}
        layoutProvider={this._layoutProviderMosaic}
        onEndReached={this._loadMoreData}
        onEndReachedThreshold={2000}
        onScroll={this._onScrollThumbs}
        ref={scrollView => this.mosaicScrollView = scrollView}
        refreshControl={
          <RefreshControl refreshing={this.state.refreshing && this.state.refreshCount > 1} onRefresh={this._onRefresh}>
            {refreshChild}
          </RefreshControl>
        }
        renderAheadOffset={this.props.options.gridRenderAheadOffset} // 250
        rowRenderer={this._rowRendererMosaic}
        showsVerticalScrollIndicator={false}
        style={styleMosaic}
      />
    )

    let recyclerGrid = (
      <RecyclerListView
        dataProvider={this.state.dataProvider}
        extendedState={extendedStateGrid}
        initialRenderIndex={initialRenderIndex}
        layoutProvider={this._layoutProviderGrid}
        onEndReached={this._loadMoreData}
        onEndReachedThreshold={2000}
        onScroll={this._onScrollThumbs}
        onMomentumScrollEnd={this._onScrollThumbs}
        ref={scrollView => this.gridScrollView = scrollView}
        refreshControl={
          <RefreshControl refreshing={this.state.refreshing && this.state.refreshCount > 1} onRefresh={this._onRefresh}>
            {refreshChild}
          </RefreshControl>
        }
        renderAheadOffset={this.props.options.gridRenderAheadOffset} // 250
        rowRenderer={this._rowRendererGrid}
        showsVerticalScrollIndicator={false}
        style={styleGrid}
      />
    )
   
    // canChangeSize needed?
    // onScroll={this._onScroll}
    // onScroll={event => { this._onScroll(event)} }
    // scrollThrottle iOS only
    // onScroll={event => { console.tron.log(`onScroll y: ${event.nativeEvent.contentOffset.y}`) } }
    // onScroll={event => { this.scrollY = event.nativeEvent.contentOffset.y } }
    const listRefresher = typeof this.blockRefresh == 'undefined' || !this.blockRefresh ?
      (
        <RefreshControl refreshing={this.state.refreshing && this.state.refreshCount > 1} onRefresh={this._onRefresh}>
          {refreshChild}
        </RefreshControl>
      ) :
      null
    const topGap = this.HomeWall ? (this.props.transparentPanels ? LIST_TOP_GAP + LIST_HEADER_HEIGHT + 1 : 0) : 0

    // change this.state.recyclerListKey to force re-render when list data hasnt changed
    // but items in the sub data has changed (e.g. avatar)
    // https://stackoverflow.com/questions/38000667/react-native-force-listview-re-render-when-data-has-not-changed
    let recyclerList = (
      <RecyclerListView
        key={this.state.recyclerListKey}
        onLayout={this.onLayoutRecyclerList.bind(this)}
        canChangeSize={true}
        dataProvider={this.state.dataProvider}
        extendedState={extendedStateList}
        initialOffset={topGap}
        // initialRenderIndex={initialRenderIndex}
        layoutProvider={this._layoutProviderList}
        onEndReached={this._loadMoreData}
        onEndReachedThreshold={5000}
        onMomentumScrollEnd={this._onScroll}
        scrollThrottle={5}
        onScroll={this._onScroll}
        onVisibleIndicesChanged={this._indexesChanged}
        ref={scrollView => this.listScrollView = scrollView}
        refreshControl={listRefresher}
        renderAheadOffset={this.props.options.listRenderAheadOffset} // 2000 250
        rowRenderer={this._rowRendererList}
        showsVerticalScrollIndicator={false}
        style={styleList}
        scrollEnabled={this.state.scrollEnabled}
      />
    )
   
    //if (recyclerList) console.log("recyclerList is defined")

		// warning: do not use LayoutManager defined as horizontal when you are in portrait mode as it uses screen dimensions and breaks things
    let recyclerFullScreenPortrait = this.state.landscape ? null : (
      <RecyclerListView
        key={`fs` + this.state.recyclerListKey + 'portrait'}
				keyboardShouldPersistTaps={`handled`}
        dataProvider={this.state.dataProviderFullScreen}
        layoutProvider={this._layoutProviderFullScreenPortrait}
        onEndReached={this._loadMoreData}
        rowRenderer={this._rowRendererFullScreen}
        ref={scrollView => this.fullScreenScrollViewPortrait = scrollView}
        extendedState={extendedStateFullScreenPortrait}
        isHorizontal={this.state.landscape}
        decelerationRate={0}
        renderAheadOffset={/* 1000 */ screenDimensions.height}
        snapToInterval={screenDimensions.height}
        initialRenderIndex={this.fullScreenStartIndex}
				style={styleFullScreen}
        onVisibleIndicesChanged={this._indexesChangedFullScreen}
				onMomentumScrollEnd={this._onScrollFullScreen}
        onScroll={this._onScrollFullScreen}
				scrollEnabled={!(this.state.fullScreenProgressDragging || this.state.fsInnerScrolling)}
				disableScrollViewPanResponder={true || this.state.fsInnerScrolling}
				scrollViewProps={{disableScrollViewPanResponder: true}}
        snapToAlignment={"center"}
			/>
    )
    recyclerFullScreenPortrait = null

		// warning: do not use LayoutManager defined as horizontal when you are in portrait mode as it uses screen dimensions and breaks things
		let recyclerFullScreenLandscape = !this.state.landscape ? null : (
      <RecyclerListView
        key={`fs` + this.state.recyclerListKey + 'landscape'}
				keyboardShouldPersistTaps={`handled`}
        dataProvider={this.state.dataProviderFullScreen}
        layoutProvider={this._layoutProviderFullScreenLandscape}
        onEndReached={this._loadMoreData}
        rowRenderer={this._rowRendererFullScreen}
        ref={scrollView => this.fullScreenScrollViewLandscape = scrollView}
        extendedState={extendedStateFullScreenLandscape}
        isHorizontal={this.state.landscape}
        decelerationRate={0}
        renderAheadOffset={/* 1000 */ screenDimensions.width}
        snapToInterval={screenDimensions.width}
        initialRenderIndex={this.fullScreenStartIndex}
        style={styleFullScreen}
        onVisibleIndicesChanged={this._indexesChangedFullScreen}
				onMomentumScrollEnd={this._onScrollFullScreen}
        onScroll={this._onScrollFullScreen}
				scrollEnabled={!(this.state.fullScreenProgressDragging || this.state.fsInnerScrolling)}
				disableScrollViewPanResponder={true || this.state.fsInnerScrolling}
				scrollViewProps={{disableScrollViewPanResponder: true}}
        snapToAlignment={"center"}
			/>
		)
		recyclerFullScreenLandscape = null

    const postCaptionOverlay = this.state.showPostCaptionIndex != null ?
      (
        <CaptionOverlayComponent
          navigation={this.props.navigation}
          containerStyle={styles.overLay}
          onPress={this.onCloseCaption} post={this.state.currentPostCaption} />
      ) :
      null

    let pv = typeof this.state.showPostView === 'object'? this.state.showPostView: false
      , PostViewOverlay = pv
        ? (<PostViewComponent parent={this} Post={pv} defaultTab={this.state.postViewDefaultTab} navigation={this.props.navigation} auth={this.props.auth} close={( ) => this.setState({ showPostView : false }) }/>)
        : null
    // console.tron.log(`PostWallBase render calling OverLayPostView with user: ` + JSON.stringify(this.props.user)) // user={this.props.user}
    // bump the overlayPostViewKey to force it to re-render

    let newPostPanel = this.props.options.enableCreatePostBtn && this.state.viewMode != FULL_SCREEN_MODE && postCaptionOverlay == null ? (
			<OverLayPostView navigation={this.props.navigation}
				onLongPressAvatar={this.onLongPressAvatar}
        key={this.state.overlayPostViewKey}
        transparent={this.props.transparentPanels}
        auth={this.props.auth}
        unreadMessages={this.props.unreadMessages}
        user={this.props.auth.user}
        onNewPost={this.onNewPost}
        parentState={this.state} />
    ) :
      null

    //console.info("newPostPanel = " + newPostPanel)

    // this may be an iframe so separate window. than main app
    let photoPicker = `<html> 
      <body style="font-family: sans-serif;">
      <br>
      <br>
      <br>
      <br>
      <br>
      <span style="font-size: 30px;">
      Select photo or video to post
      </span>
      <br>
      <input style="padding-top: 50px; left: 60px" type="file" accept="image/jpeg, image/png, video/mp4, video/mov, video/mp4, video/x-m4v, video/*" id="file-input">
      <br>
      <br>
      <div style="text-align: center; display: block;">
        <img id="selectedImage" style="left:10%; width:80%; height:80%; object-fit: contain; background-color: #ffffff;">
        <video id="selectedVideo" autoplay playsinline style="left:10%; width:20%; height:20%; object-fit: contain; background-color: #ffffff;">
      </div>
      <br>
      <br>
      <div style="text-align: center;">
        <span id="nextButton" style="font-size: 30px; visibility: hidden;">
        Next
        </span>
      </div>
      <script>

          // see MessagesWebScreen this func copied from there, we also had to convert blob to data url pulling images from web telegram

          function getData(blobUrl, gotDataUrl) {

            var xhr = new XMLHttpRequest;
            xhr.responseType = 'blob';

            xhr.onload = function() {
              var recoveredBlob = xhr.response;

              var reader = new FileReader();

              reader.onload = function() {
                var blobAsDataUrl = reader.result;
                //console.log("blob as data url = " + blobAsDataUrl) // works!
                //console.log("blob as data url length = " + blobAsDataUrl.length)
                if (gotDataUrl) gotDataUrl(blobAsDataUrl)
              };

              reader.readAsDataURL(recoveredBlob);
            };

            xhr.open('GET', blobUrl);
            xhr.send();
          }

        const fileInput = document.getElementById('file-input');

        fileInput.addEventListener('change', (e) =>  {
        
            var isVideo = false

            console.log('e.target.files = ' + e.target.files)
          
            var oneFile = e.target.files[0] // this is what we will pass back, should we turn into a blob first and pass that back?

            console.log("oneFile = " + oneFile + " type = " + oneFile.type)

            if (oneFile.type.split('/')[0] == 'video') {
              console.log("got video file")
              isVideo = true
            }

            var tmppath = URL.createObjectURL(e.target.files[0])

            console.log("tmppath = " + tmppath)

            let previewImage = document.getElementById("selectedImage")
            let previewVideo = document.getElementById("selectedVideo")

            previewImage.src = tmppath
            previewVideo.src = tmppath

            // if it is a video maybe try to use the blob as-is rather than converting to data url which could be huge

            console.log("blob type " + tmppath.type) // no good

            // the conversion to data url seems to work for video but it will be bad for long videos all in memory at once ugh
            if (!isVideo) {
              previewVideo.style.display = 'none'
              previewImage.style.display = 'block'
              getData(tmppath, (durl) => {
                // this has the requisite web prefix such as: data:image/png;base64,
                // or equiv jpg
                console.log("got data url = " + durl.substring(0,60))
                window.dataUrl = durl // save for when we send
                window.nextButton.style.visibility = 'visible'
              })
            } else {

                previewVideo.style.display = 'block'
                previewImage.style.display = 'none'

                window.dataUrl = '' // keep it a string even if empty to avoid problems in follow-on code
                window.dataBlobUrl = tmppath // this is a blob url 
                window.nextButton.style.visibility = 'visible'

                // try to get also a dataurl for the video 
                getData(tmppath, (durl) => {
                  // this has the requisite web prefix such as: data:image/png;base64,
                  // or equiv jpg
                  console.log("got data url video = " + durl.substring(0,60))
                  if (durl.length > 100000000) {
                    alert("video file size is larger than 100 megabytes, please compress video before uploading")
                    durl = null
                  }
                  window.dataUrlVideo = durl // save for when we send
                })

                const video = document.getElementById("selectedVideo")

                // make poster image from video url

                video.addEventListener('loadeddata', (event) => {
                    //alert('video has loaded data')
                    console.log('video has loaded data');

                    console.log("selected video element = " + video)

                    const canvas = document.createElement("canvas")
                    // scale the canvas accordingly
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    // draw the video at that frame

                    //alert('video width height = ' + video.videoWidth + ' ' + video.videoHeight)

                    canvas.getContext('2d')
                      .drawImage(video, 0, 0, canvas.width, canvas.height)
                    // convert it to a usable data URL
                    const oneFrame = canvas.toDataURL()

                    if (oneFrame) { // now this is working
                      console.log("one frame dataURL = " + oneFrame.substring(0,60))
                      console.log("one frame dataURL length = " + oneFrame.length)
                      window.dataUrlPoster = oneFrame
                    }
                    else {
                      console.log("oneFrame empty")
                      window.dataUrlPoster = ''
                    }

                });

                
            }

          }
        )

        // ---
        // web only utility code, make thumbnail from main image (image post)
        // need to make a cleaner function, may not need all the complexity in sizing
        // --- 
      
        // also use for convert image format to JPG, set retainSize flag to true
        // image type input is Image() e.g. IMG tag, not the data url
        var createThumbnail = function (image, retainSize) {
            var thumbnailMaxWidth = 400
            var thumbnailMaxHeight = (16/9)*thumbnailMaxWidth

            var canvas, ctx, thumbnail, thumbnailScale, thumbnailWidth, thumbnailHeight
            // create an off-screen canvas
            canvas = document.createElement('canvas')
            ctx = canvas.getContext('2d')

            //Calculate the size of the thumbnail, to best fit within max/width (cropspadding)
            thumbnailScale = (image.width / image.height) > (thumbnailMaxWidth / thumbnailMaxHeight) ?
                thumbnailMaxWidth / image.width :
                thumbnailMaxHeight / image.height
            thumbnailWidth = image.width * thumbnailScale
            thumbnailHeight = image.height * thumbnailScale

            console.log("thumbnail target dimensions = " + thumbnailWidth + " " + thumbnailHeight)
            // set its dimension to target size
            canvas.width = thumbnailWidth
            canvas.height = thumbnailHeight

            // draw source image into the off-screen canvas:
            ctx.drawImage(image, 0, 0, thumbnailWidth, thumbnailHeight)

            var thumbDataURL = canvas.toDataURL('image/jpeg', 1) // thumb

            var output = {thumbDataUrl : thumbDataURL}

            if (retainSize) {

              // redo above for full size image but use a different limit

              var thumbnailWidth = image.width
              var thumbnailHeight = image.height

              var origAR = image.height/image.width

              var maxWidth = 1242

              thumbnailWidth = (image.width > 1242) ? maxWidth : image.width

              thumbnailHeight = thumbnailWidth * origAR

              canvas.width = thumbnailWidth
              canvas.height = thumbnailHeight

              ctx.drawImage(image, 0, 0, thumbnailWidth, thumbnailHeight)

              var fullDataURL = canvas.toDataURL('image/jpeg', 0.9) // full

              output['fullDataUrl'] = fullDataURL

            }

            return output

        }

        // ---

        const nextButton = document.getElementById('nextButton')

        window.nextButton = nextButton

        nextButton.addEventListener('click', (e) =>  {
          console.log("next tapped in web photo selector")
          if (window.postMessage && (window.dataUrl || window.dataBlobUrl)) {
            if (window.dataUrl) console.log("sending data url to react-native len = " + window.dataUrl.length)
            if (window.parent) {
              // for pure web not react-native can pass object direct... in theory
              // dataUrl is for image, dataBlobUrl is for video so we dont have to deal with potentially long dataUrl for vid

              // prep for thumbnail by making non-mounted image of orig

              if (window.dataUrl) {
                var originalImage = new Image()
                // nope originalImage.imageRendering = 'high-quality'
                originalImage.src = window.dataUrl
                // once image loads, we can make a thumbnail out of it
                originalImage.addEventListener("load", function () {

                  // if 2nd arg is true, it will use a max size 
                  var res = createThumbnail(originalImage, true)

                  var thumbnailImageDataUrl = res.thumbDataUrl
                  var fullImageDataUrl = res.fullDataUrl

                  // overwrite orig image that we had in whatever format it was w/ new compressed JPEG
                  if (fullImageDataUrl) window.dataUrl = fullImageDataUrl 

                  console.log("XXX got thumbnail data url len = " + thumbnailImageDataUrl.length)
                  window.dataUrlThumb = thumbnailImageDataUrl

                  postToMainApp()
                })
              } else {
                postToMainApp() // dont wait for thumb if we dont have orig 
              }

              function postToMainApp() {
                window.parent.postMessage({'dataUrl' : window.dataUrl, 
                                           'dataUrlThumb' : window.dataUrlThumb,
                                           'dataBlobUrl' : window.dataBlobUrl, 
                                           'dataUrlPoster' : window.dataUrlPoster, 
                                           'dataUrlVideo' : window.dataUrlVideo}, '*')
              }
            }
            else
              console.log("no window.parent, cant post message back to react-native-web")
          }
        })

      </script>
      </body>
    </html>`

    // use bottom row for photo selector test, maybe pull this into another file out of post wall base 
    let webSelectMediaView = 
    (<View style={{position: 'absolute', width : '100%', height: '100%'}}>
      <WebView style={{position: 'absolute', width : '100%', height: '100%', backgroundColor: 'white'}}
          source={{html: photoPicker}} 
          onMessage={(msg) => {
            console.info("on msg: keys = " + Object.keys(msg.nativeEvent) + " isTrusted = " + msg.nativeEvent.isTrusted)
            this.setState({selectMedia: false}) // close the image picker
            console.info("msg data keys = " + Object.keys(msg.nativeEvent.data))

            // prefixed with web stuff : 'data:image/png;base64,' or similar for jpg / video (future) etc
            let base64dataWeb = msg.nativeEvent.data.dataUrl
            let base64dataThumbWeb = msg.nativeEvent.data.dataUrlThumb // thumb version

            // above may (will, to start) be '' in the case of video selected by user to post

            // model after web telegram image to post
            // handle jpeg and png maybe do w/ regex later, not sure which jpg format yet, do both for now
            let base64noHeaderDataUrl = base64dataWeb.replace('data:image/png;base64,', '').replace('data:image/jpg;base64,', '').replace('data:image/jpeg;base64,', '')
            let base64noHeaderDataUrlThumb = base64noHeaderDataUrl // in case of video

            if (base64dataThumbWeb) 
              base64noHeaderDataUrlThumb = base64dataThumbWeb.replace('data:image/png;base64,', '').replace('data:image/jpg;base64,', '').replace('data:image/jpeg;base64,', '')

            let tmpFile = '' // how are we gonna get a file on web, hmm

            let dataBlobUrl = msg.nativeEvent.data.dataBlobUrl // if this is set, it is a video (orig concept, not working yet)
            
            let dataUrlPoster = msg.nativeEvent.data.dataUrlPoster // if it's a video, we should have a poster frame
            let dataUrlPosterNoHeader = null

            if (dataUrlPoster) {
              console.info("dataUrlPoster length = " + dataUrlPoster.length)
              dataUrlPosterNoHeader = dataUrlPoster.replace('data:image/png;base64,', '')
            }

            let dataUrlVideo = msg.nativeEvent.data.dataUrlVideo

            if (dataUrlVideo) console.info("dataUrlVideo length = " + dataUrlVideo.length)

            // model after MessagesWebScreen, image post
            
            if (dataUrlVideo && !dataUrlPoster) {
              alert("caution, have video url but do not have poster url")
            }

            let uriToUse = base64dataWeb ? base64dataWeb : dataUrlPoster

            if (uriToUse) {
              console.info("uri to use len = " + uriToUse.length)
              Image.getSize(uriToUse, 
                (widthImage, heightImage) => {  
                  // working well what do you know 
                  console.info("loc X for web naturalAR = " + (heightImage / widthImage))
                  setUpAndGoEditPost.call(this,(heightImage / widthImage))
                },
                (x) => {console.info("error getting size x = " + x)}
              )
              } else {
               alert("caution, no uriToUse when getting image size, cannot create post, there may be a problem creating video poster image")
              }

            function setUpAndGoEditPost(naturalAR) {

              // snap natural ar to nearest
              let ar = 9/16
              let tol = 0.01

              if (naturalAR > (9/16 + tol)) ar = 3/4
              if (naturalAR > (3/4 + tol)) ar = 1
              if (naturalAR > (1 + tol)) ar = 4/3
              if (naturalAR > (4/3 + tol)) ar = 16/9

              let dataForEditPost = {
                base64 : base64noHeaderDataUrl,
                uri : base64dataWeb, // 'file://' + tmpFile, 
                width : 640, // not true, placeholder
                height : 640 * ar, // * (this.fullImageNaturalAR ? this.fullImageNaturalAR : 4/3)  
                uriThumb : base64dataThumbWeb, // 'file://' + tmpFile, 
                stillImageAsBase64: base64noHeaderDataUrl,
                base64Thumb: base64noHeaderDataUrlThumb
              }
          
              // video post
              if (dataBlobUrl) {
                
                dataForEditPost = {
                  uri : dataUrlPoster, 
                  width : 640, // not true, placeholder
                  height : 640 * ar, // * (this.fullImageNaturalAR ? this.fullImageNaturalAR : 4/3) 
                  // we will use dataBlobUrl as unrendered and above dataUrlVideo for final (trial)
                  // could use dataUrlVideo for unrendered i guess 
                  movieUrlAsNSString: dataBlobUrl, // here is where we will try to put the mystery blob
                  is3DMovie: false,
                  stillImageAsBase64: dataUrlPosterNoHeader
                }
              }

              console.info("ready for edit post")
                this.props.navigation.navigate("editPost", { image: dataForEditPost, 
                  onStartAgain: () => {console.log("null on start again called from post wall base web create post")}, 
                  postType: "create", 
                  ktagCallerInfo : null, 
                  isScroll : false,
                  fromMessages : false, // so we know where to go back, may have to handle specially here too
                  fromWebWall: true
              })

              // (frameFileURL, finalVideoURL, thumbURL, tileURL) 
              // this should only go for video post
              if (dataUrlPoster)
              setTimeout(() => {
              this.props.sendOneFrame(null, dataUrlVideo, dataUrlPoster, dataUrlPoster) 
              }, 500)

            } // set up and call

          }}
      >
      </WebView>
      <Button style={{position: 'absolute', top: 50, left: 10, width: 50, height: 50, backgroundColor: 'white'}}
          onPress={() => this.setState({selectMedia : false})}>
        <Text>Back</Text>
      </Button>
    </View>)

    //if (newPostPanel) console.log("have overlay post view")
    //else console.log("no overlay post view")

    //console.info("this.buttonsFadeInOut for bottom panel = " + this.buttonsFadeInOut)

    //console.info("this.props.transparentPanels = " +  this.props.transparentPanels)

    let newPostView = newPostPanel && this.props.transparentPanels ?
      (
        <Animated.View pointerEvents="box-none" style={{ position: 'absolute', left: 0, bottom: 0, right: 0, opacity: this.buttonsFadeInOut }}>
          {newPostPanel}
        </Animated.View>
      ) :
      (
        <View style={{ position: 'absolute', left: 0, bottom: 0, right: 0, opacity: 1 }}>
          {newPostPanel}
        </View>
      )

    // override normal bottom overlay bar that has the post button with simple image picker for web kargoe

    newPostView = this.state.selectMedia ? webSelectMediaView : newPostPanel

    const profileHoverButtons = this.state.showNewPostBtn && this.state.isMyProfile ? (
      <View pointerEvents="box-none" style={{ position: 'absolute', bottom: 16, right: 14, height: 50, width : 100, flexDirection : 'row' }}>
        <TouchableOpacity activeOpacity={0.8} onPress={() => this.onBadgeShareClick()}
           style={{opacity: 1, width: 50, height: 50}}>
           <Image style={{width: 50, height: 50}} source={Images.joinMeBtn}/>
        </TouchableOpacity>
        <TouchableOpacity activeOpacity={0.8} onPress={() => this.onSettingsClick()}
           style={{opacity: 1, width: 50, height: 50}}>
           <Image style={{width: 50, height: 50}} source={Images.settingsBtn}/>
        </TouchableOpacity>
      </View>
    ) :
    null

    const modalLargeAvatar = (

      <Modal
          animationType="slide"
          transparent={true}
          visible={this.state.modalLargeAvatarOn}>
          <TouchableOpacity
            onPress={() => {
              this.setState({modalLargeAvatarOn : false})
            }}
            style={{width: '100%', height: '100%', marginTop: 0, backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    flexDirection: 'row', justifyContent: 'center'}}
          >
              <Image style={{top:200, width:300, height:300}} source={{uri: getAvatar(this.state.userId || '')}}/>
          </TouchableOpacity>
        </Modal>
    )

    const modalVideo = null
    const haveProgressBar = this.props.updatePostProgress > 0 && this.props.updatePostProgress < 1
    let progressBarView = null
    if (haveProgressBar) {
      console.log(`PostWallBase progress: ${this.props.updatePostProgress}`)
      if (this.state.isProfile && this.state.isMyProfile)
        progressBarView = (
          <View style={{
            height: 4,
            width: screenWidth,
          }}>
            <ProgressBarAnimated
              barAnimationDuration={50}
              backgroundColor={Fonts.style.color.progress}
              height={4}
              borderRadius={0}
              width={screenWidth}
              maxValue={100}
              value={this.props.updatePostProgress * 100}
              borderColor='transparent'
              borderWidth={0}
            />
          </View>
        )
      else
        progressBarView = (
          <View style={{
            position: 'absolute',
            top: customMainNavBarStylesContent.height + customMainNavBarStylesContent.borderBottomWidth + customMainNavBarStylesStatusBar.height,
            height: 4,
            width: screenWidth,
          }}>
            <ProgressBarAnimated
              barAnimationDuration={50}
              backgroundColor={Fonts.style.color.progress}
              height={4}
              borderRadius={0}
              width={screenWidth}
              maxValue={100}
              value={this.props.updatePostProgress * 100}
              borderColor='transparent'
              borderWidth={0}
            />
          </View>
        )
    }

    const postLink = this.state.isProfile && this.state.isMyProfile && haveProgressBar ? (
      <View>
        {this.postLink()}
        <ProgressBarAnimated
          barAnimationDuration={50}
          backgroundColor={Fonts.style.color.progress}
          height={4}
          borderRadius={0}
          width={screenWidth}
          maxValue={100}
          value={this.props.updatePostProgress * 100}
          borderColor='transparent'
          borderWidth={0}
        />
      </View>
    ) : this.postLink()

    const actionSheetAndPopups = (
      <View>
        <ActionSheetComponent
          options={this.state.actionOptions}
          ref={(actionSheet) => this.actionSheet = actionSheet}
          onPressIndex={this.actionSheetPress}
        />
        <PopUpReportComponent
          onReport={this.reportButtonClick}
          ref={(popup) => this.popup = popup}
        />
      </View>
    )

    const onOffLine = (
      <View style={{ display : (this.state.networkOffline? 'flex': 'none'), width : width, height : 100, zIndex : 50
                    , backgroundColor : '#f30', position : 'absolute', top : 60, left : 0
                    , flexDirection : 'row', alignItems : 'center', justifyContent : 'center' }}>
        <Text style={{ color : 'white', fontSize : 18, flex : 0.7, textAlign : 'right' }}>No Internet Connection</Text>
        <TouchableOpacity style={{ flex : 0.3, margin : 25, borderRadius : 5, borderColor : 'white', borderWidth : 1 }}
          activeOpacity={0.5} onPress={ this._loadMoreData }>
          <Text style={{ fontSize : 18, color : 'white', textAlign : 'center', padding : 10 }}>Try Again</Text>
        </TouchableOpacity>
      </View>
    )

    // this.blockQueryDialog.showModal()
    const blockQueryDialog = (
      <AlertMessage
        ref={(alert) => this.alert = alert}
        title={I18n.t('followersProfile.blockUser')}
        yesModal={this.yesPerformBlock}
      />)

    const badges = (
      <BadgeGenerator User={this.props.user} ref={ref=>this.badgeGenerator=ref} onImage={this.onBadgeImage}/>
    )

    const donateView = null // (<DonatePayPalComponent />) FUTURE

    const myProfileBar = this.getMyProfileBar()

    if (this.state.calledAPI && this.state.havePosts === false) {
      recyclerGrid = <Text style={{paddingTop: 100, fontSize: 35, color: '#dddddd', width: width, textAlign: 'center'}}>No posts, yet. ;)</Text>
      recyclerMosaic = null
      recyclerList = null
    }

/*    
    const newBio = this.state.newBio ? this.state.newBio + 80 : 0
    const heightBioProfile = this.state.heightBio ? this.state.heightBio + 120 : 200
    const contentOffset = this.otherProfileAnimatedValue.interpolate(
      isIPhoneX() ? {
        inputRange: [0, newBio + 20],
        outputRange: [newBio + 20, 84],
        extrapolate: 'clamp',

      } : {
          inputRange: [0, newBio],
          outputRange: [newBio, 64],
          extrapolate: 'clamp',
        }
    );

    const offsetY = this.scrollYAnimatedValue.interpolate(
      {
        inputRange: [0, 500 ],
        outputRange: [0, -500],
        extrapolate: 'clamp',
        // darren doesnt like this, it make the top user header info snap up too fast
        //easing: (t) => {let x = Math.pow(t, 0.3); return x}
      });
*/

    const alertMessageView = (
      <MoneyFaceMessage visible={this.state.alertMessage.length > 0} onClose={this.clearAlertMessage}>
        <Text style={{fontSize : 16, fontFamily : Fonts.style.font.regular, textAlign : 'center'}}>
          {this.state.alertMessage}
        </Text>
      </MoneyFaceMessage>
    )
    const errorMessageView = (
      <ThumbsDownMessage visible={this.state.errorMessage.length > 0} onClose={this.clearErrorMessage}>
        <Text style={{fontSize : 16, fontFamily : Fonts.style.font.regular, textAlign : 'center'}}>
          {this.state.errorMessage}
        </Text>
      </ThumbsDownMessage>
    )

    // RN 0.60 deal with RecycleListView layout issue, cannot have width or height zero
    const viewMode = this.state.viewMode
    if (!this.HomeWall || viewMode != FULL_SCREEN_MODE || this.state.landscape)
			recyclerFullScreenPortrait = (<View style={{ minHeight: 1, minWidth: 1, display: 'none' }}>{recyclerFullScreenPortrait}</View>)
		if (!this.HomeWall || viewMode != FULL_SCREEN_MODE || !this.state.landscape)
			recyclerFullScreenLandscape = (<View style={{ minHeight: 1, minWidth: 1, display: 'none' }}>{recyclerFullScreenLandscape}</View>)

    if (viewMode != GRID_MODE)
      recyclerGrid = (<View style={{ minHeight: 1, minWidth: 1, display: 'none' }}>{recyclerGrid}</View>)
    if (viewMode != MOSAIC_MODE)
      recyclerMosaic = (<View style={{ minHeight: 1, minWidth: 1, display: 'none' }}>{recyclerMosaic}</View>)
    if (viewMode != LIST_MODE) {
        recyclerList = (<View style={{ minHeight: 1, minWidth: 1, display: 'none' }}>{recyclerList}</View>)
      this.currentlyPlayingVideo = null // get rid of remnant video player ref
    }

    // test 
    let dataAll = this.state.dataProvider._data
    //console.log("dataAll.length = " + dataAll.length)

    //console.log("setting up full screen modal this.state.fullScreenImageAR = " + this.state.fullScreenImageAR)
		let fullScreenModal = this.state.fullScreenURI ? (<Image uri={this.state.fullScreenURI} prelimZoomScale={this.state.prelimZoomScale} ar={this.state.fullScreenImageAR} modal={true} onClose={() => this.setState({fullScreenURI : null})} />) : null
		
		const avatarSize = Math.ceil((screenWidth / 5 + 20) * .45) // from OverlayPostView
		const logoutViewHeight = Math.ceil(avatarSize/2.5)
		const switchRowHeight = avatarSize + 20 // 65
		const switchPadLeft = Math.ceil(avatarSize / 3.5) // 8
		const switchRowCount = this.props.auth.group && this.props.auth.group.list ? 1 + this.props.auth.group.list.length : 1
		const switchScrollHeight = Math.ceil(Math.min(6.45, switchRowCount) * switchRowHeight)
		const shadowTextStyle = {
			shadowOffset: { width: 0, height: 0 }, shadowRadius : 4, shadowOpacity: 1, shadowColor: 'black'
		}
		let switchUserView = null
    const switchingViewAlways = (
      <TouchableOpacity key={`switching_user`} activeOpacity={0.8}
        onPress={() => {
          this.switchPostHints = []
          this.setState({showSwitchingUsersScreen: false, showSwitchUserView: false}) 
        }}
        style={{alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.70)'}}>
        <Text style={{backgroundColor: 'rgba(255,255,255,0.75)', padding: 10, borderRadius: 15, color: 'black', fontSize: 15}}>{`Switching...`}</Text>
      </TouchableOpacity>
    )
		const switchingView = this.state.showSwitchingUsersScreen ? switchingViewAlways : null

		// if (!this.state.switchingUserInProgress && !switchingView && this.state.showSwitchUserView)
		if (!switchingView && this.state.showSwitchUserView)
			switchUserView = (
				<TouchableOpacity key={`switch_user`} activeOpacity={0.8}
					onPress={() => this.setState({showSwitchUserView: false})}
					style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)'}}>
					<View style={{position: 'absolute', bottom: 80, left: 0, width: '100%', height: switchScrollHeight}}>
						<ScrollView style={{flexDirection: 'column', width: 130, height: switchScrollHeight}}>
							<TouchableOpacity key={`switch_user_scroll`} activeOpacity={1}>
								<View style={{height: switchRowHeight, width: switchRowHeight, paddingLeft: switchPadLeft, paddingTop: 4}}>
									<TouchableOpacity key={`add_profile_view`} activeOpacity={0.8}
										onPress={() => {this.setState({showAddProfileView: true})}}
										style={{width: avatarSize+2, height: avatarSize+2, backgroundColor: 'white', borderRadius: avatarSize/2+1, justifyContent: 'center', alignItems: 'center'}}
										>
										<Text style={{fontSize: 11, lineHeight: 13, color: 'black'}}>{`Add`}</Text>
										<Text style={{fontSize: 11, lineHeight: 13, color: 'black'}}>{`Profile`}</Text>
									</TouchableOpacity>
								</View>
								{this.props.auth.group && this.props.auth.group.list && this.props.auth.group.list.map(user => (
									<View key={`switch-user-${user['UserId']}`} style={{height: switchRowHeight, justifyContent: 'center'}}>
										<View style={{height: avatarSize, alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'row'}}>
											<TouchableOpacity key={`logout-user-${user['UserId']}`} activeOpacity={0.8}
												onPress={() => this.props.removeGroupUser(user['UserId'])}
												style={{backgroundColor: 'white', left: switchPadLeft + avatarSize*.9, paddingLeft: 10, height: logoutViewHeight, width: 50, borderTopRightRadius: 4, borderBottomRightRadius: 4}}
												>
												<Text style={{color: 'black', fontSize: 10, lineHeight: logoutViewHeight}}>{`Logout`}</Text>
											</TouchableOpacity>
											<AvatarComponent key={`switch-av-${user['UserId']}`} style={{position: 'absolute', left: switchPadLeft, borderWidth : 1, borderColor: 'white'}} userId={user['UserId']} size={avatarSize} onPress={() => this.switchToGroupUser(user['UserId'])}/>
										</View>
										<View style={{width: avatarSize + switchPadLeft * 2, alignItems: 'center'}}>
											<Text style={[{color: 'white', fontSize: 8}, shadowTextStyle]} numberOfLines={1} ellipsizeMode='tail'>{user['Username']}</Text>
										</View>
									</View>
								))}
							</TouchableOpacity>
						</ScrollView>
					</View>
				</TouchableOpacity>
			)
		let addProfileView = null
		if (this.state.showAddProfileView)
			addProfileView = (
				<TouchableOpacity key={`add_profile`} activeOpacity={0.8}
					onPress={() => this.setState({showAddProfileView: false})}
					style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)'}}>
						<View style={{justifyContent: 'space-around', alignItems: 'center', paddingTop: 30, paddingBottom: 40, position: 'absolute', bottom: 0, left: 0, right: 0, height: 200 ,borderTopLeftRadius: 25, borderTopRightRadius: 25, backgroundColor: 'white'}}>
							<Button style = {{}} transparent onPress={() => this.props.addProfile('login')}>
								<Text style={{color: 'black', fontSize: 22}}>{`ADD EXISTING ACCOUNT`}</Text>
							</Button>
							<Button style = {{}} transparent onPress={() => this.props.addProfile('signup')}>
								<Text style={{color: 'black', fontSize: 22}}>{`CREATE NEW ACCOUNT`}</Text>
							</Button>
						</View>
				</TouchableOpacity>
			)

    if (this.switchPostHints) {
      if (this.switchNeedsCall) {
        this.props.switchToGroupUser(this.switchToUserId)    
        this.switchNeedsCall = false
      }
      return (
        <View style={{flex: 1, backgroundColor: 'white'}}>
          {header}
          <View style={{width: '100%', height: 2000, justifyContent: 'flex-start', overflow: 'hidden', backgroundColor: 'white'}}>
            <View style={{height: 10, backgroundColor: 'white', overflow: 'hidden'}}>
              {recyclerGrid}
              {recyclerMosaic}
              {recyclerList}
            </View>
            <View style={{position: 'absolute', top: 0, left: 0}}>
              {this.switchPostHints.map((post, index) => {
                return this._rowRendererList('POST', post, index)})}
            </View>
          </View>
          {newPostView}
          {switchingViewAlways}
        </View>
      )
    }

    let streamFullScreenView = null
    if (this.state.streamFullScreenPost)
      streamFullScreenView = this.renderStreamFullScreen()

    console.log('ready to render recycler list grid mosaic ' + recyclerList + ' ' + recyclerGrid + ' ' + recyclerMosaic)

    // temp for web always show the bottom panel with big Post button since we dont have other screens operational
    // yet and are always routing back to home wall
    return (
      // PostWall screen
      this.state.isProfile == false ?
        <BaseScreen fullLoading={this.state.auxLoading}>
          {fullScreenModal}
          {!makeTransparentHeader && header}
          {onOffLine}
          {modalVideo}
          {recyclerGrid}
          {recyclerMosaic}
          {recyclerList}
          {recyclerFullScreenPortrait}
          {recyclerFullScreenLandscape}
          {makeTransparentHeader && header}
          {progressBarView}
          {(this.state.isPostWall == "home" || Platform.OS == 'web') && newPostView}
          {postCaptionOverlay}
          {PostViewOverlay}
          {donateView}
          {actionSheetAndPopups}
          {blockQueryDialog}
          {alertMessageView}
          {errorMessageView}
					{switchUserView}
					{addProfileView}
					{switchingView}
          {streamFullScreenView}
        </BaseScreen> :
        //  my profile
        this.state.isMyProfile == true ?
          <BaseScreen fullLoading={this.state.auxLoading}>
            {fullScreenModal}
            {myProfileBar}
            {postLink}
            <ScrollView scrollEnabled={false} keyboardDismissMode='on-drag' ref={(mainScroll) => this.mainScroll = mainScroll} style={{flex: 1}} contentContainerStyle={{ flex: 1 }}>
              {modalVideo}
              {recyclerGrid}
              {recyclerMosaic}
              {recyclerList}
              {recyclerFullScreenPortrait}
							{recyclerFullScreenLandscape}
							</ScrollView>
            {profileHoverButtons}
            {postCaptionOverlay}
            {PostViewOverlay}
            {donateView}
            {actionSheetAndPopups}
            {badges}
            {blockQueryDialog}
            {streamFullScreenView}
          </BaseScreen> :
          // other profile
          <BaseScreen fullLoading={this.state.auxLoading}>
            {fullScreenModal}
            {myProfileBar}
            <ScrollView scrollEnabled={false} keyboardDismissMode='on-drag' ref={(mainScroll) => this.mainScroll = mainScroll} style={{flex: 1}} contentContainerStyle={{ flex: 1 }}>
              {modalVideo}
              {recyclerGrid}
              {recyclerMosaic}
              {recyclerList}
							{recyclerFullScreenPortrait}
							{recyclerFullScreenLandscape}
            </ScrollView>
            {profileHoverButtons}
            {postCaptionOverlay}
            {PostViewOverlay}
            {donateView}
            {actionSheetAndPopups}
            {blockQueryDialog}
            {modalLargeAvatar}
            {streamFullScreenView}
          </BaseScreen>
    )
  }

  getStateSubset(props, state) {
    const songId = props.musicSettings.songDetails ? props.musicSettings.songDetails.id : 0
    const result = JSON.stringify([
      songId,
      state.calledAPI,
      state.showNewPostBtn,
      state.animatedLove,
      state.viewMode,
      state.landscape,
      state.indexScroll,
      state.refreshing,
      state.refreshCount,
      state.scrollEnabled,
      state.fullScreenProgressDragging,
      state.fullScreenVideoProgress,
      state.fullScreenDetailMode,
      state.fullScreenPaused,
      state.newComment.length,
      state.fsInnerScrolling,
      state.actionOptions.length,
      state.networkOffline,
      state.havePosts,
      state.alertMessage.length,
      state.fullScreenURI,
      state.showSwitchUserView,
      state.showSwitchingUsersScreen,
      state.switchingUserInProgress,
      state.showAddProfileView,
      state.dataProvider.length,
      state.dataProviderMosaic.length,
      state.dataProviderFullScreen.length,
      state.postdetailsIntegrated,
      state.currVideoPlayIndex,
      state.showKargoeTagsPostId,
      state.hideKargoeDotsPostId,
      props.musicSettings.muted,
      props.updatePostProgress,
      props.nav.routes.length,
      Dimensions.get("window"),
    ])
    return result
  }

  shouldComponentUpdate(nextProps, nextState) {

    // for debugging only to see what prop or state is causing the render

    if (false) {
      Object.entries(this.props).forEach(([key, val]) =>
        nextProps[key] !== val && console.log(`SHOULD Prop '${key}' changed`)
      );

      if (this.state) {
        Object.entries(this.state).forEach(([key, val]) =>
          nextState[key] !== val && console.log(`SHOULD State '${key}' changed to '${val}'`)
        );
      }
    }

    return true
    const newSubState   = this.getStateSubset(nextProps, nextState)
    const shouldUpdate  = !this.renderSubState || this.renderSubState != newSubState
    this.renderSubState = newSubState
    console.log(`PostWallBase shouldComponentUpdate ` + (shouldUpdate ? '*** true ***' : 'false'))
    return shouldUpdate
  }

/*  
  render_UNUSED() {
    const now = Date.now()
    if (!this.preRender) {
      this.renderSubState = this.getStateSubset(this.props, this.state)
      this.preRender = this.renderFull()
    }
    else {
      const newSubState = this.getStateSubset(this.props, this.state)
      if (newSubState != this.renderSubState) {
        this.renderSubState = newSubState
        this.preRender = this.renderFull()
        const elapsed = Date.now() - now
        console.log(`render substate elapsed ${elapsed}ms changed: ${newSubState}`)
      }
      else
        console.log(`render substate 0ms no change`)
    } 
    return this.preRender
  }
*/  
} // PostWallBase